export default {
    cancel: {
        NL: 'Annuleren',
        EN: 'Cancel',
        DE: 'Abbrechen',
        FR: 'Annuler',
        ES: 'Cancelar',
        IT: 'Annulla'
    },
    save: {
        NL: 'Opslaan',
        EN: 'Save',
        DE: 'Speichern',
        FR: 'Enregistrer',
        ES: 'Guardar',
        IT: 'Salva'
    },
    warning: {
        NL: 'Waarschuwing',
        EN: 'Warning',
        DE: 'Warnung',
        FR: 'Avertissement',
        ES: 'Advertencia',
        IT: 'Avviso'
    },
    confirm: {
        NL: 'Bevestigen',
        EN: 'Confirm',
        DE: 'Bestätigen',
        FR: 'Confirmer',
        ES: 'Confirmar',
        IT: 'Conferma'
    },
    delete: {
        NL: 'Verwijderen',
        EN: 'Delete',
        DE: 'Löschen',
        FR: 'Supprimer',
        ES: 'Eliminar',
        IT: 'Elimina'
    },
    complete: {
        NL: 'Afronden',
        EN: 'Complete',
        DE: 'Vollständig',
        FR: 'Compléter',
        ES: 'Completar',
        IT: 'Completa'
    },
    reopen: {
        NL: 'Heropenen',
        EN: 'Reopen',
        DE: 'Erneut öffnen',
        FR: 'Réouvrir',
        ES: 'Reabrir',
        IT: 'Riapri'
    },
    enable: {
        NL: 'Activeren',
        EN: 'Enable',
        DE: 'Aktivieren',
        FR: 'Activer',
        ES: 'Habilitar',
        IT: 'Abilitare'
    },
    disable: {
        NL: 'Deactiveren',
        EN: 'Disable',
        DE: 'Deaktivieren',
        FR: 'Désactiver',
        ES: 'Deshabilitar',
        IT: 'Disabilitare'
    },
    enabled: {
        NL: 'Actief',
        EN: 'Enabled',
        DE: 'Aktiviert',
        FR: 'Activé',
        ES: 'Habilitado',
        IT: 'Abilitato'
    },
    disabled: {
        NL: 'Inactief',
        EN: 'Disabled',
        DE: 'Deaktiviert',
        FR: 'Désactivé',
        ES: 'Deshabilitado',
        IT: 'Disabilitato'
    },
    allowed: {
        NL: 'Toestaan',
        EN: 'Allow',
        DE: 'Erlauben',
        FR: 'Autoriser',
        ES: 'Permitir',
        IT: 'Consentire'
    },
    allowedWithWarning: {
        NL: 'Toestaan met waarschuwing',
        EN: 'Allow with warning',
        DE: 'Erlauben mit Warnung',
        FR: 'Autoriser avec avertissement',
        ES: 'Permitir con advertencia',
        IT: 'Consentire con avviso'
    },
    notAllowed: {
        NL: 'Niet toestaan',
        EN: 'Not allowed',
        DE: 'Nicht erlaubt',
        FR: 'Non autorisé',
        ES: 'No permitido',
        IT: 'Non consentito'
    },
    allowedWithMargin: {
        NL: 'Toestaan binnen marge',
        EN: 'Allow within margin',
        DE: 'Erlauben innerhalb der Marge',
        FR: 'Autoriser dans la marge',
        ES: 'Permitir dentro del margen',
        IT: 'Consentire entro il margine'
    },
    startShiftBeforeStartTime: {
        NL: 'Eerder starten dan geplande starttijd',
        EN: 'Start earlier than planned start time',
        DE: 'Früher starten als die geplante Startzeit',
        FR: 'Démarrer plus tôt que l\'heure de début prévue',
        ES: 'Empezar antes de la hora de inicio prevista',
        IT: 'Iniziare prima dell\'orario di inizio previsto'
    },
    startShiftBeforeStartTimeMargin: {
        NL: 'Marge voor eerder starten',
        EN: 'Margin for starting earlier',
        DE: 'Marge für früheren Start',
        FR: 'Marge pour un démarrage anticipé',
        ES: 'Margen para empezar antes',
        IT: 'Margine per iniziare prima'
    },
    startShiftBeforeStartTimeMarginInfo: {
        NL: 'Aantal minuten voor de geplande starttijd dat de dienst gestart mag worden.',
        EN: 'Number of minutes before the planned start time that the shift may be started.',
        DE: 'Anzahl Minuten vor der geplanten Startzeit, in denen die Schicht gestartet werden darf.',
        FR: 'Nombre de minutes avant l\'heure de début prévue pendant lesquelles le service peut être démarré.',
        ES: 'Número de minutos antes de la hora de inicio prevista en los que se puede iniciar el turno.',
        IT: 'Numero di minuti prima dell\'orario di inizio previsto entro cui è possibile avviare il turno.'
    },
    minutes: {
        NL: 'minuten',
        EN: 'minutes',
        DE: 'Minuten',
        FR: 'minutes',
        ES: 'minutos',
        IT: 'minuti'
    },
    deliveryRadiusWarning: {
        NL: 'Afwijking bezorgadres',
        EN: 'Delivery address deviation',
        DE: 'Abweichung Lieferadresse',
        FR: 'Écart d\'adresse de livraison',
        ES: 'Desviación de la dirección de entrega',
        IT: 'Deviazione dell\'indirizzo di consegna'
    },
    send: {
        NL: 'Verzenden',
        EN: 'Send',
        DE: 'Senden',
        FR: 'Envoyer',
        ES: 'Enviar',
        IT: 'Invia'
    },
    condition: {
        NL: 'Voorwaarde',
        EN: 'Condition',
        DE: 'Bedingung',
        FR: 'Condition',
        ES: 'Condición',
        IT: 'Condizione'
    },
    carrier: {
        NL: 'Vervoerder',
        EN: 'Carrier',
        DE: 'Spediteur',
        FR: 'Transporteur',
        ES: 'Transportista',
        IT: 'Vettore'
    },
    shippingRuleSet: {
        NL: 'Verzendregelset',
        EN: 'Shipping rule set',
        DE: 'Versandregelset',
        FR: 'Ensemble de règles d\'expédition',
        ES: 'Conjunto de reglas de envío',
        IT: 'Set di regole di spedizione'
    },
    shippingrule: {
        NL: 'Verzendregel',
        EN: 'Shipping rule',
        DE: 'Versandregel',
        FR: 'Règle d\'expédition',
        ES: 'Regla de envío',
        IT: 'Regola di spedizione'
    },
    property: {
        NL: 'Eigenschap',
        EN: 'Property',
        DE: 'Eigenschaft',
        FR: 'Propriété',
        ES: 'Propiedad',
        IT: 'Proprietà'
    },
    operator: {
        NL: 'Vergelijking',
        EN: 'Operator',
        DE: 'Operator',
        FR: 'Opérateur',
        ES: 'Operador',
        IT: 'Operatore'
    },
    value: {
        NL: 'Waarde',
        EN: 'Value',
        DE: 'Wert',
        FR: 'Valeur',
        ES: 'Valor',
        IT: 'Valore'
    },
    values: {
        NL: 'Waarden',
        EN: 'Values',
        DE: 'Werte',
        FR: 'Valeurs',
        ES: 'Valores',
        IT: 'Valori'
    },
    lt: {
        NL: 'Kleiner dan',
        EN: 'Less than',
        DE: 'Weniger als',
        FR: 'Moins que',
        ES: 'Menos que',
        IT: 'Meno di'
    },
    lte: {
        NL: 'Kleiner of gelijk aan',
        EN: 'Less than or equal to',
        DE: 'Weniger als oder gleich',
        FR: 'Inférieur ou égal à',
        ES: 'Menor o igual que',
        IT: 'Minore o uguale a'
    },
    gt: {
        NL: 'Groter dan',
        EN: 'Greater than',
        DE: 'Größer als',
        FR: 'Plus grand que',
        ES: 'Mayor que',
        IT: 'Maggiore di'
    },
    gte: {
        NL: 'Groter of gelijk aan',
        EN: 'Greater than or equal to',
        DE: 'Größer als oder gleich',
        FR: 'Supérieur ou égal à',
        ES: 'Mayor o igual que',
        IT: 'Maggiore o uguale a'
    },
    eq: {
        NL: 'Gelijk aan',
        EN: 'Equal to',
        DE: 'Gleich',
        FR: 'Égal à',
        ES: 'Igual a',
        IT: 'Uguale a'
    },
    neq: {
        NL: 'Niet gelijk aan',
        EN: 'Not equal to',
        DE: 'Nicht gleich',
        FR: 'Pas égal à',
        ES: 'No igual a',
        IT: 'Non uguale a'
    },
    in: {
        NL: 'In',
        EN: 'In',
        DE: 'In',
        FR: 'Dans',
        ES: 'En',
        IT: 'In'
    },
    nin: {
        NL: 'Niet in',
        EN: 'Not in',
        DE: 'Nicht in',
        FR: 'Pas dans',
        ES: 'No en',
        IT: 'Non in'
    },
    between: {
        NL: 'Tussen',
        EN: 'Between',
        DE: 'Zwischen',
        FR: 'Entre',
        ES: 'Entre',
        IT: 'Tra'
    },
    notBetween: {
        NL: 'Niet tussen',
        EN: 'Not between',
        DE: 'Nicht zwischen',
        FR: 'Pas entre',
        ES: 'No entre',
        IT: 'Non tra'
    },
    contains: {
        NL: 'Bevat',
        EN: 'Contains',
        DE: 'Enthält',
        FR: 'Contient',
        ES: 'Contiene',
        IT: 'Contiene'
    },
    notContains: {
        NL: 'Bevat niet',
        EN: 'Does not contain',
        DE: 'Enthält nicht',
        FR: 'Ne contient pas',
        ES: 'No contiene',
        IT: 'Non contiene'
    },
    errors: {
        nameRequired: {
            NL: 'Naam is verplicht',
            EN: 'Name is required',
            DE: 'Name ist erforderlich',
            FR: 'Le nom est requis',
            ES: 'El nombre es obligatorio',
            IT: 'Il nome è obbligatorio'
        }
    },
    sender: {
        NL: 'Verzender',
        EN: 'Sender',
        DE: 'Absender',
        FR: 'Expéditeur',
        ES: 'Remitente',
        IT: 'Mittente'
    },
    receiver: {
        NL: 'Ontvanger',
        EN: 'Receiver',
        DE: 'Empfänger',
        FR: 'Destinataire',
        ES: 'Receptor',
        IT: 'Destinatario'
    },
    reference: {
        NL: 'Referentie',
        EN: 'Reference',
        DE: 'Referenz',
        FR: 'Référence',
        ES: 'Referencia',
        IT: 'Riferimento'
    },
    followShipment: {
        NL: 'Volg je zending',
        EN: 'Follow your shipment',
        DE: 'Verfolgen Sie Ihre Sendung',
        FR: 'Suivez votre envoi',
        ES: 'Sigue tu envío',
        IT: 'Segui la tua spedizione'
    },
    pickupAddress: {
        NL: 'Afhaaladres',
        EN: 'Pickup address',
        DE: 'Abholadresse',
        FR: 'Adresse de ramassage',
        ES: 'Dirección de recogida',
        IT: 'Indirizzo di ritiro'
    },
    deliveryAddress: {
        NL: 'Bezorgadres',
        EN: 'Delivery address',
        DE: 'Lieferadresse',
        FR: 'Adresse de livraison',
        ES: 'Dirección de entrega',
        IT: 'Indirizzo di consegna'
    },
    returnAddress: {
        NL: 'Retouradres',
        EN: 'Return address',
        DE: 'Rücksendeadresse',
        FR: 'Adresse de retour',
        ES: 'Dirección de devolución',
        IT: 'Indirizzo di ritorno'
    },
    pickupPoint: {
        NL: 'Afhaalpunt',
        EN: 'Pickup point',
        DE: 'Abholpunkt',
        FR: 'Point de ramassage',
        ES: 'Punto de recogida',
        IT: 'Punto di ritiro'
    },
    customerSupport: {
        NL: 'Meldingen',
        EN: 'Customer support',
        DE: 'Kundensupport',
        FR: 'Support client',
        ES: 'Soporte al cliente',
        IT: 'Supporto clienti'
    },
    customerSupportDescription: {
        NL: 'Met deze functie kunnen klanten vanuit het Zending Info scherm een melding maken over de zending naar jullie. Kies het emailadres waar je de melding wil ontvangen, en bepaal zelf welke redenen voor een melding de klant kan kiezen. De melding en een link naar de zending worden naar het ingevulde emailadres gestuurd.',
        EN: 'From the Shipment Info screen, a message can be created about the shipment. The customer selects a reason and provides a description. The message and a link to the shipment are sent to the entered email address.',
        DE: 'Über den Versandinformationsbildschirm kann eine Nachricht zur Sendung erstellt werden. Der Kunde wählt einen Grund aus und gibt eine Beschreibung an. Die Nachricht und ein Link zur Sendung werden an die eingegebene E-Mail-Adresse gesendet.',
        FR: 'Depuis l’écran d’informations sur l’expédition, un message peut être créé concernant l’expédition. Le client sélectionne une raison et fournit une description. Le message et un lien vers l’expédition sont envoyés à l’adresse e-mail saisie.',
        ES: 'Desde la pantalla de información del envío, se puede crear un mensaje sobre el envío. El cliente selecciona un motivo y proporciona una descripción. El mensaje y un enlace al envío se envían a la dirección de correo electrónico ingresada.',
        IT: 'Dalla schermata delle informazioni sulla spedizione, è possibile creare un messaggio sulla spedizione. Il cliente seleziona un motivo e fornisce una descrizione. Il messaggio e un link alla spedizione vengono inviati all’indirizzo email inserito.'
    },
    customerSupportReasons: {
        NL: 'Redenen voor meldingen',
        EN: 'Reasons for support',
        DE: 'Gründe für Support',
        FR: 'Raisons du support',
        ES: 'Motivos del soporte',
        IT: 'Motivi del supporto'
    },
    emailAddressForCustomerSupport: {
        NL: 'Emailadres voor meldingen',
        EN: 'Email address for support',
        DE: 'E-Mail-Adresse für Support',
        FR: 'Adresse e-mail pour le support',
        ES: 'Dirección de correo electrónico para el soporte',
        IT: 'Indirizzo email per il supporto'
    },
    customerSupportModalTitleSetting: {
        NL: 'Titel in melding popup',
        EN: 'Title in support popup',
        DE: 'Titel im Support-Popup',
        FR: 'Titre dans la fenêtre de support',
        ES: 'Título en la ventana de soporte',
        IT: 'Titolo nella finestra di supporto'
    },
    customerSupportModalTextSetting: {
        NL: 'Uitleg/instructie',
        EN: 'Explanation/instruction',
        DE: 'Erklärung/Anleitung',
        FR: 'Explication/instruction',
        ES: 'Explicación/instrucción',
        IT: 'Spiegazione/istruzione'
    },
    supportReason: {
        NL: 'Reden',
        EN: 'Support reason',
        DE: 'Grund',
        FR: 'Raison',
        ES: 'Motivo',
        IT: 'Motivo'
    },
    addSupportReason: {
        NL: 'Reden toevoegen',
        EN: 'Add reason',
        DE: 'Grund hinzufügen',
        FR: 'Ajouter une raison',
        ES: 'Agregar un motivo',
        IT: 'Aggiungi un motivo'
    },
    customerSupportModalText: {
        NL: 'Maak een melding over deze zending bij',
        EN: 'Send a message about this shipment to',
        DE: 'Senden Sie eine Nachricht über diese Lieferung an',
        FR: 'Envoyer un message sur cette expédition à',
        ES: 'Enviar un mensaje sobre este envío a',
        IT: 'Invia un messaggio per questa spedizione a'
    },
    name: {
        NL: 'Naam',
        EN: 'Name',
        DE: 'Name',
        FR: 'Nom',
        ES: 'Nombre',
        IT: 'Nome'
    },
    emailAddress: {
        NL: 'Emailadres',
        EN: 'Email address',
        DE: 'E-Mail-Adresse',
        FR: 'Adresse e-mail',
        ES: 'Dirección de correo electrónico',
        IT: 'Indirizzo email'
    },
    phoneNumber: {
        NL: 'Telefoonnummer',
        EN: 'Phone number',
        DE: 'Telefonnummer',
        FR: 'Numéro de téléphone',
        ES: 'Número de teléfono',
        IT: 'Numero di telefono'
    },
    message: {
        NL: 'Bericht',
        EN: 'Message',
        DE: 'Nachricht',
        FR: 'Message',
        ES: 'Mensaje',
        IT: 'Messaggio'
    },
    customerSupportTooltip: {
        NL: 'Melding maken bij',
        EN: 'Send a message about this shipment to',
        DE: 'Senden Sie eine Nachricht über diese Lieferung an',
        FR: 'Envoyer un message sur cette expédition à',
        ES: 'Enviar un mensaje sobre este envío a',
        IT: 'Invia un messaggio per questa spedizione a'
    },
    newRoute: {
        NL: 'Nieuwe route',
        EN: 'New route',
        DE: 'Neue Route',
        FR: 'Nouvelle route',
        ES: 'Nueva ruta',
        IT: 'Nuovo percorso'
    },
    route: {
        NL: 'Route',
        EN: 'Route',
        DE: 'Route',
        FR: 'Route',
        ES: 'Ruta',
        IT: 'Percorso'
    },
    vehicle: {
        NL: 'Voertuig',
        EN: 'Vehicle',
        DE: 'Fahrzeug',
        FR: 'Voiture',
        ES: 'Vehículo',
        IT: 'Veicolo'
    },
    vehicleType: {
        NL: 'Voertuigtype',
        EN: 'Vehicle type',
        DE: 'Fahrzeugtyp',
        FR: 'Type de voiture',
        ES: 'Tipo de vehículo',
        IT: 'Tipo di veicolo'
    },
    vatNumber: {
        NL: 'BTW-nummer',
        EN: 'VAT number',
        DE: 'Umsatzsteuer-Identifikationsnummer',
        FR: 'Numéro de TVA',
        ES: 'Número de identificación de IVA',
        IT: 'Codice fiscale'
    },
    eoriNumber: {
        NL: 'EORI-nummer',
        EN: 'EORI number',
        DE: 'EORI-Nummer',
        FR: 'Numéro EORI',
        ES: 'Número EORI',
        IT: 'Codice EORI'
    },
    productCode: {
        NL: 'Productcode',
        EN: 'Product code',
        DE: 'Produktcode',
        FR: 'Code produit',
        ES: 'Código de producto',
        IT: 'Codice prodotto'
    },
    addCountry: {
        NL: 'Voeg land toe',
        EN: 'Add country',
        DE: 'Land hinzufügen',
        FR: 'Ajouter un pays',
        ES: 'Agregar país',
        IT: 'Aggiungi paese'
    },
    otherCountries: {
        NL: 'Overige landen',
        EN: 'Other countries',
        DE: 'Andere Länder',
        FR: 'Autres pays',
        ES: 'Otros países',
        IT: 'Altri paesi'
    },
    country: {
        NL: 'Land',
        EN: 'Country',
        DE: 'Land',
        FR: 'Pays',
        ES: 'País',
        IT: 'Paese'
    },
    language: {
        NL: 'Taal',
        EN: 'Language',
        DE: 'Sprache',
        FR: 'Langue',
        ES: 'Idioma',
        IT: 'Lingua'
    },
    deleteCountry: {
        NL: 'Verwijder land',
        EN: 'Delete country',
        DE: 'Land löschen',
        FR: 'Supprimer le pays',
        ES: 'Eliminar país',
        IT: 'Elimina paese'
    },
    deleteCountryText: {
        NL: 'Weet je zeker dat je dit land wilt verwijderen?',
        EN: 'Are you sure you want to delete this country?',
        DE: 'Möchtest du dieses Land löschen?',
        FR: 'Êtes-vous sûr de vouloir supprimer ce pays?',
        ES: '¿Estás seguro de que quieres eliminar este país?',
        IT: 'Sei sicuro di voler eliminare questo paese?'
    },
    resetTable: {
        NL: 'Tabel resetten',
        EN: 'Reset table',
        DE: 'Tabelle zurücksetzen',
        FR: 'Réinitialiser la table',
        ES: 'Restablecer tabla',
        IT: 'Reimposta tabella'
    },
    errorsNameRequired: {
        NL: 'Naam is verplicht',
        EN: 'Name is required'
    },
    startDate: {
        NL: 'Startdatum',
        EN: 'Start date'
    },
    endDate: {
        NL: 'Einddatum',
        EN: 'End date'
    },
    startTime: {
        NL: 'Starttijd',
        EN: 'Start time'
    },
    startTimeExecuted: {
        NL: 'Starttijd (uitgevoerd)',
        EN: 'Start time (executed)'
    },
    endTime: {
        NL: 'Eindtijd',
        EN: 'End time'
    },
    endTimeExecuted: {
        NL: 'Eindtijd (uitgevoerd)',
        EN: 'End time (executed)'
    },
    parcel: {
        NL: 'Zending',
        EN: 'Parcel',
        DE: 'Paket',
        FR: 'Colis',
        ES: 'Parcela',
        IT: 'Pacchetto'
    },
    parcelInfo: {
        NL: 'Zending info',
        EN: 'Parcel info',
        DE: 'Paketinfo',
        FR: 'Informations du colis',
        ES: 'Información de la parcela',
        IT: 'Informazioni del pacchetto'
    },
    order: {
        NL: 'Rit',
        EN: 'Order',
        DE: 'Bestellung',
        FR: 'Commande',
        ES: 'Pedido',
        IT: 'Ordine'
    },
    invoice: {
        NL: 'Factuur',
        EN: 'Invoice',
        DE: 'Rechnung',
        FR: 'Facture',
        ES: 'Factura',
        IT: 'Fattura'
    },
    orderInfo: {
        NL: 'Rit info',
        EN: 'Order info',
        DE: 'Bestellinfo',
        FR: 'Informations de la commande',
        ES: 'Información del pedido',
        IT: 'Informazioni dell\'ordine'
    },
    map: {
        NL: 'Kaart',
        EN: 'Map',
        DE: 'Karte',
        FR: 'Carte',
        ES: 'Mapa',
        IT: 'Mappa'
    },
    timeslotStartTime: {
        NL: 'Tijdvak Starttijd',
        EN: 'Timeslot start time'
    },
    timeslotEndTime: {
        NL: 'Tijdvak Eindtijd',
        EN: 'Timeslot end time'
    },
    messenger: {
        NL: 'Koerier',
        EN: 'Messenger'
    },
    startLocation: {
        NL: 'Startlocatie',
        EN: 'Start location'
    },
    endLocation: {
        NL: 'Eindlocatie',
        EN: 'End location'
    },
    location: {
        NL: 'Locatie',
        EN: 'Location',
        DE: 'Ort',
        FR: 'Emplacement',
        ES: 'Ubicación',
        IT: 'Posizione'
    },
    instructions: {
        NL: 'Instructies',
        EN: 'Instructions',
        DE: 'Anweisungen',
        FR: 'Instructions',
        ES: 'Instrucciones',
        IT: 'Istruzioni'
    },
    maximumAmountOfStops: {
        NL: 'Maximum aantal stops',
        EN: 'Maximum amount of stops'
    },
    maxStopsInfo: {
        NL: 'Kies hoeveel stops de route maximaal mag bevatten voor het automatisch vullen.',
        EN: 'Choose how many stops the route may have before it is automatically filled.'
    },
    whenRouteIsFull: {
        NL: 'Wanneer route vol is',
        EN: 'When route is full'
    },
    whenRouteIsReady: {
        NL: 'Wanneer route gereed is',
        EN: 'When route is ready'
    },
    afterRouteStarted: {
        NL: 'Nadat route is gestart',
        EN: 'After route started'
    },
    newTemplate: {
        NL: 'Nieuw template',
        EN: 'New template'
    },
    newOrderTemplate: {
        NL: 'Nieuw rit template',
        EN: 'New order template'
    },
    newRouteTemplate: {
        NL: 'Nieuw route template',
        EN: 'New route template'
    },
    editRouteTemplate: {
        NL: 'Bewerk route template',
        EN: 'Edit route template'
    },
    createRoutesFromTemplate: {
        NL: 'Maak routes van template',
        EN: 'Create routes from template'
    },
    createNewRoute: {
        NL: 'Maak nieuwe route',
        EN: 'Create new route'
    },
    doNotPutOrdersInRoute: {
        NL: 'Ritten niet meer in route zetten',
        EN: 'Do not put orders in route'
    },
    addStopsToRoute: {
        NL: 'Blijf stops toevoegen aan route',
        EN: 'Add stops to route'
    },
    optimizeForTimeslots: {
        NL: 'Optimaliseren voor tijdvakken',
        EN: 'Optimize for timeslots'
    },
    optimizeRoute: {
        NL: 'Optimaliseer route',
        EN: 'Optimize route',
        DE: 'Route optimieren',
        FR: 'Optimiser l\'itinéraire',
        ES: 'Optimizar ruta',
        IT: 'Ottimizzare il percorso'
    },
    optimizeAndStart: {
        NL: 'Optimaliseer & start',
        EN: 'Optimize & start',
        DE: 'Optimieren & starten',
        FR: 'Optimiser & démarrer',
        ES: 'Optimizar & iniciar',
        IT: 'Ottimizzare & avviare'
    },
    timeslotOptimization: {
        NL: 'Tijdvak optimalisatie',
        EN: 'Timeslot optimization'
    },
    routeAdjustableByMessenger: {
        NL: 'Route aanpasbaar door koerier',
        EN: 'Route adjustable by messenger'
    },
    adjustableByMessenger: {
        NL: 'Aanpasbaar door koerier',
        EN: 'Adjustable by messenger'
    },
    loadingRequiredBeforeStart: {
        NL: 'Route inladen verplicht voor start',
        EN: 'Loading required before start'
    },
    routeCalculation: {
        NL: 'Routeberekening',
        EN: 'Route calculation'
    },
    connectedOrderTemplates: {
        NL: 'Gekoppelde rit templates',
        EN: 'Connected order templates'
    },
    orderTemplates: {
        NL: 'Rit templates',
        EN: 'Order templates'
    },
    fillRouteAutomatically: {
        NL: 'Route automatisch vullen',
        EN: 'Fill route automatically'
    },
    fillRouteAutomaticallyInfo: {
        NL: 'Een route kan automatisch gevuld worden met ritten op dezelfde datum die voldoen aan de ingestelde voorwaarden. Bepaal hieronder aan welke voorwaarden een rit moet voldoen.',
        EN: 'A route can be automatically filled with orders on the same date that meet the set criteria. Determine below the conditions that an order must meet.'
    },
    and: {
        NL: 'En',
        EN: 'And'
    },
    or: {
        NL: 'Of',
        EN: 'Or'
    },
    user: {
        NL: 'Gebruiker',
        EN: 'User',
        DE: 'Benutzer',
        FR: 'Utilisateur',
        ES: 'Usuario',
        IT: 'Utente'
    },
    customer: {
        NL: 'Klant',
        EN: 'Customer',
        DE: 'Kunde',
        FR: 'Client',
        ES: 'Cliente',
        IT: 'Cliente'
    },
    creationTime: {
        NL: 'Aanmaaktijd',
        EN: 'Creation time'
    },
    deliveryZone: {
        NL: 'Bezorggebied',
        EN: 'Delivery zone'
    },
    postalCode: {
        NL: 'Postcode',
        EN: 'Postal code',
        DE: 'Postleitzahl',
        FR: 'Code postal',
        ES: 'Código postal',
        IT: 'Codice postale'
    },
    postalCodeZone: {
        NL: 'Postcodegebied',
        EN: 'Postal code zone'
    },
    street: {
        NL: 'Straat',
        EN: 'Street'
    },
    city: {
        NL: 'Plaats',
        EN: 'City'
    },
    postalCodeZoneInfo: {
        NL: 'Gebruik een komma om postcodes te scheiden en een streepje om een reeks te noteren. Postcodes kunnen mét of zónder letters gekozen worden. Bijvoorbeeld: 1000-2000,3000,4000AA-4000ZZ',
        EN: 'Use a comma to separate postcodes and a hyphen to denote a range. Postcodes can be with or without letters. For example: 1000-2000,3000,4000AA-4000ZZ'
    },
    colliType: {
        NL: 'Colli type',
        EN: 'Colli type'
    },
    colliAmount: {
        NL: 'Colli aantal',
        EN: 'Colli amount'
    },
    colliWeight: {
        NL: 'Colli gewicht',
        EN: 'Colli weight'
    },
    colliVolume: {
        NL: 'Colli volume',
        EN: 'Colli volume'
    },
    colloType: {
        NL: 'Collo type',
        EN: 'Collo type'
    },
    colloAmount: {
        NL: 'Collo aantal',
        EN: 'Collo amount'
    },
    colloWeight: {
        NL: 'Collo gewicht',
        EN: 'Collo weight'
    },
    colloVolume: {
        NL: 'Collo volume',
        EN: 'Collo volume'
    },
    notes: {
        NL: 'Opmerking',
        EN: 'Notes'
    },
    instruction: {
        NL: 'Instructie',
        EN: 'Instruction'
    },
    conditionGroup: {
        NL: 'Voorwaardengroep',
        EN: 'Condition group'
    },
    repeatEvery: {
        NL: 'Herhaald elk',
        EN: 'Repeat every'
    },
    repeatsEvery: {
        NL: 'Herhaalt elke',
        EN: 'Repeats every'
    },
    weeks: {
        NL: 'weken',
        EN: 'weeks'
    },
    month: {
        NL: 'maand',
        EN: 'month'
    },
    quarter: {
        NL: 'kwartaal',
        EN: 'quarter'
    },
    year: {
        NL: 'jaar',
        EN: 'year'
    },
    stopTimePerAddress: {
        NL: 'Stoptijd per adres',
        EN: 'Stop time per address'
    },
    repetition: {
        NL: 'Herhaling',
        EN: 'Repetition'
    },
    yes: {
        NL: 'Ja',
        EN: 'Yes',
        DE: 'Ja',
        FR: 'Oui',
        ES: 'Sí',
        IT: 'Sì'
    },
    no: {
        NL: 'Nee',
        EN: 'No',
        DE: 'Nein',
        FR: 'Non',
        ES: 'No',
        IT: 'No'
    },
    lastUpdated: {
        NL: 'Laatst gewijzigd',
        EN: 'Last updated',
        DE: 'Zuletzt aktualisiert',
        FR: 'Dernière mise à jour',
        ES: 'Última actualización',
        IT: 'Ultimo aggiornamento'
    },
    first: {
        NL: 'Eerste',
        EN: 'First',
        DE: 'Erste',
        FR: 'Premier',
        ES: 'Primero',
        IT: 'Primo'
    },
    second: {
        NL: 'Tweede',
        EN: 'Second',
        DE: 'Zweite',
        FR: 'Deuxième',
        ES: 'Segundo',
        IT: 'Secondo'
    },
    third: {
        NL: 'Derde',
        EN: 'Third',
        DE: 'Dritte',
        FR: 'Troisième',
        ES: 'Tercero',
        IT: 'Terzo'
    },
    fourth: {
        NL: 'Vierde',
        EN: 'Fourth',
        DE: 'Vierte',
        FR: 'Quatrième',
        ES: 'Cuarto',
        IT: 'Quarto'
    },
    fifth: {
        NL: 'Vijfde',
        EN: 'Fifth',
        DE: 'Fünfte',
        FR: 'Cinquième',
        ES: 'Quinto',
        IT: 'Quinto'
    },
    last: {
        NL: 'Laatste',
        EN: 'Last',
        DE: 'Letzte',
        FR: 'Dernier',
        ES: 'Último',
        IT: 'Ultimo'
    },
    copy: {
        NL: 'Kopiëren',
        EN: 'Copy',
        DE: 'Kopieren',
        FR: 'Copier',
        ES: 'Copiar',
        IT: 'Copia'
    },
    deleteOrderTemplate: {
        NL: 'Rit template verwijderen',
        EN: 'Delete order template'
    },
    deleteOrderTemplateText: {
        NL: `Alle ritten die vanuit deze template al zijn aangemaakt zullen worden verwijderd.

Wil je dat ritten nog tot een bepaalde datum in de toekomst er in blijven staan? Stel dan in de template een einddatum in, en verwijder de template pas na verlopen van de einddatum.`,
        EN: `All orders that have already been created from this template will be deleted.

Do you want orders to remain available until a certain date in the future? Then set an end date in the template and only delete the template after that date has passed.`
    },
    deleteRouteTemplate: {
        NL: 'Route template verwijderen',
        EN: 'Delete route template'
    },
    deleteRouteTemplateText: {
        NL: `Alle routes die vanuit deze template al zijn aangemaakt zullen worden verwijderd.

Wil je dat routes nog tot een bepaalde datum in de toekomst er in blijven staan? Stel dan in de template een einddatum in, en verwijder de template pas na verlopen van de einddatum.`,
        EN: `All routes that have already been created from this template will be deleted.

Do you want routes to remain available until a certain date in the future? Then set an end date in the template and only delete the template after that date has passed.`
    },
    address: {
        NL: 'Adres',
        EN: 'Address'
    },
    recurringRoute: {
        NL: 'Herhaalde route',
        EN: 'Recurring route'
    },
    orderAddresses: {
        NL: 'Volgorde adressen',
        EN: 'Order addresses'
    },
    connectedRouteTemplate: {
        NL: 'Gekoppelde route template',
        EN: 'Connected route template'
    },
    date: {
        NL: 'Datum',
        EN: 'Date',
        DE: 'Datum',
        FR: 'Date',
        ES: 'Fecha',
        IT: 'Data'
    },
    shifts: {
        NL: 'Diensten',
        EN: 'Shifts',
        DE: 'Dienst',
        FR: 'Dienst',
        ES: 'Día',
        IT: 'Turno'
    },
    shift: {
        NL: 'Dienst',
        EN: 'Shift',
        DE: 'Dienst',
        FR: 'Dienst',
        ES: 'Día',
        IT: 'Turno'
    },
    newShift: {
        NL: 'Nieuwe dienst',
        EN: 'New shift',
        DE: 'Neuer Dienst',
        FR: 'Nouveau service',
        ES: 'Nuevo día',
        IT: 'Nuovo turno'
    },
    startShift: {
        NL: 'Start dienst',
        EN: 'Start shift',
        DE: 'Dienst starten',
        FR: 'Dienst starten',
        ES: 'Día comenzar',
        IT: 'Turno comenzar'
    },
    endShift: {
        NL: 'Dienst afronden',
        EN: 'End shift',
        DE: 'Dienst beenden',
        FR: 'Dienst terminer',
        ES: 'Día terminar',
        IT: 'Turno terminar'
    },
    reopenShift: {
        NL: 'Dienst heropenen',
        EN: 'Reopen shift',
        DE: 'Dienst erneut öffnen',
        FR: 'Réouvrir le service',
        ES: 'Reabrir servicio',
        IT: 'Riapri turno'
    },
    shiftEndBlockedByActiveRoute: {
        NL: 'Dienst kan niet worden afgerond omdat er nog een route actief is.',
        EN: 'Shift cannot be completed because a route is still active.',
        DE: 'Dienst kann nicht beendet werden, da noch eine Route aktiv ist.',
        FR: 'Le service ne peut pas être terminé car un itinéraire est encore actif.',
        ES: 'El día no se puede completar porque todavía hay una ruta activa.',
        IT: 'Il turno non può essere completato perché è ancora attivo un percorso.'
    },
    shiftStartBlockedByActiveShift: {
        NL: 'Dienst kan niet worden gestart omdat er al een andere dienst actief is. Rond eerst de actieve dienst af voordat je een nieuwe dienst start.',
        EN: 'Shift cannot be started because another shift is already active. Complete the active shift before starting a new one.',
        DE: 'Dienst kann nicht gestartet werden, da bereits eine andere Dienst aktiv ist. Beenden Sie zuerst die aktive Dienst, bevor Sie eine neue starten.',
        FR: 'Le service ne peut pas être démarré car un autre service est déjà actif. Terminez le service actif avant d\'en démarrer un nouveau.',
        ES: 'El día no se puede iniciar porque ya hay otro día activo. Complete el día activo antes de iniciar uno nuevo.',
        IT: 'Il turno non può essere avviato perché un altro turno è già attivo. Completa il turno attivo prima di avviarne uno nuovo.'
    },
    shiftNotStarted: {
        NL: 'Dienst niet gestart',
        EN: 'Shift not started',
        DE: 'Dienst nicht gestartet',
        FR: 'Dienst non démarré',
        ES: 'Día no comenzado',
        IT: 'Turno no comenzado'
    },
    noShift: {
        NL: 'Geen dienst',
        EN: 'No shift',
        DE: 'Kein Dienst',
        FR: 'Pas de service',
        ES: 'Sin servicio',
        IT: 'Nessun turno'
    },
    shiftCompleted: {
        NL: 'Dienst afgerond',
        EN: 'Shift completed',
        DE: 'Dienst beendet',
        FR: 'Dienst terminé',
        ES: 'Día terminado',
        IT: 'Turno terminato'
    },
    pause: {
        NL: 'Pauze',
        EN: 'Pause',
        DE: 'Pause',
        FR: 'Pause',
        ES: 'Pausa',
        IT: 'Pausa'
    },
    resume: {
        NL: 'Hervat',
        EN: 'Resume',
        DE: 'Fortsetzen',
        FR: 'Reprendre',
        ES: 'Reanudar',
        IT: 'Riprendi'
    },
    workedTime: {
        NL: 'Werktijd',
        EN: 'Worked time',
        DE: 'Gearbeitete Zeit',
        FR: 'Temps travaillé',
        ES: 'Tiempo trabajado',
        IT: 'Tempo di lavoro'
    },
    totalWorkedTime: {
        NL: 'Totale werktijd',
        EN: 'Total worked time',
        DE: 'Gesamtarbeitszeit',
        FR: 'Temps de travail total',
        ES: 'Tiempo total trabajado',
        IT: 'Tempo totale di lavoro'
    },
    pausedTime: {
        NL: 'Pauze tijd',
        EN: 'Paused time',
        DE: 'Pausierte Zeit',
        FR: 'Temps de pause',
        ES: 'Tiempo de pausa',
        IT: 'Tempo di pausa'
    },
    shiftPaused: {
        NL: 'Dienst gepauzeerd',
        EN: 'Shift paused',
        DE: 'Dienst pausiert',
        FR: 'Dienst mis en pause',
        ES: 'Día pausado',
        IT: 'Turno pausato'
    },
    newActivity: {
        NL: 'Nieuwe activiteit',
        EN: 'New activity',
        DE: 'Neue Aktivität',
        FR: 'Nouvelle activité',
        ES: 'Nueva actividad',
        IT: 'Nuovo turno'
    },
    addActivity: {
        NL: 'Activiteit toevoegen',
        EN: 'Add activity',
        DE: 'Aktivität hinzufügen',
        FR: 'Ajouter une activité',
        ES: 'Agregar actividad',
        IT: 'Aggiungi turno'
    },
    editActivity: {
        NL: 'Bewerk activiteit',
        EN: 'Edit activity',
        DE: 'Aktivität bearbeiten',
        FR: 'Modifier l\'activité',
        ES: 'Editar actividad',
        IT: 'Modifica turno'
    },
    activities: {
        NL: 'Activiteiten',
        EN: 'Activities',
        DE: 'Aktivitäten',
        FR: 'Activités',
        ES: 'Actividades',
        IT: 'Turni'
    },
    activity: {
        NL: 'Activiteit',
        EN: 'Activity',
        DE: 'Aktivität',
        FR: 'Activité',
        ES: 'Actividad',
        IT: 'Turno'
    },
    currentActivity: {
        NL: 'Huidige activiteit',
        EN: 'Current activity',
        DE: 'Aktuelle Aktivität',
        FR: 'Activité actuelle',
        ES: 'Actividad actual',
        IT: 'Turno attuale'
    },
    switchActivity: {
        NL: 'Wissel activiteit',
        EN: 'Switch activity',
        DE: 'Aktivität wechseln',
        FR: 'Changer d\'activité',
        ES: 'Cambiar actividad',
        IT: 'Cambia turno'
    },
    shiftSettingsInfo: {
        NL: 'Tijdens een dienst kun je de koerier verschillende activiteiten laten registreren. Een dienst wordt door de koerier gestart en beïndigd. Tijdens de dienst is altijd één van de activiteiten actief. Bepaal hier welke activiteiten je wil laten registreren, en welke voorwaarden er bij horen.',
        EN: '',
        DE: '',
        FR: '',
        ES: '',
        IT: ''
    },
    color: {
        NL: 'Kleur',
        EN: 'Color',
        DE: 'Farbe',
        FR: 'Couleur',
        ES: 'Color',
        IT: 'Colore'
    },
    settings: {
        NL: 'Instellingen',
        EN: 'Settings',
        DE: 'Einstellungen',
        FR: 'Paramètres',
        ES: 'Ajustes',
        IT: 'Impostazioni'
    },
    hourlyRate: {
        NL: 'Uurtarief',
        EN: 'Hourly rate',
        DE: 'Stundensatz',
        FR: 'Tarif horaire',
        ES: 'Tarifa horaria',
        IT: 'Tariffa oraria'
    },
    total: {
        NL: 'Totaal',
        EN: 'Total',
        DE: 'Gesamt',
        FR: 'Total',
        ES: 'Total',
        IT: 'Totale'
    },
    history: {
        NL: 'Historie',
        EN: 'History',
        DE: 'Verlauf',
        FR: 'Historique',
        ES: 'Historial',
        IT: 'Storia'
    },
    status: {
        NL: 'Status',
        EN: 'Status',
        DE: 'Status',
        FR: 'Statut',
        ES: 'Estado',
        IT: 'Stato'
    },
    orders: {
        NL: 'Ritten',
        EN: 'Orders',
        DE: 'Bestellungen',
        FR: 'Commandes',
        ES: 'Pedidos',
        IT: 'Ordini'
    },
    newOrder: {
        NL: 'Nieuwe rit',
        EN: 'New order',
        DE: 'Neue Bestellung',
        FR: 'Nouvelle commande',
        ES: 'Nuevo pedido',
        IT: 'Nuovo ordine'
    },
    ordersRead: {
        NL: 'Ritten inzien',
        EN: 'View orders',
        DE: 'Bestellungen anzeigen',
        FR: 'Voir les commandes',
        ES: 'Ver pedidos',
        IT: 'Visualizza ordini'
    },
    ordersWrite: {
        NL: 'Ritten aanmaken en bewerken',
        EN: 'Create orders',
        DE: 'Bestellungen erstellen',
        FR: 'Créer des commandes',
        ES: 'Crear pedidos',
        IT: 'Crea ordini'
    },
    parcels: {
        NL: 'Zendingen',
        EN: 'Parcels',
        DE: 'Versand',
        FR: 'Expéditions',
        ES: 'Envíos',
        IT: 'Spedizioni'
    },
    newParcel: {
        NL: 'Nieuwe zending',
        EN: 'New parcel',
        DE: 'Neuer Versand',
        FR: 'Nouvelle expédition',
        ES: 'Nuevo envío',
        IT: 'Nuova spedizione'
    },
    apiKey: {
        NL: 'API-sleutel',
        EN: 'API key',
        DE: 'API-Schlüssel',
        FR: 'Clé API',
        ES: 'Clave API',
        IT: 'Chiave API'
    },
    completed: {
        NL: 'Afgerond',
        EN: 'Completed',
        DE: 'Abgeschlossen',
        FR: 'Complété',
        ES: 'Completado',
        IT: 'Completato'
    },
    notCompleted: {
        NL: 'Niet afgerond',
        EN: 'Not completed',
        DE: 'Nicht abgeschlossen',
        FR: 'Non complété',
        ES: 'No completado',
        IT: 'Non completato'
    },
    tooLate: {
        NL: 'Te laat',
        EN: 'Too late',
        DE: 'Zu spät',
        FR: 'Trop tard',
        ES: 'Demasiado tarde',
        IT: 'Trop tardi'
    },
    nrOfStops: {
        NL: 'Aantal stops',
        EN: 'Number of stops',
        DE: 'Anzahl der Stops',
        FR: 'Nombre de stops',
        ES: 'Número de paradas',
        IT: 'Numero di fermate'
    },
    nrOfColli: {
        NL: 'Aantal colli',
        EN: 'Number of colli',
        DE: 'Anzahl der Kolli',
        FR: 'Nombre de colli',
        ES: 'Número de colli',
        IT: 'Numero di colli'
    },
    revenue: {
        NL: 'Omzet',
        EN: 'Revenue',
        DE: 'Umsatz',
        FR: 'Revenu',
        ES: 'Ingresos',
        IT: 'Ricavi'
    },
    revenuePerHour: {
        NL: 'Omzet per uur',
        EN: 'Revenue per hour',
        DE: 'Umsatz pro Stunde',
        FR: 'Revenu par heure',
        ES: 'Ingresos por hora',
        IT: 'Ricavi per ora'
    },
    duration: {
        NL: 'Duur',
        EN: 'Duration',
        DE: 'Dauer',
        FR: 'Durée',
        ES: 'Duración',
        IT: 'Durata'
    },
    plannedDuration: {
        NL: 'Geplande duur',
        EN: 'Planned duration',
        DE: 'Planierte Dauer',
        FR: 'Durée prévue',
        ES: 'Duración prevista',
        IT: 'Durata prevista'
    },
    completedDuration: {
        NL: 'Uitgevoerde duur',
        EN: 'Completed duration',
        DE: 'Erreicht Dauer',
        FR: 'Durée réalisée',
        ES: 'Duración completada',
        IT: 'Durata completata'
    },
    deviationPlannedDuration: {
        NL: 'Afwijking van geplande duur',
        EN: 'Deviation from planned duration',
        DE: 'Abweichung von planierter Dauer',
        FR: 'Déviation de la durée prévue',
        ES: 'Desviación de la duración prevista',
        IT: 'Deviazione dalla durata prevista'
    },
    distance: {
        NL: 'Afstand',
        EN: 'Distance',
        DE: 'Distanz',
        FR: 'Distance',
        ES: 'Distancia',
        IT: 'Distanza'
    },
    speed: {
        NL: 'Snelheid',
        EN: 'Speed',
        DE: 'Geschwindigkeit',
        FR: 'Vitesse',
        ES: 'Velocidad',
        IT: 'Velocità'
    },
    averageSpeed: {
        NL: 'Gemiddelde snelheid',
        EN: 'Average speed',
        DE: 'Durchschnittliche Geschwindigkeit',
        FR: 'Vitesse moyenne',
        ES: 'Velocidad promedio',
        IT: 'Velocità media'
    },
    completedDistance: {
        NL: 'Uitgevoerde afstand',
        EN: 'Completed distance',
        DE: 'Erreicht Distanz',
        FR: 'Distance réalisée',
        ES: 'Distancia completada',
        IT: 'Distanza completata'
    },
    plannedStartTime: {
        NL: 'Geplande starttijd',
        EN: 'Planned start time',
        DE: 'Planierte Startzeit',
        FR: 'Heure prévue de départ',
        ES: 'Hora prevista de inicio',
        IT: 'Ora prevista di inizio'
    },
    plannedEndTime: {
        NL: 'Geplande eindtijd',
        EN: 'Planned end time',
        DE: 'Planierte Endzeit',
        FR: 'Heure prévue de fin',
        ES: 'Hora prevista de fin',
        IT: 'Ora prevista di fine'
    },
    expectedEndTime: {
        NL: 'Verwachte eindtijd',
        EN: 'Expected end time',
        DE: 'Erwartete Endzeit',
        FR: 'Heure prévue de fin',
        ES: 'Hora prevista de fin',
        IT: 'Ora prevista di fine'
    },
    startPoint: {
        NL: 'Startpunt',
        EN: 'Start point',
        DE: 'Startpunkt',
        FR: 'Point de départ',
        ES: 'Punto de inicio',
        IT: 'Punto di inizio'
    },
    endPoint: {
        NL: 'Eindpunt',
        EN: 'End point',
        DE: 'Endpunkt',
        FR: 'Point de fin',
        ES: 'Punto de fin',
        IT: 'Punto di fine'
    },
    stopTime: {
        NL: 'Stoptijd',
        EN: 'Stop time',
        DE: 'Stopzeit',
        FR: 'Heure d\'arrêt',
        ES: 'Hora de parada',
        IT: 'Ora di stop'
    },
    planned: {
        NL: 'Gepland',
        EN: 'Planned',
        DE: 'Planiert',
        FR: 'Prévu',
        ES: 'Prevista',
        IT: 'Previsto'
    },
    targets: {
        NL: 'Doelen',
        EN: 'Targets',
        DE: 'Ziele',
        FR: 'Objectifs',
        ES: 'Objetivos',
        IT: 'Obiettivi'
    },
    type: {
        NL: 'Type',
        EN: 'Type',
        DE: 'Typ',
        FR: 'Type',
        ES: 'Tipo',
        IT: 'Tipo'
    },
    target: {
        NL: 'Doel',
        EN: 'Target',
        DE: 'Ziel',
        FR: 'Objectif',
        ES: 'Objetivo',
        IT: 'Obiettivo'
    },
    addTarget: {
        NL: 'Doel toevoegen',
        EN: 'Add target',
        DE: 'Ziel hinzufügen',
        FR: 'Ajouter un objectif',
        ES: 'Agregar objetivo',
        IT: 'Aggiungi obiettivo'
    },
    rrule: {
        NL: 'Herhaalpatroon',
        EN: 'Recurrence rule',
        DE: 'Wiederholungsregel',
        FR: 'Règle de récurrence',
        ES: 'Regla de recurrencia',
        IT: 'Regola di ricorrenza'
    },
    stopsPerHour: {
        NL: 'Stops per uur',
        EN: 'Stops per hour',
        DE: 'Stopps pro Stunde',
        FR: 'Arrêts par heure',
        ES: 'Paradas por hora',
        IT: 'Fermate per ora'
    },
    targetExecuted: {
        NL: 'Doel (uitgevoerd)',
        EN: 'Target (executed)',
        DE: 'Ziel (ausgeführt)',
        FR: 'Objectif (exécuté)',
        ES: 'Objetivo (ejecutado)',
        IT: 'Obiettivo (eseguito)'
    },
    executed: {
        NL: 'Uitgevoerd',
        EN: 'Executed',
        DE: 'Ausgeführt',
        FR: 'Exécuté',
        ES: 'Ejecutado',
        IT: 'Eseguito'
    },
    score: {
        NL: 'Score',
        EN: 'Score',
        DE: 'Punktzahl',
        FR: 'Score',
        ES: 'Puntuación',
        IT: 'Punteggio'
    },
    privateAddress: {
        NL: 'Privéadres',
        EN: 'Private address',
        DE: 'Privatadresse',
        FR: 'Adresse privée',
        ES: 'Dirección privada',
        IT: 'Indirizzo privato'
    },
    businessAddress: {
        NL: 'Bedrijfsadres',
        EN: 'Business address',
        DE: 'Geschäftsadresse',
        FR: 'Adresse professionnelle',
        ES: 'Dirección comercial',
        IT: 'Indirizzo aziendale'
    },
    general: {
        NL: 'Algemeen',
        EN: 'General',
        DE: 'Allgemein',
        FR: 'Général',
        ES: 'General',
        IT: 'Generale'
    },
    shiftbaseIntegration: {
        NL: 'Shiftbase integratie',
        EN: 'Shiftbase integration',
        DE: 'Shiftbase-Integration',
        FR: 'Intégration Shiftbase',
        ES: 'Integración Shiftbase',
        IT: 'Integrazione Shiftbase'
    },
    shiftbaseIntegrationInfo: {
        NL: 'Hier kun je een koppeling maken met Shiftbase. Vul de API-sleutel van Shiftbase in, en de koppeling zal automatisch de diensten en activiteiten synchroniseren.',
        EN: 'Here you can create a connection with Shiftbase. Enter the API key from Shiftbase, and the connection will automatically synchronize the shifts and activities.',
        DE: 'Hier können Sie eine Verbindung mit Shiftbase herstellen. Geben Sie den API-Schlüssel von Shiftbase ein, und die Verbindung synchronisiert automatisch die Schichten und Aktivitäten.',
        FR: 'Ici, vous pouvez créer une connexion avec Shiftbase. Entrez la clé API de Shiftbase, et la connexion synchronisera automatiquement les services et les activités.',
        ES: 'Aquí puedes crear una conexión con Shiftbase. Ingrese la clave API de Shiftbase, y la conexión sincronizará automáticamente los turnos y actividades.',
        IT: 'Qui puoi creare una connessione con Shiftbase. Inserisci la chiave API di Shiftbase e la connessione sincronizzerà automaticamente i turni e le attività.'
    },
    autoSyncShifts: {
        NL: 'Diensten automatisch synchroniseren',
        EN: 'Automatically synchronize shifts',
        DE: 'Schichten automatisch synchronisieren',
        FR: 'Synchroniser automatiquement les services',
        ES: 'Sincronizar automáticamente los turnos',
        IT: 'Sincronizza automaticamente i turni'
    },
    minimalShiftDuration: {
        NL: 'Minimale dienstduur',
        EN: 'Minimal shift duration',
        DE: 'Minimale Dienstzeit',
        FR: 'Durée minimale du service',
        ES: 'Duración mínima del servicio',
        IT: 'Durata minima del turno'
    },
    department: {
        NL: 'Afdeling',
        EN: 'Department',
        DE: 'Abteilung',
        FR: 'Département',
        ES: 'Departamento',
        IT: 'Dipartimento'
    },
    departmentId: {
        NL: 'Afdelings-ID',
        EN: 'Department ID',
        DE: 'Abteilungs-ID',
        FR: 'ID du département',
        ES: 'ID del departamento',
        IT: 'ID del dipartimento'
    },
    departmentConnectedTo: {
        NL: 'Afdeling overnemen van',
        EN: 'Take department from',
        DE: 'Abteilung übernehmen von',
        FR: 'Reprendre le département de',
        ES: 'Tomar departamento de',
        IT: 'Prendi il dipartimento da'
    },
    departmentConnectedToInfo: {
        NL: 'Een dienst zonder eigen Shiftbase afdeling of team neemt deze over van de koerier of klant. Een wijziging bij de koerier of klant geldt dan ook voor diensten zonder eigen afdeling of team.',
        EN: 'A shift without its own Shiftbase department or team takes these from the courier or customer. A change on the courier or customer then also applies to shifts without their own department or team.',
        DE: 'Eine Schicht ohne eigene Shiftbase-Abteilung oder eigenes Team übernimmt diese vom Kurier oder Kunden. Eine Änderung beim Kurier oder Kunden gilt dann auch für Schichten ohne eigene Abteilung oder eigenes Team.',
        FR: 'Un service sans département ou équipe Shiftbase propre les reprend du coursier ou du client. Une modification chez le coursier ou le client s\'applique alors aussi aux services sans département ou équipe propre.',
        ES: 'Un turno sin departamento o equipo de Shiftbase propio los toma del mensajero o del cliente. Un cambio en el mensajero o cliente se aplica también a los turnos sin departamento o equipo propio.',
        IT: 'Un turno senza dipartimento o team Shiftbase proprio li prende dal corriere o dal cliente. Una modifica al corriere o al cliente vale quindi anche per i turni senza dipartimento o team proprio.'
    },
    teamConnectedTo: {
        NL: 'Team overnemen van',
        EN: 'Take team from',
        DE: 'Team übernehmen von',
        FR: 'Reprendre l\'équipe de',
        ES: 'Tomar equipo de',
        IT: 'Prendi il team da'
    },
    choosePerShift: {
        NL: 'Zelf kiezen per dienst',
        EN: 'Choose per shift',
        DE: 'Pro Schicht selbst wählen',
        FR: 'Choisir par service',
        ES: 'Elegir por turno',
        IT: 'Scegli per turno'
    },
    importShifts: {
        NL: 'Diensten importeren',
        EN: 'Import shifts',
        DE: 'Schichten importieren',
        FR: 'Importer les services',
        ES: 'Importar turnos',
        IT: 'Importa turni'
    },
    importShiftsInfo: {
        NL: 'Kies welke diensten uit Shiftbase worden geïmporteerd bij het synchroniseren. Een rooster werkt een bestaande dienst bij met dezelfde Shiftbase dienst, afdeling en team op dezelfde dag die nog niet is gestart en nog niet bij een ander rooster hoort. Roosters van medewerkers die niet aan een gebruiker gekoppeld zijn worden alleen bij "Alle diensten" verwerkt.',
        EN: 'Choose which shifts from Shiftbase are imported when synchronizing. A roster updates an existing shift with the same Shiftbase shift, department and team on the same day that has not started yet and does not belong to another roster. Rosters of employees that are not linked to a user are only processed with "All shifts".',
        DE: 'Wählen Sie, welche Schichten aus Shiftbase beim Synchronisieren importiert werden. Ein Dienstplan aktualisiert eine bestehende Schicht mit derselben Shiftbase-Schicht, Abteilung und demselben Team am selben Tag, die noch nicht begonnen hat und noch zu keinem anderen Dienstplan gehört. Dienstpläne von Mitarbeitern, die nicht mit einem Benutzer verknüpft sind, werden nur bei "Alle Schichten" verarbeitet.',
        FR: 'Choisissez quels services de Shiftbase sont importés lors de la synchronisation. Un planning met à jour un service existant avec le même service Shiftbase, département et équipe le même jour, qui n\'a pas encore commencé et n\'appartient pas à un autre planning. Les plannings des employés non liés à un utilisateur ne sont traités qu\'avec "Tous les services".',
        ES: 'Elija qué turnos de Shiftbase se importan al sincronizar. Un horario actualiza un turno existente con el mismo turno de Shiftbase, departamento y equipo el mismo día que aún no ha comenzado y no pertenece a otro horario. Los horarios de empleados no vinculados a un usuario solo se procesan con "Todos los turnos".',
        IT: 'Scegli quali turni di Shiftbase vengono importati durante la sincronizzazione. Un turno pianificato aggiorna un turno esistente con lo stesso turno Shiftbase, dipartimento e team nello stesso giorno, che non è ancora iniziato e non appartiene a un altro turno pianificato. I turni dei dipendenti non collegati a un utente vengono elaborati solo con "Tutti i turni".'
    },
    importShiftsMatch: {
        NL: 'Alleen bestaande diensten bijwerken',
        EN: 'Only update existing shifts',
        DE: 'Nur bestehende Schichten aktualisieren',
        FR: 'Mettre à jour uniquement les services existants',
        ES: 'Actualizar solo turnos existentes',
        IT: 'Aggiorna solo i turni esistenti'
    },
    importShiftsLinkedUser: {
        NL: 'Ook nieuwe diensten van gekoppelde gebruikers',
        EN: 'Also new shifts of linked users',
        DE: 'Auch neue Schichten verknüpfter Benutzer',
        FR: 'Aussi les nouveaux services des utilisateurs liés',
        ES: 'También turnos nuevos de usuarios vinculados',
        IT: 'Anche nuovi turni degli utenti collegati'
    },
    importShiftsAll: {
        NL: 'Alle diensten',
        EN: 'All shifts',
        DE: 'Alle Schichten',
        FR: 'Tous les services',
        ES: 'Todos los turnos',
        IT: 'Tutti i turni'
    },
    fixed: {
        NL: 'Vast',
        EN: 'Fixed',
        DE: 'Fest',
        FR: 'Fixe',
        ES: 'Fijo',
        IT: 'Fisso'
    },
    products: {
        NL: 'Producten',
        EN: 'Products',
        DE: 'Produkte',
        FR: 'Produits',
        ES: 'Productos',
        IT: 'Prodotti'
    },
    addProduct: {
        NL: 'Product toevoegen',
        EN: 'Add product',
        DE: 'Produkt hinzufügen',
        FR: 'Ajouter un produit',
        ES: 'Agregar producto',
        IT: 'Aggiungi prodotto'
    },
    removeProduct: {
        NL: 'Product verwijderen',
        EN: 'Remove product',
        DE: 'Produkt entfernen',
        FR: 'Supprimer le produit',
        ES: 'Eliminar producto',
        IT: 'Rimuovi prodotto'
    },
    options: {
        NL: 'Opties',
        EN: 'Options',
        DE: 'Optionen',
        FR: 'Options',
        ES: 'Opciones',
        IT: 'Opzioni'
    },
    useProducts: {
        NL: 'Gebruik producten',
        EN: 'Use products',
        DE: 'Produkte verwenden',
        FR: 'Utiliser des produits',
        ES: 'Usar productos',
        IT: 'Usa prodotti'
    },
    useDeliveryAreas: {
        NL: 'Gebruik bezorggebieden',
        EN: 'Use delivery areas',
        DE: 'Liefergebiete verwenden',
        FR: 'Utiliser les zones de livraison',
        ES: 'Usar zonas de entrega',
        IT: 'Usa aree di consegna'
    },
    usePriceScales: {
        NL: 'Gebruik tariefstaffels',
        EN: 'Use price tiers',
        DE: 'Preisstufen verwenden',
        FR: 'Utiliser les tranches de prix',
        ES: 'Usar tramos de precios',
        IT: 'Usa fasce di prezzo'
    },
    useProgressivePriceScales: {
        NL: 'Gebruik progressieve tariefstaffels',
        EN: 'Use progressive price tiers',
        DE: 'Progressive Preisstufen verwenden',
        FR: 'Utiliser des tranches de prix progressives',
        ES: 'Usar tramos de precios progresivos',
        IT: 'Usa fasce di prezzo progressive'
    },
    usePriceScalesPerDay: {
        NL: 'Gebruik tariefstaffels per dag',
        EN: 'Use price tiers per day',
        DE: 'Preisstufen pro Tag verwenden',
        FR: 'Utiliser les tranches de prix par jour',
        ES: 'Usar tramos de precios por día',
        IT: 'Usa fasce di prezzo per giorno'
    },
    from: {
        NL: 'Vanaf',
        EN: 'From',
        DE: 'Von',
        FR: 'De',
        ES: 'Desde',
        IT: 'Da'
    },
    price: {
        NL: 'Prijs',
        EN: 'Price',
        DE: 'Preis',
        FR: 'Prix',
        ES: 'Precio',
        IT: 'Prezzo'
    },
    priceTable: {
        NL: 'Tarieftabel',
        EN: 'Price table',
        DE: 'Preistabelle',
        FR: 'Tableau des prix',
        ES: 'Tabla de precios',
        IT: 'Tabella dei prezzi'
    },
    addOption: {
        NL: 'Optie toevoegen',
        EN: 'Add option',
        DE: 'Option hinzufügen',
        FR: 'Ajouter une option',
        ES: 'Agregar opción',
        IT: 'Aggiungi opzione'
    },
    priceBasedOn: {
        NL: 'Prijs gebaseerd op',
        EN: 'Price based on',
        DE: 'Preis basierend auf',
        FR: 'Prix basé sur',
        ES: 'Precio basado en',
        IT: 'Prezzo basato su'
    },
    hours: {
        NL: 'Uren',
        EN: 'Hours',
        DE: 'Stunden',
        FR: 'Heures',
        ES: 'Horas',
        IT: 'Ore'
    },
    addDeliveryAddressToRoute: {
        NL: 'Bezorgadres toevoegen aan route',
        EN: 'Add delivery address to route',
        DE: 'Lieferadresse zur Route hinzufügen',
        FR: 'Ajouter l\'adresse de livraison à la route',
        ES: 'Agregar dirección de entrega a la ruta',
        IT: 'Aggiungi l\'indirizzo di consegna alla route'
    },
    doNotAddDeliveryAddress: {
        NL: 'Bezorgadres niet toevoegen',
        EN: 'Do not add delivery address',
        DE: 'Lieferadresse nicht hinzufügen',
        FR: 'Ne pas ajouter l\'adresse de livraison',
        ES: 'No agregar dirección de entrega',
        IT: 'Non aggiungere l\'indirizzo di consegna'
    },
    addPickupAddressToRoute: {
        NL: 'Ophaaladres toevoegen aan route',
        EN: 'Add pickup address to route',
        DE: 'Abholadresse zur Route hinzufügen',
        FR: 'Ajouter l\'adresse d\'enlèvement à la route',
        ES: 'Agregar dirección de recogida a la ruta',
        IT: 'Aggiungi l\'indirizzo di ritiro alla route'
    },
    doNotAddPickupAddress: {
        NL: 'Ophaaladres niet toevoegen',
        EN: 'Do not add pickup address',
        DE: 'Abholadresse nicht hinzufügen',
        FR: 'Ne pas ajouter l\'adresse d\'enlèvement',
        ES: 'No agregar dirección de recogida',
        IT: 'Non aggiungere l\'indirizzo di ritiro'
    },
    cancelScan: {
        NL: 'Scan annuleren',
        EN: 'Cancel scan',
        DE: 'Scan abbrechen',
        FR: 'Annuler le scan',
        ES: 'Cancelar escaneo',
        IT: 'Annullare lo scan'
    },
    branches: {
        NL: 'Vestigingen',
        EN: 'Branches',
        DE: 'Filialen',
        FR: 'Succursales',
        ES: 'Sucursales',
        IT: 'Filiali'
    },
    branch: {
        NL: 'Vestiging',
        EN: 'Branch',
        DE: 'Filiale',
        FR: 'Succursale',
        ES: 'Sucursal',
        IT: 'Filiale'
    },
    allBranches: {
        NL: 'Alle vestigingen',
        EN: 'All branches',
        DE: 'Alle Filialen',
        FR: 'Toutes les succursales',
        ES: 'Todas las sucursales',
        IT: 'Tutte le filiali'
    },
    acccessToAllBranches: {
        NL: 'Toegang tot alle vestigingen',
        EN: 'Access to all branches',
        DE: 'Zugriff auf alle Filialen',
        FR: 'Accès à toutes les succursales',
        ES: 'Acceso a todas las sucursales',
        IT: 'Accesso a tutte le filiali'
    },
    add: {
        NL: 'Toevoegen',
        EN: 'Add',
        DE: 'Hinzufügen',
        FR: 'Ajouter',
        ES: 'Agregar',
        IT: 'Aggiungi'
    },
    replace: {
        NL: 'Vervangen',
        EN: 'Replace',
        DE: 'Ersetzen',
        FR: 'Remplacer',
        ES: 'Reemplazar',
        IT: 'Sostituisci'
    },
    action: {
        NL: 'Actie',
        EN: 'Action',
        DE: 'Aktie',
        FR: 'Action',
        ES: 'Acción',
        IT: 'Azione'
    },
    assignBranches: {
        NL: 'Vestigingen toewijzen',
        EN: 'Assign branches',
        DE: 'Filialen zuweisen',
        FR: 'Attribuer des succursales',
        ES: 'Asignar sucursales',
        IT: 'Assegna filiali'
    },
    assignBranch: {
        NL: 'Vestiging toewijzen',
        EN: 'Assign branch',
        DE: 'Filiale zuweisen',
        FR: 'Attribuer une succursale',
        ES: 'Asignar sucursal',
        IT: 'Assegna filiale'
    },
    chooseBranchesAndActionForUsers: {
        NL: 'Kies de vestigingen en de actie die toegepast moet worden op de geselecteerde gebruikers.',
        EN: 'Choose the branches and the action to apply to the selected users.',
        DE: 'Wählen Sie die Filialen und die Aktion, die auf die ausgewählten Benutzer angewendet werden soll.',
        FR: 'Choisissez les succursales et l\'action à appliquer aux utilisateurs sélectionnés.',
        ES: 'Elige las sucursales y la acción que se aplicará a los usuarios seleccionados.',
        IT: 'Scegli le filiali e l\'azione da applicare agli utenti selezionati.'
    },
    chooseBranchForCustomers: {
        NL: 'Kies de vestiging die toegepast moet worden op de geselecteerde klanten.',
        EN: 'Choose the branch to apply to the selected customers.',
        DE: 'Wählen Sie die Filiale, die auf die ausgewählten Kunden angewendet werden soll.',
        FR: 'Choisissez la succursale à appliquer aux clients sélectionnés.',
        ES: 'Elige la sucursal que se aplicará a los clientes seleccionados.',
        IT: 'Scegli la filiale da applicare ai clienti selezionati.'
    },
    chooseBranchForRouteTemplates: {
        NL: 'Kies de vestiging die toegepast moet worden op de geselecteerde route templates.',
        EN: 'Choose the branch to apply to the selected route templates.',
        DE: 'Wählen Sie die Filiale, die auf die ausgewählten Routenvorlagen angewendet werden soll.',
        FR: 'Choisissez la succursale à appliquer aux modèles de route sélectionnés.',
        ES: 'Elige la sucursal que se aplicará a las plantillas de ruta seleccionadas.',
        IT: 'Scegli la filiale da applicare ai modelli di percorso selezionati.'
    },
    chooseBranchForOrders: {
        NL: 'Kies de vestiging die toegepast moet worden op de geselecteerde ritten.',
        EN: 'Choose the branch to apply to the selected orders.',
        DE: 'Wählen Sie die Filiale, die auf die ausgewählten Aufträge angewendet werden soll.',
        FR: 'Choisissez la succursale à appliquer aux courses sélectionnées.',
        ES: 'Elige la sucursal que se aplicará a los pedidos seleccionados.',
        IT: 'Scegli la filiale da applicare agli ordini selezionati.'
    },
    chooseBranchForAddresses: {
        NL: 'Kies de vestiging die toegepast moet worden op de geselecteerde adressen.',
        EN: 'Choose the branch to apply to the selected addresses.',
        DE: 'Wählen Sie die Filiale, die auf die ausgewählten Adressen angewendet werden soll.',
        FR: 'Choisissez la succursale à appliquer aux adresses sélectionnées.',
        ES: 'Elige la sucursal que se aplicará a las direcciones seleccionadas.',
        IT: 'Scegli la filiale da applicare agli indirizzi selezionati.'
    },
    selectAtLeastOneBranch: {
        NL: 'Selecteer minimaal één vestiging.',
        EN: 'Select at least one branch.',
        DE: 'Wählen Sie mindestens eine Filiale aus.',
        FR: 'Sélectionnez au moins une succursale.',
        ES: 'Selecciona al menos una sucursal.',
        IT: 'Seleziona almeno una filiale.'
    },
    noBranch: {
        NL: 'Geen vestiging',
        EN: 'No branch',
        DE: 'Keine Filiale',
        FR: 'Aucune succursale',
        ES: 'Sin sucursal',
        IT: 'Nessuna filiale'
    },
    addBranch: {
        NL: 'Vestiging toevoegen',
        EN: 'Add branch',
        DE: 'Filiale hinzufügen',
        FR: 'Ajouter une succursale',
        ES: 'Agregar sucursal',
        IT: 'Aggiungi filiale'
    },
    removeBranch: {
        NL: 'Vestiging verwijderen',
        EN: 'Remove branch',
        DE: 'Filiale entfernen',
        FR: 'Supprimer la succursale',
        ES: 'Eliminar sucursal',
        IT: 'Rimuovi filiale'
    },
    newBranch: {
        NL: 'Nieuwe vestiging',
        EN: 'New branch',
        DE: 'Neue Filiale',
        FR: 'Nouvelle succursale',
        ES: 'Nueva sucursal',
        IT: 'Nuova filiale'
    },
    editBranch: {
        NL: 'Vestiging bewerken',
        EN: 'Edit branch',
        DE: 'Filiale bearbeiten',
        FR: 'Modifier la succursale',
        ES: 'Editar sucursal',
        IT: 'Modifica filiale'
    },
    deliveryZones: {
        NL: 'Bezorggebieden',
        EN: 'Delivery zones'
    },
    branchDeliveryZonesInfo: {
        NL: 'Ritten die in het bezorggebied liggen krijgen automatisch deze vestiging.',
        EN: 'Orders located in the delivery zone are automatically assigned this branch.'
    },
    recalculateDeliveryZoneIds: {
        NL: 'Bezorggebieden herberekenen',
        EN: 'Recalculate delivery zones'
    },
    recalculateDeliveryZoneIdsText: {
        NL: 'Bezorggebieden van de geselecteerde ritten worden herberekend.',
        EN: 'Delivery zones for the selected orders will be recalculated.'
    },
    applyLicenseStaffelMax: {
        NL: 'Bovengrens per staffel toepassen',
        EN: 'Apply upper limit per tier'
    },
    applyLicenseStaffelMaxInfo: {
        NL: 'Hoogt het aantal licenties op naar het startaantal van een hogere staffel als dat een lager totaalbedrag oplevert.',
        EN: 'Raises the number of licenses to the starting quantity of a higher tier when that results in a lower total.'
    },
    customsCurrency: {
        NL: 'Valuta',
        EN: 'Currency'
    },
    customsCurrencyInfo: {
        NL: 'Valuta van de waarde van alle artikelen voor de douane.',
        EN: 'Currency of the customs value of all items.'
    },
    customsCurrencyUnknown: {
        NL: ({currency}: {currency: string}) => `De valuta ${currency} wordt niet ondersteund voor de douanewaarde. Kies een valuta uit de lijst of reken het bedrag om naar euro.`,
        EN: ({currency}: {currency: string}) => `Currency ${currency} is not supported for the customs value. Choose a currency from the list or convert the amount to EUR.`
    },
    customsCurrencyNotSupportedByCarrier: {
        NL: ({currency, carrier}: {currency: string, carrier: string}) => `De valuta ${currency} kan niet aangemeld worden bij ${carrier}. Reken het bedrag zelf om naar euro.`,
        EN: ({currency, carrier}: {currency: string, carrier: string}) => `Currency ${currency} can't be registered with ${carrier}. Convert the amount to EUR.`
    },
    qlsProductNotAvailable: {
        NL: ({carrier, country}: {carrier: string, country: string}) => `Deze combinatie van verzendopties is bij ${carrier} via QLS niet beschikbaar voor zendingen naar ${country}.`,
        EN: ({carrier, country}: {carrier: string, country: string}) => `This combination of shipping options is not available with ${carrier} via QLS for parcels to ${country}.`
    },
    customsInformation: {
        NL: 'Douane informatie',
        EN: 'Customs information'
    },
    qlsProductNotActive: {
        NL: ({carrier}: {carrier: string}) => `Het ${carrier} product voor deze zending is niet actief in je QLS-account. Neem contact op met QLS om het te laten activeren.`,
        EN: ({carrier}: {carrier: string}) => `The ${carrier} product for this parcel is not active in your QLS account. Contact QLS to have it activated.`
    },
    qlsSenderCountryNotSupported: {
        NL: ({carrier}: {carrier: string}) => `Zendingen met ${carrier} via QLS kunnen alleen verstuurd worden vanaf een adres in Nederland of België.`,
        EN: ({carrier}: {carrier: string}) => `Parcels with ${carrier} via QLS can only be sent from an address in the Netherlands or Belgium.`
    },
    export: {
        NL: 'Exporteren',
        EN: 'Export',
        DE: 'Exportieren',
        FR: 'Exporter',
        ES: 'Exportar',
        IT: 'Esporta'
    },
    bundleStops: {
        NL: (count: number) => `${count} stops`,
        EN: (count: number) => `${count} stops`
    },
    showStops: {
        NL: 'Toon stops',
        EN: 'Show stops'
    },
    hideStops: {
        NL: 'Verberg stops',
        EN: 'Hide stops'
    },
    removeStop: {
        NL: 'Verwijder stop',
        EN: 'Remove stop'
    },
    removeStopConfirm: {
        NL: 'Weet je zeker dat je deze stop wilt verwijderen?',
        EN: 'Are you sure you want to remove this stop?'
    },
    principal: {
        NL: 'Opdrachtgever',
        EN: 'Principal'
    },
    consignor: {
        NL: 'Afzender',
        EN: 'Sender'
    },
    collectionAddress: {
        NL: 'Ophaaladres',
        EN: 'Pickup address'
    },
    recipient: {
        NL: 'Ontvanger',
        EN: 'Recipient'
    },
    noBarcode: {
        NL: 'Geen barcode',
        EN: 'No barcode'
    },
    scanRequired: {
        NL: 'Scan verplicht',
        EN: 'Scan required'
    },
    collectPackaging: {
        NL: 'Emballage ophalen',
        EN: 'Collect packaging'
    },
    maxImages: {
        NL: 'Je kunt maximaal 5 foto\'s toevoegen.',
        EN: 'You can add up to 5 photos.'
    },
    addBarcode: {
        NL: 'Barcode toevoegen',
        EN: 'Add barcode'
    },
    addBarcodeToWhichStop: {
        NL: (barcode: string) => `Bij welke stop hoort barcode ${barcode}?`,
        EN: (barcode: string) => `Which stop does barcode ${barcode} belong to?`
    },
    colliCount: {
        NL: (count: number) => `${count} ${count === 1 ? 'collo' : 'colli'}`,
        EN: (count: number) => `${count} ${count === 1 ? 'parcel' : 'parcels'}`
    },
    barcodeOfNotReadyStop: {
        NL: (name: string) => `Deze barcode hoort bij ${name}, deze stop is nog niet gereed.`,
        EN: (name: string) => `This barcode belongs to ${name}, this stop is not ready yet.`
    },
    attention: {
        NL: 'Let op!',
        EN: 'Attention!'
    },
    barcodeOfOtherAddress: {
        NL: 'De gescande barcode moet op een ander adres worden bezorgd. Wil je deze toevoegen?',
        EN: 'The scanned barcode has to be delivered at another address. Do you want to add it?'
    },
    barcodeNotOfStops: {
        NL: 'De gescande barcode komt niet overeen met de barcodes van deze stops. Wil je deze toevoegen?',
        EN: 'The scanned barcode does not match the barcodes of these stops. Do you want to add it?'
    },
    openAddress: {
        NL: 'Adres openen',
        EN: 'Open address'
    },
    addressInCurrentRoute: {
        NL: 'Adres in huidige route',
        EN: 'Address in current route'
    },
    barcodeOfAddressInCurrentRoute: {
        NL: 'Deze barcode hoort bij een ander adres in je huidige route.',
        EN: 'This barcode belongs to another address in your current route.'
    },
    neverAddPickupForAddress: {
        NL: 'Ophalen nooit toevoegen voor dit adres',
        EN: 'Never add pickup for this address'
    },
    neverAddDeliveryForAddress: {
        NL: 'Bezorging nooit toevoegen voor dit adres',
        EN: 'Never add delivery for this address'
    },
    addOrder: {
        NL: 'Rit toevoegen',
        EN: 'Add order'
    },
    pickupAddressNotInRoute: {
        NL: 'Deze zending hoort bij een ophaaladres dat niet in je route zit. Wil je dit adres toevoegen aan je route?',
        EN: 'This shipment belongs to a pickup address that is not in your route. Do you want to add this address to your route?'
    },
    deliveryAddressNotInRoute: {
        NL: 'Deze zending hoort bij een bezorgadres dat niet in je route zit. Wil je dit adres toevoegen aan je route?',
        EN: 'This shipment belongs to a delivery address that is not in your route. Do you want to add this address to your route?'
    },
    addOrderWithColli: {
        NL: (count: number) => `De rit waar deze collo in zit bevat in totaal ${count} colli. Deze worden allemaal toegevoegd aan jouw route. Weet je zeker dat je door wil gaan?`,
        EN: (count: number) => `The order of this parcel contains ${count} parcels in total. All of them will be added to your route. Are you sure you want to continue?`
    },
    addOrderToRouteConfirm: {
        NL: 'De rit waar deze collo toe behoort wordt toegevoegd aan je route. Weet je zeker dat je door wil gaan?',
        EN: 'The order of this parcel will be added to your route. Are you sure you want to continue?'
    },
    orderAddedToRoute: {
        NL: 'Rit toegevoegd aan route',
        EN: 'Order added to route'
    },
    noColloForBarcode: {
        NL: (barcode: string) => `Geen collo gevonden voor barcode: ${barcode}`,
        EN: (barcode: string) => `No parcel found for barcode: ${barcode}`
    },
    editOptions: {
        NL: 'Opties wijzigen',
        EN: 'Edit options'
    },
    allStops: {
        NL: 'Alle stops',
        EN: 'All stops'
    },
    oneStop: {
        NL: 'Eén stop',
        EN: 'One stop'
    },
    chooseStop: {
        NL: 'Kies de stop',
        EN: 'Choose the stop'
    },
    addImage: {
        NL: 'Voeg een foto toe',
        EN: 'Add a photo'
    },
    fillInPackagingStatus: {
        NL: 'Vul de status van alle emballage in',
        EN: 'Fill in the status of all packaging'
    },
    fillInComment: {
        NL: 'Vul een opmerking in',
        EN: 'Fill in a comment'
    },
    verificationCodeOfStopIncorrect: {
        NL: (name: string) => `Verificatiecode van ${name} is onjuist`,
        EN: (name: string) => `Verification code of ${name} is incorrect`
    },
    checkRecipientId: {
        NL: 'Controleer id van ontvanger',
        EN: 'Check the ID of the recipient'
    },
    checkRecipientAge: {
        NL: 'Controleer leeftijd van ontvanger',
        EN: 'Check the age of the recipient'
    },
    fillInRecipientName: {
        NL: 'Vul naam van ontvanger in',
        EN: 'Fill in the name of the recipient'
    },
    fillInHouseNumber: {
        NL: 'Vul een huisnummer in',
        EN: 'Fill in a house number'
    },
    notDeliveredInMailboxConfirm: {
        NL: 'Je gaat deze zending niet in de brievenbus bezorgen, wil je doorgaan?',
        EN: 'You are not delivering this shipment in the mailbox, do you want to continue?'
    },
    submitPreparing: {
        NL: 'Voorbereiden',
        EN: 'Preparing'
    },
    submitGettingLocation: {
        NL: 'Huidige locatie ophalen',
        EN: 'Getting current location'
    },
    submitCalculatingDistance: {
        NL: 'Afstand tot bestemming berekenen',
        EN: 'Calculating distance to destination'
    },
    submitWaitingForConfirmation: {
        NL: 'Bevestiging op afwijkende locatie afwachten',
        EN: 'Waiting for confirmation at a different location'
    },
    submitWaitingForServer: {
        NL: 'Wachten op serverbevestiging',
        EN: 'Waiting for server confirmation'
    },
    submitBusy: {
        NL: (process: string) => `Bezig met afhandelen: ${process}`,
        EN: (process: string) => `Handling: ${process}`
    },
    outsideDeliveryRadiusNotAllowed: {
        NL: (radius: number) => `Je bevind je niet binnen ${radius} meter van je bestemming, bezorging kan niet worden voltooid.`,
        EN: (radius: number) => `You are not within ${radius} meters of your destination, the delivery cannot be completed.`
    },
    outsideDeliveryRadiusWarning: {
        NL: (radius: number) => `Je bevind je niet binnen ${radius} meter van je bestemming, wil je doorgaan met de bezorging?`,
        EN: (radius: number) => `You are not within ${radius} meters of your destination, do you want to continue the delivery?`
    },
    gpsRequired: {
        NL: 'GPS verplicht',
        EN: 'GPS required'
    },
    gpsRequiredText: {
        NL: 'Voor deze stops is GPS verplicht, druk op Help voor instructies om toegang tot locatie toe te staan.',
        EN: 'GPS is required for these stops, press Help for instructions to allow access to your location.'
    },
    goBack: {
        NL: 'Terug gaan',
        EN: 'Go back'
    },
    goBackConfirm: {
        NL: 'Weet je zeker dat je terug wil gaan? Gegevens bij dit adres worden niet opgeslagen.',
        EN: 'Are you sure you want to go back? Data at this address will not be saved.'
    },
    pickupAction: {
        NL: 'Ophalen',
        EN: 'Pick up'
    },
    deliverAction: {
        NL: 'Bezorgen',
        EN: 'Deliver'
    },
    deliverRetourAction: {
        NL: 'Retour bezorgen',
        EN: 'Deliver return'
    },
    addressCopied: {
        NL: 'Adres gekopieerd',
        EN: 'Address copied'
    },
    addAddress: {
        NL: 'Adres toevoegen',
        EN: 'Add address'
    },
    addressCount: {
        NL: (count: number) => `${count} ${count === 1 ? 'adres' : 'adressen'}`,
        EN: (count: number) => `${count} ${count === 1 ? 'address' : 'addresses'}`
    },
    pickupNotPossible: {
        NL: 'Ophalen niet mogelijk',
        EN: 'Pickup not possible'
    },
    deliveryNotPossible: {
        NL: 'Bezorgen niet mogelijk',
        EN: 'Delivery not possible'
    },
    noSharedReasons: {
        NL: 'Geen gezamenlijke reden voor deze stops. Handel de stops los af.',
        EN: 'No shared reason for these stops. Handle the stops separately.'
    },
    pxAtAddress: {
        NL: 'Op dit adres ligt een Px om op te halen',
        EN: 'There is a Px to collect at this address'
    },
    lastDeliveryAttempt: {
        NL: 'Laatste bezorgpoging',
        EN: 'Last delivery attempt'
    },
    mailboxParcel: {
        NL: 'Brievenbuspakket',
        EN: 'Mailbox parcel'
    },
    transportRefrigerated: {
        NL: 'Gekoeld vervoeren',
        EN: 'Transport refrigerated'
    },
    notAtNeighbors: {
        NL: 'Niet bij buren bezorgen',
        EN: 'Do not deliver at neighbors'
    },
    attentionOf: {
        NL: 't.a.v.',
        EN: 'attn.'
    },
    reason: {
        NL: 'Reden',
        EN: 'Reason'
    },
    specification: {
        NL: 'Specificatie',
        EN: 'Specification'
    },
    deliveredAtNeighbors: {
        NL: 'Bezorgd bij buren',
        EN: 'Delivered at neighbors'
    },
    deliveredInMailbox: {
        NL: 'Bezorgd in brievenbus',
        EN: 'Delivered in mailbox'
    },
    deliveredAtSafePlace: {
        NL: 'Bezorgd op veilige plek',
        EN: 'Delivered at safe place'
    },
    addSafePlaceImage: {
        NL: 'Maak een foto van het pakket op de veilige plek',
        EN: 'Take a photo of the parcel at the safe place'
    },
    recipientWantsSafePlace: {
        NL: (place: string) => `Ontvanger wil het pakket op een veilige plek: ${place}`,
        EN: (place: string) => `Recipient wants the parcel at a safe place: ${place}`
    },
    recipientWantsNeighbour: {
        NL: (nr: string) => `Ontvanger wil bezorging bij de buren: huisnummer ${nr}`,
        EN: (nr: string) => `Recipient wants delivery at the neighbours: house number ${nr}`
    },
    recipientInstructions: {
        NL: (instructions: string) => `Instructie van de ontvanger: ${instructions}`,
        EN: (instructions: string) => `Instruction from the recipient: ${instructions}`
    },
    houseNumber: {
        NL: 'Huisnummer',
        EN: 'House number'
    },
    recipientName: {
        NL: 'Naam ontvanger',
        EN: 'Name of recipient'
    },
    idCheck: {
        NL: 'ID check',
        EN: 'ID check'
    },
    documentNumber: {
        NL: 'Documentnummer',
        EN: 'Document number'
    },
    lastFourCharacters: {
        NL: 'Laatste 4 tekens',
        EN: 'Last 4 characters'
    },
    verificationCode: {
        NL: 'Verificatiecode',
        EN: 'Verification code'
    },
    codeOfStop: {
        NL: (name: string) => `Code ${name}`,
        EN: (name: string) => `Code ${name}`
    },
    ageCheck: {
        NL: 'Leeftijdscheck',
        EN: 'Age check'
    },
    recipientOlderThan: {
        NL: (age: number) => `Ontvanger is ouder dan ${age}`,
        EN: (age: number) => `Recipient is older than ${age}`
    },
    bornBefore: {
        NL: (date: string) => `Geboren voor ${date}`,
        EN: (date: string) => `Born before ${date}`
    },
    colli: {
        NL: 'Colli',
        EN: 'Parcels'
    },
    scan: {
        NL: 'Scannen',
        EN: 'Scan'
    },
    photo: {
        NL: 'Foto',
        EN: 'Photo'
    },
    signature: {
        NL: 'Handtekening',
        EN: 'Signature'
    },
    delivered: {
        NL: 'Bezorgd',
        EN: 'Delivered'
    },
    refused: {
        NL: 'Geweigerd',
        EN: 'Refused'
    },
    notDelivered: {
        NL: 'Niet bezorgd',
        EN: 'Not delivered'
    },
    invoiceTogether: {
        NL: 'Gezamenlijk factureren',
        EN: 'Invoice together'
    },
    invoiceForCustomers: {
        NL: 'Factureer ook voor deze klanten',
        EN: 'Also invoice for these customers'
    },
    invoiceForCustomersInfo: {
        NL: 'Kies welke andere klantaccounts meegefactureerd worden op de factuur van deze klant. Gekoppelde accounts nemen de administratie-instellingen van deze klant over en krijgen geen eigen factuur meer.',
        EN: 'Choose which other customer accounts are invoiced on the invoice of this customer. Linked accounts take over the administration settings of this customer and no longer get an invoice of their own.'
    },
    invoicedViaMainCustomer: {
        NL: 'Deze klant wordt gefactureerd via',
        EN: 'This customer is invoiced via'
    },
    minimumRevenueCombined: {
        NL: 'Berekenen over',
        EN: 'Calculate over'
    },
    minimumRevenuePerCustomer: {
        NL: 'Per klant afzonderlijk',
        EN: 'Each customer separately'
    },
    minimumRevenueAllCustomers: {
        NL: 'Alle gekoppelde klanten samen',
        EN: 'All linked customers together'
    },
    linkBarcodeNoBarcode: {
        NL: 'Geen barcode',
        EN: 'No barcode'
    },
    linkBarcodeNewBarcode: {
        NL: 'Nieuwe barcode',
        EN: 'New barcode'
    },
    linkBarcodeChooseText: {
        NL: 'Kies hier of de barcode aan een collo gekoppeld moet worden of als nieuwe collo moet worden toegevoegd.',
        EN: 'Choose whether the barcode should be linked to a parcel or added as a new parcel.'
    },
    linkBarcodeToKnownCollo: {
        NL: 'Koppelen aan bekende collo',
        EN: 'Link to known parcel'
    },
    linkBarcodeAddNewCollo: {
        NL: 'Toevoegen nieuwe collo',
        EN: 'Add new parcel'
    },
    linkBarcodeWarningTitle: {
        NL: 'Let op!',
        EN: 'Attention!'
    },
    linkBarcodeLink: {
        NL: 'Barcode koppelen',
        EN: 'Link barcode'
    },
    linkBarcodeAddCollo: {
        NL: 'Collo toevoegen',
        EN: 'Add parcel'
    },
    linkBarcodeColliType: {
        NL: 'Collo type',
        EN: 'Parcel type'
    },
    linkBarcodeDescription: {
        NL: 'Omschrijving',
        EN: 'Description'
    },
    scannedBarcodeNoMatchDelivery: {
        NL: 'De gescande barcode komt niet overeen met de barcode van deze bezorging. Kies hieronder om de collo toe te voegen of klik op annuleren.',
        EN: 'The scanned barcode does not match the barcode of this delivery. Choose below to add the parcel or click cancel.'
    },
    scannedBarcodeNoMatchPickup: {
        NL: 'De gescande barcode komt niet overeen met de barcode van deze pickup. Kies hieronder om de collo toe te voegen of klik op annuleren.',
        EN: 'The scanned barcode does not match the barcode of this pickup. Choose below to add the parcel or click cancel.'
    },
    intrapostEnvelopeRegisterAs: {
        NL: 'Envelop aanmelden als',
        EN: 'Register envelope as'
    },
    intrapostEnvelopeNoTrackTraceInfo: {
        NL: 'Voor poststukken is geen track & trace beschikbaar.',
        EN: 'Track & trace is not available for mail pieces.'
    },
    intrapostEnvelopeProductStandard: {
        NL: 'Post Standaard (24-uurs)',
        EN: 'Mail Standard (24-hour)'
    },
    intrapostEnvelopeProductFixedDays: {
        NL: 'Post Vast (48/72-uurs)',
        EN: 'Mail Fixed (48/72-hour)'
    },
    intrapostCustomerLogosTitle: {
        NL: 'Logo\'s voor klanten',
        EN: 'Logos for customers'
    },
    intrapostCustomerLogosInfo: {
        NL: 'Intrapost bepaalt of een zending door DHL of een andere vervoerder wordt bezorgd. Voeg per verzendoptie toe welk logo je klanten zien. Voor verzendopties zonder eigen logo wordt het standaard logo getoond.',
        EN: 'Intrapost determines whether a shipment is delivered by DHL or another carrier. Add which logo your customers see per shipping option. For options without a specific logo, the default logo is shown.'
    },
    intrapostDefaultLogo: {
        NL: 'Standaard logo',
        EN: 'Default logo'
    },
    intrapostAddShippingOption: {
        NL: 'Verzendoptie toevoegen',
        EN: 'Add shipping option'
    },
    intrapostChooseShippingOption: {
        NL: 'Kies een verzendoptie',
        EN: 'Choose a shipping option'
    },
    noColloFoundForBarcode: {
        NL: (barcode: string) => `Geen collo gevonden voor barcode: ${barcode}`,
        EN: (barcode: string) => `No parcel found for barcode: ${barcode}`
    },
    partnerOutgoingTitle: {
        NL: 'Ritten aanmelden bij partners',
        EN: 'Forwarding orders to partners'
    },
    partnerOutgoingInfo: {
        NL: 'Partners waar je ritten naartoe kunt doorzetten.',
        EN: 'Partners you can forward orders to.'
    },
    partnerIncomingTitle: {
        NL: 'Ritten ontvangen van partners',
        EN: 'Receiving orders from partners'
    },
    partnerIncomingInfo: {
        NL: 'Partners die ritten bij jou kunnen aanmelden.',
        EN: 'Partners that can forward orders to you.'
    },
    partnerAdd: {
        NL: 'Partner toevoegen',
        EN: 'Add partner'
    },
    partnerIntro: {
        NL: 'Wissel ritten uit met andere Veloyd vervoerders. Voeg een partner toe met de API key van die partner en kies of je ritten wilt aanmelden bij de partner, ritten van de partner wilt ontvangen, of beide.',
        EN: 'Exchange orders with other Veloyd carriers. Add a partner with the API key of that partner and choose whether you want to forward orders to the partner, receive orders from the partner, or both.'
    },
    partnerOwnKeyTitle: {
        NL: 'Eigen API key partnerkoppelingen',
        EN: 'Own API key for partner connections'
    },
    partnerOwnKeyInfo: {
        NL: 'Deel deze API key met partner vervoerders. Deze API key is niet bedoeld voor koppelingen voor klanten of webshops.',
        EN: 'Share this API key with partner carriers. This API key is not meant for connections of customers or webshops.'
    },
    partnerDefaultSettingsInfo: {
        NL: 'Deze instellingen gelden voor alle partners, tenzij je bij een partner iets anders instelt.',
        EN: 'These settings apply to all partners, unless you set something different for a partner.'
    },
    partnerApiKeyLabel: {
        NL: 'API key van de partner',
        EN: 'API key of the partner'
    },
    partnerStatusActive: {
        NL: 'Actief',
        EN: 'Active'
    },
    partnerStatusRequested: {
        NL: 'Verzoek verstuurd',
        EN: 'Request sent'
    },
    partnerStatusPending: {
        NL: 'Verzoek ontvangen',
        EN: 'Request received'
    },
    partnerStatusInactive: {
        NL: 'Inactief',
        EN: 'Inactive'
    },
    partnerStatusRejected: {
        NL: 'Verzoek afgewezen',
        EN: 'Request rejected'
    },
    partnerRequestTitle: {
        NL: 'Partner verzoek versturen',
        EN: 'Send partner request'
    },
    partnerRequestText: {
        NL: 'Kies of je ritten wilt aanmelden bij deze partner, ritten van deze partner wilt ontvangen, of beide.',
        EN: 'Choose whether you want to forward orders to this partner, receive orders from this partner, or both.'
    },
    partnerDirectionLabel: {
        NL: 'Richting',
        EN: 'Direction'
    },
    partnerDirectionBoth: {
        NL: 'Ritten aanmelden bij en ontvangen van partner (beide)',
        EN: 'Forward orders to and receive orders from partner (both)'
    },
    partnerDirectionOutgoing: {
        NL: 'Ritten aanmelden bij partner (uitgaand)',
        EN: 'Forward orders to partner (outgoing)'
    },
    partnerDirectionIncoming: {
        NL: 'Ritten ontvangen van partner (inkomend)',
        EN: 'Receive orders from partner (incoming)'
    },
    partnerDirectionAlreadyConnected: {
        NL: 'Er is al een koppeling of verzoek voor deze richting',
        EN: 'There already is a connection or request for this direction'
    },
    partnerAcceptRequestText: {
        NL: (directions: string) => `Weet je zeker dat je dit verzoek wilt accepteren? Het verzoek geldt voor: ${directions}.`,
        EN: (directions: string) => `Are you sure you want to accept this request? The request is for: ${directions}.`
    },
    partnerRejectRequestText: {
        NL: (directions: string) => `Weet je zeker dat je dit verzoek wilt afwijzen? Het verzoek geldt voor: ${directions}.`,
        EN: (directions: string) => `Are you sure you want to reject this request? The request is for: ${directions}.`
    },
    partnerOutgoingSection: {
        NL: (name: string) => `Aanmelden bij ${name}`,
        EN: (name: string) => `Forwarding to ${name}`
    },
    partnerIncomingSection: {
        NL: (name: string) => `Ontvangen van ${name}`,
        EN: (name: string) => `Receiving from ${name}`
    },
    partnerDefaultOutgoingSection: {
        NL: 'Aanmelden bij partners',
        EN: 'Forwarding to partners'
    },
    partnerDefaultIncomingSection: {
        NL: 'Ontvangen van partners',
        EN: 'Receiving from partners'
    },
    partnerDeactivateOutgoingText: {
        NL: (name: string) => `Weet je zeker dat je het aanmelden van ritten bij ${name} wilt deactiveren? Ritten die nog niet zijn afgerond worden bij ${name} geannuleerd en weer actief bij jou.`,
        EN: (name: string) => `Are you sure you want to stop forwarding orders to ${name}? Orders that are not completed yet are cancelled at ${name} and active again at your account.`
    },
    partnerDeactivateIncomingText: {
        NL: (name: string) => `Weet je zeker dat je het ontvangen van ritten van ${name} wilt deactiveren? Ritten die nog niet zijn afgerond worden bij jou geannuleerd en weer actief bij ${name}.`,
        EN: (name: string) => `Are you sure you want to stop receiving orders from ${name}? Orders that are not completed yet are cancelled at your account and active again at ${name}.`
    },
    partnerDeactivateTitle: {
        NL: 'Partner koppeling deactiveren',
        EN: 'Deactivate partner connection'
    },
    partnerConnections: {
        NL: 'Partner koppelingen',
        EN: 'Partner connections'
    },
    partnerDefaultSettings: {
        NL: 'Standaard instellingen',
        EN: 'Default settings'
    },
    partnerCancelRequest: {
        NL: 'Verzoek annuleren',
        EN: 'Cancel request'
    },
    partnerCancelRequestTitle: {
        NL: 'Partner verzoek annuleren',
        EN: 'Cancel partner request'
    },
    partnerCancelRequestText: {
        NL: 'Weet je zeker dat je dit verzoek wilt annuleren?',
        EN: 'Are you sure you want to cancel this request?'
    },
    partnerReceivedRequestTitle: {
        NL: 'Partner verzoek',
        EN: 'Partner request'
    },
    partnerAcceptRequest: {
        NL: 'Accepteer',
        EN: 'Accept'
    },
    partnerRejectRequest: {
        NL: 'Afwijzen',
        EN: 'Reject'
    },
    partnerNewRequest: {
        NL: 'Nieuw verzoek',
        EN: 'New request'
    },
    partnerRemoveTitle: {
        NL: 'Partner verwijderen',
        EN: 'Remove partner'
    },
    partnerRemoveText: {
        NL: 'Weet je zeker dat je deze partner wilt verwijderen?',
        EN: 'Are you sure you want to remove this partner?'
    },
    copiedToClipboard: {
        NL: 'Gekopieerd naar clipboard',
        EN: 'Copied to clipboard'
    },
    partnerShowScanColor: {
        NL: 'Kleur tonen bij scannen',
        EN: 'Show color when scanning'
    },
    partnerShowScanColorInfo: {
        NL: 'Bij meerdere vervoerders met hetzelfde logo kan het handig zijn om tijdens het scannen een kleur te zien voor snelle herkenning',
        EN: 'With multiple carriers with the same logo it can be useful to see a color while scanning for quick recognition'
    },
    partnerCreditorCode: {
        NL: 'Crediteurnummer',
        EN: 'Creditor number'
    },
    partnerCreditorCodeInfo: {
        NL: 'Hier kun je het crediteurnummer invullen dat wordt gebruikt in je boekhouding voor deze vervoerder',
        EN: 'Enter the creditor number used in your accounting for this carrier'
    },
    partnerOrderSettings: {
        NL: 'Rit instellingen',
        EN: 'Order settings'
    },
    partnerCommunication: {
        NL: 'Gebruik communicatie van',
        EN: 'Use communication of'
    },
    partnerAllowEditOrder: {
        NL: 'Mag partner de rit bewerken',
        EN: 'Partner may edit the order'
    },
    partnerAddressOnly: {
        NL: 'Alleen adres en colli',
        EN: 'Address and colli only'
    },
    partnerAutoForwardOrders: {
        NL: 'Ritten automatisch doorzetten',
        EN: 'Forward orders automatically'
    },
    partnerAutoForwardOrdersInfo: {
        NL: 'Zet deze optie aan wanneer je wil dat ritten automatisch worden doorgezet naar de partner. Je kan ritten altijd handmatig doorzetten naar een partner.',
        EN: 'Turn this option on when you want orders to be forwarded to the partner automatically. You can always forward orders to a partner manually.'
    },
    partnerShowRouteInfo: {
        NL: 'Toon route informatie aan partner',
        EN: 'Show route information to partner'
    },
    partnerShowRouteInfoInfo: {
        NL: 'De partner ziet de route informatie tijdens het scannen, hierdoor kunnen pakketten meteen op route gesorteerd worden.',
        EN: 'The partner sees the route information while scanning, so parcels can be sorted by route right away.'
    },
    partnerAdditionalPostalCodes: {
        NL: '(Aanvullende) postcodes',
        EN: '(Additional) postal codes'
    },
    partnerIncomingPostalCodesInfo: {
        NL: 'De postcodes waar je ritten van partners wilt ontvangen, naast de bezorggebieden. Gebruik een komma om postcodes te scheiden en een streepje om een reeks te noteren. Postcodes kunnen mét of zónder letters gekozen worden. Bijvoorbeeld: 1000-2000, 3000, 4000AA-4000ZZ',
        EN: 'The postal codes where you want to receive orders from partners, in addition to the delivery zones. Use a comma to separate postal codes and a dash for a range. Postal codes can be chosen with or without letters. For example: 1000-2000, 3000, 4000AA-4000ZZ'
    },
    partnerIncomingPartnerPostalCodesInfo: {
        NL: 'De postcodes waar je ritten van deze partner wilt ontvangen, naast de bezorggebieden. Gebruik een komma om postcodes te scheiden en een streepje om een reeks te noteren. Postcodes kunnen mét of zónder letters gekozen worden. Bijvoorbeeld: 1000-2000, 3000, 4000AA-4000ZZ',
        EN: 'The postal codes where you want to receive orders from this partner, in addition to the delivery zones. Use a comma to separate postal codes and a dash for a range. Postal codes can be chosen with or without letters. For example: 1000-2000, 3000, 4000AA-4000ZZ'
    },
    partnerMaxDimensions: {
        NL: 'Maximum dimensies',
        EN: 'Maximum dimensions'
    },
    partnerMaxLength: {
        NL: 'Maximale lengte',
        EN: 'Maximum length'
    },
    partnerMaxWidth: {
        NL: 'Maximale breedte',
        EN: 'Maximum width'
    },
    partnerMaxHeight: {
        NL: 'Maximale hoogte',
        EN: 'Maximum height'
    },
    partnerMaxWeight: {
        NL: 'Maximaal gewicht',
        EN: 'Maximum weight'
    },
    partnerMaxVolume: {
        NL: 'Maximaal volume',
        EN: 'Maximum volume'
    },
    partnerUseDefault: {
        NL: 'Gebruik standaard instelling',
        EN: 'Use default setting'
    },
    partnerOwnDeliveryZone: {
        NL: 'Eigen bezorggebied',
        EN: 'Own delivery zone'
    },
    partnerCustomDeliveryZone: {
        NL: 'Afwijkend bezorggebied',
        EN: 'Different delivery zone'
    },
    partnerUseRestrictedDeliveryZone: {
        NL: 'Gebruik beperkt bezorggebied',
        EN: 'Use restricted delivery zone'
    },
    partnerNoDeliveryZones: {
        NL: 'Geen bezorggebieden gevonden. Stel bezorggebieden in via Instellingen > Algemeen > Bezorggebieden.',
        EN: 'No delivery zones found. Set up delivery zones in Settings > General > Delivery zones.'
    },
    partnerDeactivate: {
        NL: 'Deactiveer',
        EN: 'Deactivate'
    },
    partnerPartner: {
        NL: 'Partner',
        EN: 'Partner'
    },
    partnerUseDefaultValue: {
        NL: (value: string) => `Gebruik standaard instelling (${value})`,
        EN: (value: string) => `Use default setting (${value})`
    },
    partnerDeliveryZoneOf: {
        NL: (name: string) => `Bezorggebied van ${name}`,
        EN: (name: string) => `Delivery zone of ${name}`
    },
    partnerAdditionalPostalCodesOf: {
        NL: (name: string) => `Aanvullende postcodes van ${name}`,
        EN: (name: string) => `Additional postal codes of ${name}`
    },
    partnerPostalCodesOf: {
        NL: (name: string) => `Postcodes van ${name}`,
        EN: (name: string) => `Postal codes of ${name}`
    },
    partnerAllowEditOrderOf: {
        NL: (name: string) => `Mag ${name} de rit bewerken`,
        EN: (name: string) => `May ${name} edit the order`
    },
    partnerRestrictedDeliveryZoneInfo: {
        NL: (name: string) => `Beperk het gebied waarin ritten naar ${name} worden doorgezet tot een selectie van je eigen bezorggebieden en/of postcodes. Wil je een kleiner gebied? Klik dan op het polygon- of cirkel-icoon op de kaart om een nieuw bezorggebied te tekenen.`,
        EN: (name: string) => `Restrict the area in which orders are forwarded to ${name} to a selection of your own delivery zones and/or postal codes. Want a smaller area? Click the polygon or circle icon on the map to draw a new delivery zone.`
    },
    partnerRestrictedDeliveryZoneText: {
        NL: (name: string) => `Ritten worden alleen doorgezet naar ${name} wanneer ze zowel in het bezorggebied van de partner als in een van de geselecteerde eigen bezorggebieden of postcodes liggen. Op de kaart zie je waar deze gebieden overlappen.`,
        EN: (name: string) => `Orders are only forwarded to ${name} when they are both in the delivery zone of the partner and in one of the selected own delivery zones or postal codes. The map shows where these areas overlap.`
    },
    partnerOutgoingPostalCodesInfo: {
        NL: (name: string) => `De postcodes waarin ritten naar ${name} mogen worden doorgezet, naast de geselecteerde bezorggebieden. Gebruik een komma om postcodes te scheiden en een streepje om een reeks te noteren. Postcodes kunnen mét of zónder letters gekozen worden. Bijvoorbeeld: 1000-2000, 3000, 4000AA-4000ZZ`,
        EN: (name: string) => `The postal codes in which orders may be forwarded to ${name}, in addition to the selected delivery zones. Use a comma to separate postal codes and a dash for a range. Postal codes can be chosen with or without letters. For example: 1000-2000, 3000, 4000AA-4000ZZ`
    },
    partnerDefaultDeliveryZoneText: {
        NL: (name: string) => `Kies hier in welke bezorggebieden partners ritten mogen aanmelden voor ${name}. Klik op het polygon- of cirkel-icoon op de kaart om een nieuw bezorggebied te tekenen.`,
        EN: (name: string) => `Choose in which delivery zones partners may forward orders to ${name}. Click the polygon or circle icon on the map to draw a new delivery zone.`
    },
    partnerDeliveryZoneText: {
        NL: ({partnerName, name}: {partnerName: string, name: string}) => `Kies hier in welke bezorggebieden ${partnerName} ritten mag aanmelden voor ${name}. Klik op het polygon- of cirkel-icoon op de kaart om een nieuw bezorggebied te tekenen.`,
        EN: ({partnerName, name}: {partnerName: string, name: string}) => `Choose in which delivery zones ${partnerName} may forward orders to ${name}. Click the polygon or circle icon on the map to draw a new delivery zone.`
    },
    partnerNewDeliveryZoneTitle: {
        NL: 'Nieuw bezorggebied',
        EN: 'New delivery zone'
    },
    partnerNewDeliveryZoneText: {
        NL: 'Het bezorggebied wordt toegevoegd aan je eigen bezorggebieden (instellingen > Algemeen > Bezorggebieden).',
        EN: 'The delivery zone is added to your own delivery zones (settings > General > Delivery zones).'
    },
    partnerSendToPartner: {
        NL: 'Doorzetten naar partner',
        EN: 'Forward to partner'
    },
    partnerSendToPartnerText: {
        NL: 'Selecteer de partners waar de ritten naar mogen worden doorgezet. Bij meerdere partners wordt elke rit doorgezet naar de eerste partner die de rit kan uitvoeren, in de volgorde waarin je ze selecteert. Ritten kunnen altijd worden teruggehaald naar je eigen account.',
        EN: 'Select the partners the orders may be forwarded to. With multiple partners, each order is forwarded to the first partner that can carry out the order, in the order in which you select them. Orders can always be taken back to your own account.'
    },
    partnerTakeBackTo: {
        NL: (name: string) => `Terughalen naar ${name}`,
        EN: (name: string) => `Take back to ${name}`
    },
    partnerTakeBackWithoutNetwork: {
        NL: 'De netwerkmodule is niet beschikbaar voor je account. De geselecteerde ritten die bij een partner liggen worden teruggehaald naar je eigen account.',
        EN: 'The network module is not available for your account. The selected orders that are with a partner are taken back to your own account.'
    },
    partnerCarriers: {
        NL: 'Vervoerders',
        EN: 'Carriers'
    },
    partnerSelectCarrier: {
        NL: 'Selecteer minimaal één vervoerder.',
        EN: 'Select at least one carrier.'
    },
    conditions: {
        NL: 'Voorwaarden',
        EN: 'Conditions'
    },
    partnerCustomConditions: {
        NL: 'Eigen voorwaarden',
        EN: 'Custom conditions'
    },
    partnerOutgoingConditions: {
        NL: 'Voorwaarden voor doorzetten',
        EN: 'Conditions for forwarding'
    },
    partnerOutgoingConditionsInfo: {
        NL: (name: string) => `Alleen ritten die aan deze voorwaarden voldoen, kun je doorzetten naar ${name}, automatisch of handmatig. Zonder voorwaarden geldt alleen het bezorggebied.`,
        EN: (name: string) => `Only orders that meet these conditions can be forwarded to ${name}, automatically or manually. Without conditions only the delivery zone applies.`
    },
    partnerIncomingConditions: {
        NL: 'Voorwaarden voor ontvangen',
        EN: 'Conditions for receiving'
    },
    partnerIncomingConditionsInfo: {
        NL: (name: string) => `Je ontvangt alleen ritten van ${name} die aan deze voorwaarden voldoen. Zonder voorwaarden gelden alleen je bezorggebied en de maximum dimensies.`,
        EN: (name: string) => `You only receive orders from ${name} that meet these conditions. Without conditions only your delivery zone and the maximum dimensions apply.`
    },
    partnerDefaultOutgoingConditionsInfo: {
        NL: 'Alleen ritten die aan deze voorwaarden voldoen, kun je doorzetten naar een partner, automatisch of handmatig. Ze gelden voor elke partner die de standaard instelling gebruikt. Zonder voorwaarden geldt alleen het bezorggebied.',
        EN: 'Only orders that meet these conditions can be forwarded to a partner, automatically or manually. They apply to every partner that uses the default setting. Without conditions only the delivery zone applies.'
    },
    partnerDefaultIncomingConditionsInfo: {
        NL: 'Je ontvangt alleen ritten van een partner die aan deze voorwaarden voldoen. Ze gelden voor elke partner die de standaard instelling gebruikt. Zonder voorwaarden gelden alleen je bezorggebied en de maximum dimensies.',
        EN: 'You only receive orders from a partner that meet these conditions. They apply to every partner that uses the default setting. Without conditions only your delivery zone and the maximum dimensions apply.'
    },
    partnerOrderNotMatchingConditions: {
        NL: ({trackTrace, name}: {trackTrace: string, name: string}) => `${trackTrace}: Rit voldoet niet aan de voorwaarden van ${name}`,
        EN: ({trackTrace, name}: {trackTrace: string, name: string}) => `${trackTrace}: Order does not meet the conditions of ${name}`
    },
    partnerOrderNotMatchingConditionsOfCarriers: {
        NL: ({trackTrace}: {trackTrace: string}) => `${trackTrace}: Rit voldoet niet aan de voorwaarden van de gekozen vervoerders`,
        EN: ({trackTrace}: {trackTrace: string}) => `${trackTrace}: Order does not meet the conditions of the selected carriers`
    },
    conditionAllIn: {
        NL: 'Alle in',
        EN: 'All in'
    },
    conditionContainsAll: {
        NL: 'Bevat alle',
        EN: 'Contains all'
    },
    conditionAnyOf: {
        NL: 'Een van',
        EN: 'One of'
    },
    conditionNoneOf: {
        NL: 'Geen van',
        EN: 'None of'
    },
    conditionEqInfo: {
        NL: 'De waarde van de rit of zending is gelijk aan de ingevulde waarde.',
        EN: 'The value of the order or parcel is equal to the entered value.'
    },
    conditionNeqInfo: {
        NL: 'De waarde van de rit of zending is niet gelijk aan de ingevulde waarde.',
        EN: 'The value of the order or parcel is not equal to the entered value.'
    },
    conditionTextEqInfo: {
        NL: 'De tekst is gelijk aan de ingevulde tekst, hoofdletters en spaties aan het begin en eind tellen niet mee. Bij een tekst per stop (zoals straat of plaats) moet de tekst van minstens één stop gelijk zijn.',
        EN: 'The text is equal to the entered text, capitals and spaces at the start and end do not count. With a text per stop (such as street or city) the text of at least one stop must be equal.'
    },
    conditionTextNeqInfo: {
        NL: 'De tekst is niet gelijk aan de ingevulde tekst, hoofdletters en spaties aan het begin en eind tellen niet mee. Bij een tekst per stop (zoals straat of plaats) mag de tekst van geen enkele stop gelijk zijn.',
        EN: 'The text is not equal to the entered text, capitals and spaces at the start and end do not count. With a text per stop (such as street or city) the text of no stop may be equal.'
    },
    conditionLtInfo: {
        NL: 'De waarde van de rit of zending is kleiner dan de ingevulde waarde, bijv. kleiner dan 10: 9 voldoet, 10 niet.',
        EN: 'The value of the order or parcel is less than the entered value, e.g. less than 10: 9 matches, 10 does not.'
    },
    conditionLteInfo: {
        NL: 'De waarde van de rit of zending is kleiner dan of gelijk aan de ingevulde waarde, bijv. kleiner of gelijk aan 10: 10 voldoet, 11 niet.',
        EN: 'The value of the order or parcel is less than or equal to the entered value, e.g. less than or equal to 10: 10 matches, 11 does not.'
    },
    conditionGtInfo: {
        NL: 'De waarde van de rit of zending is groter dan de ingevulde waarde, bijv. groter dan 10: 11 voldoet, 10 niet.',
        EN: 'The value of the order or parcel is greater than the entered value, e.g. greater than 10: 11 matches, 10 does not.'
    },
    conditionGteInfo: {
        NL: 'De waarde van de rit of zending is groter dan of gelijk aan de ingevulde waarde, bijv. groter of gelijk aan 10: 10 voldoet, 9 niet.',
        EN: 'The value of the order or parcel is greater than or equal to the entered value, e.g. greater than or equal to 10: 10 matches, 9 does not.'
    },
    conditionTimeLtInfo: {
        NL: 'Het tijdstip is eerder dan de ingevulde tijd, bijv. kleiner dan 12:00: 11:59 voldoet, 12:00 niet.',
        EN: 'The time is earlier than the entered time, e.g. less than 12:00: 11:59 matches, 12:00 does not.'
    },
    conditionTimeGtInfo: {
        NL: 'Het tijdstip is later dan de ingevulde tijd, bijv. groter dan 12:00: 12:01 voldoet, 12:00 niet.',
        EN: 'The time is later than the entered time, e.g. greater than 12:00: 12:01 matches, 12:00 does not.'
    },
    conditionContainsInfo: {
        NL: 'De tekst bevat de ingevulde tekst, hoofdletters tellen niet mee, bijv. bevat "spoed": "Graag SPOED leveren" voldoet. Bij een tekst per stop (zoals instructie) moet de tekst van minstens één stop hem bevatten.',
        EN: 'The text contains the entered text, capitals do not count, e.g. contains "urgent": "Deliver URGENT please" matches. With a text per stop (such as instruction) the text of at least one stop must contain it.'
    },
    conditionNotContainsInfo: {
        NL: 'De tekst bevat de ingevulde tekst niet, hoofdletters tellen niet mee. Bij een tekst per stop (zoals instructie) mag de tekst van geen enkele stop hem bevatten.',
        EN: 'The text does not contain the entered text, capitals do not count. With a text per stop (such as instruction) the text of no stop may contain it.'
    },
    conditionAllInInfo: {
        NL: 'Elke waarde van de rit of zending moet bij de gekozen waarden staan, bijv. A en B gekozen: een rit met A, of met A en B, voldoet; een rit met A en C niet. Een rit zonder waarden voldoet ook.',
        EN: 'Every value of the order or parcel must be one of the chosen values, e.g. A and B chosen: an order with A, or with A and B, matches; an order with A and C does not. An order without values matches as well.'
    },
    conditionContainsAllInfo: {
        NL: 'Elke gekozen waarde moet in de rit of zending voorkomen, bijv. A en B gekozen: een rit met A, B en C voldoet; een rit met alleen A niet.',
        EN: 'Every chosen value must be present in the order or parcel, e.g. A and B chosen: an order with A, B and C matches; an order with only A does not.'
    },
    conditionAnyOfInfo: {
        NL: 'Minstens één waarde van de rit of zending moet bij de gekozen waarden staan, bijv. A en B gekozen: een rit met A en C voldoet; een rit met alleen C niet.',
        EN: 'At least one value of the order or parcel must be one of the chosen values, e.g. A and B chosen: an order with A and C matches; an order with only C does not.'
    },
    conditionNoneOfInfo: {
        NL: 'Geen enkele waarde van de rit of zending mag bij de gekozen waarden staan, bijv. A en B gekozen: een rit met C voldoet; een rit met A en C niet.',
        EN: 'No value of the order or parcel may be one of the chosen values, e.g. A and B chosen: an order with C matches; an order with A and C does not.'
    },
    conditionPostalCodeAllInInfo: {
        NL: 'Elke postcode van de rit (één per stop) of de zending valt binnen de ingevulde postcodes, bijv. 3500-3599: stops op 3511AB en 3584CS voldoen, stops op 3511AB en 1012AB niet.',
        EN: 'Every postal code of the order (one per stop) or parcel lies within the entered postal codes, e.g. 3500-3599: stops at 3511AB and 3584CS match, stops at 3511AB and 1012AB do not.'
    },
    conditionPostalCodeAnyOfInfo: {
        NL: 'Minstens één postcode van de rit (één per stop) of de zending valt binnen de ingevulde postcodes, bijv. 3500-3599: stops op 3511AB en 1012AB voldoen, alleen 1012AB niet.',
        EN: 'At least one postal code of the order (one per stop) or parcel lies within the entered postal codes, e.g. 3500-3599: stops at 3511AB and 1012AB match, only 1012AB does not.'
    },
    conditionPostalCodeNoneOfInfo: {
        NL: 'Geen enkele postcode van de rit (één per stop) of de zending valt binnen de ingevulde postcodes, bijv. 3500-3599: een stop op 1012AB voldoet, stops op 3511AB en 1012AB niet.',
        EN: 'No postal code of the order (one per stop) or parcel lies within the entered postal codes, e.g. 3500-3599: a stop at 1012AB matches, stops at 3511AB and 1012AB do not.'
    },
    creationTimeOrderDate: {
        NL: 'Aanmaaktijd (op orderdatum)',
        EN: 'Creation time (on order date)'
    },
    creationTimeOrderDateInfo: {
        NL: 'Vergelijkt met deze tijd op de datum van de rit: een rit die op een eerdere dag is aangemaakt, is altijd eerder',
        EN: 'Compares with this time on the date of the order: an order created on an earlier day is always earlier'
    },
    creationTimeOfDay: {
        NL: 'Aanmaaktijd (tijdstip)',
        EN: 'Creation time (time of day)'
    },
    creationTimeOfDayInfo: {
        NL: 'Vergelijkt alleen het tijdstip van aanmaken, ongeacht de dag',
        EN: 'Only compares the time of creation, regardless of the day'
    },
    weight: {
        NL: 'Gewicht',
        EN: 'Weight'
    },
    length: {
        NL: 'Lengte',
        EN: 'Length'
    },
    width: {
        NL: 'Breedte',
        EN: 'Width'
    },
    height: {
        NL: 'Hoogte',
        EN: 'Height'
    },
    volume: {
        NL: 'Volume',
        EN: 'Volume'
    },
    parcelSizeConditionInfo: {
        NL: 'Lengte is de langste zijde van de zending, hoogte de kortste',
        EN: 'Length is the longest side of the parcel, height the shortest'
    },
    priceExplanationTitle: {
        NL: 'Prijsopbouw',
        EN: 'Price breakdown'
    },
    priceExplanationStartRate: {
        NL: 'Starttarief',
        EN: 'Start rate'
    },
    priceExplanationZoneDistance: {
        NL: (measuredBy: 'straightLine' | 'car' | 'bike') => measuredBy === 'car' ? 'Rij-afstand auto' : measuredBy === 'bike' ? 'Rij-afstand fiets' : 'Afstand hemelsbreed',
        EN: (measuredBy: 'straightLine' | 'car' | 'bike') => measuredBy === 'car' ? 'Driving distance by car' : measuredBy === 'bike' ? 'Riding distance by bike' : 'Straight-line distance'
    },
    priceExplanationRoadDistanceUnavailable: {
        NL: 'De rij-afstand kon niet worden bepaald, de zone is bepaald met de afstand hemelsbreed.',
        EN: 'The driving distance could not be determined, the zone was determined with the straight-line distance.'
    },
    priceExplanationStops: {
        NL: (nrOfStops: number) => `${nrOfStops} stop${nrOfStops > 1 ? 's' : ''}`,
        EN: (nrOfStops: number) => `${nrOfStops} stop${nrOfStops > 1 ? 's' : ''}`
    },
    priceExplanationPickupAddresses: {
        NL: (nrOfAddresses: number) => `${nrOfAddresses} ophaaladres${nrOfAddresses > 1 ? 'sen' : ''}`,
        EN: (nrOfAddresses: number) => `${nrOfAddresses} pickup address${nrOfAddresses > 1 ? 'es' : ''}`
    },
    priceExplanationDeliveryAddresses: {
        NL: (nrOfAddresses: number) => `${nrOfAddresses} bezorgadres${nrOfAddresses > 1 ? 'sen' : ''}`,
        EN: (nrOfAddresses: number) => `${nrOfAddresses} delivery address${nrOfAddresses > 1 ? 'es' : ''}`
    },
    priceExplanationColli: {
        NL: (nrOfColli: number) => `${nrOfColli} colli`,
        EN: (nrOfColli: number) => `${nrOfColli} parcels`
    },
    priceExplanationColliTotal: {
        NL: (colliTypes: string) => `Colli totaal: ${colliTypes}`,
        EN: (colliTypes: string) => `Parcels total: ${colliTypes}`
    },
    priceExplanationColliIncluded: {
        NL: (nrOfColli: number) => `${nrOfColli} inbegrepen`,
        EN: (nrOfColli: number) => `${nrOfColli} included`
    },
    priceExplanationColloIncluded: {
        NL: 'Inbegrepen',
        EN: 'Included'
    },
    priceTableNrOfColliIncluded: {
        NL: 'Aantal colli inbegrepen',
        EN: 'Number of parcels included'
    },
    priceTableColliTypeNrOfColliIncludedInfo: {
        NL: 'De goedkoopste colli met een prijs (dus niet € 0,00) zijn inbegrepen en worden niet berekend.',
        EN: 'The cheapest parcels with a price (so not € 0.00) are included and are not charged.'
    },
    priceExplanationPickupAndDeliveryOptions: {
        NL: (nrOfOptions: number) => `${nrOfOptions} Ophaal- / bezorgoptie${nrOfOptions > 1 ? 's' : ''}`,
        EN: (nrOfOptions: number) => `${nrOfOptions} Pickup / delivery option${nrOfOptions > 1 ? 's' : ''}`
    },
    priceExplanationDistanceFee: {
        NL: ({distance, fee}: {distance: string, fee: string}) => `Kilometerprijs ${distance}km à €${fee}`,
        EN: ({distance, fee}: {distance: string, fee: string}) => `Price per km ${distance}km at €${fee}`
    },
    priceExplanationFuelFee: {
        NL: (percentage: string | number) => `Brandstoftoeslag ${percentage}%`,
        EN: (percentage: string | number) => `Fuel surcharge ${percentage}%`
    },
    priceExplanationRounding: {
        NL: 'Afronding',
        EN: 'Rounding'
    },
    priceExplanationRoundingWholeEuros: {
        NL: 'Hele euro\'s',
        EN: 'Whole euros'
    },
    priceExplanationRoundingMultipleOf: {
        NL: (amount: string) => `Veelvoud van ${amount}`,
        EN: (amount: string) => `Multiple of ${amount}`
    },
    manual: {
        NL: 'Handleiding',
        EN: 'Manual'
    },
    information: {
        NL: 'Informatie',
        EN: 'Information'
    },
    download: {
        NL: 'Download',
        EN: 'Download'
    },
    activate: {
        NL: 'Activeer',
        EN: 'Activate'
    },
    webshops: {
        NL: 'Webshops',
        EN: 'Webshops'
    },
    available: {
        NL: 'Beschikbaar',
        EN: 'Available'
    },
    prestaShopPickupPluginInfo: {
        NL: 'Met deze plugin kunnen beschikbare afhaalpunten getoond worden in de checkout van PrestaShop, en kan de consument zelf het gewenste afhaalpunt kiezen.',
        EN: 'With this plugin, available pickup points can be shown in the PrestaShop checkout, so the consumer can choose the preferred pickup point.'
    },
    prestaShopPickupPluginManual: {
        NL: 'Zie de handleiding voor activatie van de plugin',
        EN: 'See the manual for activating the plugin'
    },
    webhookUrl: {
        NL: 'Webhook URL',
        EN: 'Webhook URL'
    },
    webhookUrlExplanation: {
        NL: 'Gebruik onderstaande URL om een webhook in te stellen waarmee bestellingen automatisch worden geïmporteerd.',
        EN: 'Use the URL below to set up a webhook that imports orders automatically.'
    },
    seeThe: {
        NL: 'Zie de',
        EN: 'See the'
    },
    manualLowercase: {
        NL: 'handleiding',
        EN: 'manual'
    },
    forMoreInfoOnWebhooks: {
        NL: 'voor meer informatie over het instellen van webhooks.',
        EN: 'for more information on setting up webhooks.'
    },
    followThe: {
        NL: 'Volg de',
        EN: 'Follow the'
    },
    returnPortalManual: {
        NL: 'Retourportaal handleiding',
        EN: 'Return portal manual'
    },
    toActivateReturnPortal: {
        NL: 'om het retourportaal te activeren.',
        EN: 'to activate the return portal.'
    },
    returnPortalNotActive: {
        NL: 'Je retourportaal is nog niet actief.',
        EN: 'Your return portal is not active yet.'
    },
    customBranding: {
        NL: 'Eigen branding',
        EN: 'Custom branding'
    },
    brandingModuleExplanation: {
        NL: 'Met de branding module worden de kleur en het logo van Veloyd vervangen door de bedrijfskleur en een eigen gekozen logo, en krijg je een eigen URL om in te loggen. Dit wordt toegepast in de vervoerder omgeving, de klant omgeving en de koerier omgeving. Zo is jouw bedrijf herkenbaarder voor klanten, koeriers en planners. Voor meer informatie zie:',
        EN: 'With the branding module, the Veloyd color and logo are replaced by your company color and a logo of your choice, and you get your own URL to log in. This applies to the carrier, customer and courier environments. This makes your company more recognizable for customers, couriers and planners. For more information see:'
    },
    brandingModuleActivation: {
        NL: 'Om de module te activeren moet je een URL aanvragen. Stuur een mail naar info@veloyd.nl voor het aanvragen van de gewenste URL.',
        EN: 'To activate the module you need to request a URL. Send an email to info@veloyd.nl to request the desired URL.'
    },
    activateCustomBrandingForUsers: {
        NL: 'Activeer de eigen branding module voor gebruikers',
        EN: 'Activate the custom branding module for users'
    },
    customBrandingLogosInfo: {
        NL: 'Op verschillende plekken in het systeem worden logo\'s gebruikt, deze kunnen hieronder worden geupload. Vanwege eisen van de verschillende platformen waarop Veloyd gebruikt wordt, zijn er verschillende afmetingen nodig. Voor de vierkante logo\'s is het aan te raden om een zo groot mogelijk logo te gebruiken, deze worden met name gebruikt als favicon en app-iconen op mobiele apparaten. Het is aan te raden om logo\'s in SVG formaat te gebruiken.',
        EN: 'Logos are used in several places in the system and can be uploaded below. Because of the requirements of the different platforms Veloyd runs on, different sizes are needed. For the square logos it is recommended to use the largest possible logo, as they are mainly used as favicon and app icons on mobile devices. It is recommended to use logos in SVG format.'
    },
    logo: {
        NL: 'Logo',
        EN: 'Logo'
    },
    logoLoginPage: {
        NL: 'Logo login pagina',
        EN: 'Login page logo'
    },
    logoLoginPageDimensions: {
        NL: 'Hoogte: 128px. Minimale breedte: 128px, maximale breedte: 256px.',
        EN: 'Height: 128px. Minimum width: 128px, maximum width: 256px.'
    },
    logoNavigationBar: {
        NL: 'Logo navigatie balk',
        EN: 'Navigation bar logo'
    },
    logoNavigationBarDimensions: {
        NL: 'Hoogte: 32px. Minimale breedte: 32px, maximale breedte: 64px.',
        EN: 'Height: 32px. Minimum width: 32px, maximum width: 64px.'
    },
    fileTypePng: {
        NL: 'Bestandstype: png',
        EN: 'File type: png'
    },
    fileTypePngSvg: {
        NL: 'Bestandstype: png, svg',
        EN: 'File type: png, svg'
    },
    customManualsInfo: {
        NL: 'Je kan er voor kiezen om de Help knop in Veloyd te laten verwijzen naar eigen handleidingen. Vul hieronder de URL in van de handleiding.',
        EN: 'You can choose to have the Help button in Veloyd link to your own manuals. Enter the URL of the manual below.'
    },
    manualUrlReseller: {
        NL: 'Vervoerder handleiding URL',
        EN: 'Carrier manual URL'
    },
    manualUrlCustomer: {
        NL: 'Klant handleiding URL',
        EN: 'Customer manual URL'
    },
    manualUrlMessenger: {
        NL: 'Koerier handleiding URL',
        EN: 'Courier manual URL'
    },
    carriers: {
        NL: 'Vervoerders',
        EN: 'Carriers'
    },
    deactivate: {
        NL: 'Deactiveer',
        EN: 'Deactivate'
    },
    accept: {
        NL: 'Accepteer',
        EN: 'Accept'
    },
    veloydPartnerCarriers: {
        NL: 'Veloyd vervoerders',
        EN: 'Veloyd carriers'
    },
    partnerCarriersCustomBranding: {
        NL: 'Zending vervoerders',
        EN: 'Parcel carriers'
    },
    partnerCarriersInfo: {
        NL: 'Als Veloyd gebruiker kun je pakketten versturen met andere Veloyd gebruikers. Hiervoor moet onderstaande optie worden geactiveerd, daarna kun je een verzoek sturen naar een andere Veloyd gebruiker met de API key van deze partner. Deze API key kun je opvragen bij de partner. Zodra dit verzoek is geaccepteerd verschijnt de vervoerder hierboven en kan deze worden geactiveerd.',
        EN: 'As a Veloyd user you can ship parcels with other Veloyd users. To do so, enable the option below; you can then send a request to another Veloyd user with the API key of that partner. You can get this API key from the partner. Once the request is accepted, the carrier appears above and can be activated.'
    },
    partnerAddByApiKey: {
        NL: 'Partner toevoegen op API key',
        EN: 'Add partner by API key'
    },
    partnerSendRequest: {
        NL: 'Verzoek versturen',
        EN: 'Send request'
    },
    visibleAsPartnerCarrier: {
        NL: 'Zichtbaar als vervoerder voor andere Veloyd gebruikers',
        EN: 'Visible as a carrier to other Veloyd users'
    },
    partnerConnectionActive: {
        NL: 'Koppeling actief',
        EN: 'Connection active'
    },
    partnerRequestSent: {
        NL: 'Verzoek verstuurd',
        EN: 'Request sent'
    },
    partnerRequestReceived: {
        NL: 'Partner verzoek ontvangen',
        EN: 'Partner request received'
    },
    carriersViaPlatform: {
        NL: 'Vervoerders via platform',
        EN: 'Carriers via a platform'
    },
    carriersViaPlatformInfo: {
        NL: 'Verschillende vervoerders zijn ook te activeren via externe platforms. Om gebruik te maken van deze vervoerders dien je zelf een account aan te vragen op dit platform.',
        EN: 'Several carriers can also be activated through external platforms. To use these carriers you need to request an account on the platform yourself.'
    },
    platform: {
        NL: 'Platform',
        EN: 'Platform'
    },
    parcelProducts: {
        NL: 'Verzendopties',
        EN: 'Shipping options'
    },
    parcelProductsNoCarriers: {
        NL: 'Er moet minimaal 1 vervoerders zijn geactiveerd voordat verzendopties kunnen worden ingesteld.',
        EN: 'At least 1 carrier must be activated before shipping options can be set.'
    },
    parcelProductAddressLabelInfo: {
        NL: 'Een zending aangemeld met de optie Adreslabel komt niet in de planning te staan, en krijgt géén track & trace code.',
        EN: 'A parcel created with the Address label option is not added to the planning and does not get a track & trace code.'
    },
    parcelProductMailboxNoTrackTraceInfo: {
        NL: 'Voor zendingen aangemeld met de optie Brievenbuspakket zonder Track & Trace worden geen emails verstuurd en de Track & Trace pagina is niet beschikbaar.',
        EN: 'For parcels created with the Mailbox parcel without Track & Trace option no emails are sent and the Track & Trace page is not available.'
    },
    parcelProductReturnInfo: {
        NL: 'Activatie van het product Retour maakt ook het gebruik van het retourportaal voor klanten mogelijk',
        EN: 'Activating the Return product also enables the return portal for customers'
    },
    parcelProductVerificationCodeInfo: {
        NL: 'Voor ontvangst van deze zendingen is een verificatiecode vereist, deze wordt per email naar de ontvanger gestuurd. Hiervoor is het noodzakelijk dat minimaal 1 van de volgende emailnotificaties actief is: Bezorging aangemeld, Bezorging gepland, Bezorging onderweg.',
        EN: 'A verification code is required to receive these parcels; it is emailed to the recipient. At least 1 of the following email notifications must be active: Delivery created, Delivery planned, Delivery on the way.'
    },
    continue: {
        NL: 'Doorgaan',
        EN: 'Continue'
    },
    messengerEditCompletedAddress: {
        NL: 'Koerier kan afgerond adres wijzigen',
        EN: 'Courier can change a completed address'
    },
    messengerEditCompletedAddressInfo: {
        NL: 'De koerier kan de afronding van een adres in de actieve route aanpassen, bijvoorbeeld na een vergissing. De eerdere afronding blijft in de rit historie staan en een retourrit die door de afronding is aangemaakt wordt geannuleerd. Een adres dat inmiddels opnieuw is ingepland of in bewaring is gezet kan niet meer worden aangepast.',
        EN: 'The courier can change how an address in the active route was completed, for example after a mistake. The earlier completion stays in the order history and a retour created by it is cancelled. An address that has been rescheduled or put on hold since can no longer be changed.'
    },
    onlyLastCompletedAddress: {
        NL: 'Alleen laatst afgerond adres',
        EN: 'Only the last completed address'
    },
    allAddressesInActiveRoute: {
        NL: 'Alle adressen in actieve route',
        EN: 'All addresses in the active route'
    },
    messengerEditCompletedAddressMinutes: {
        NL: 'Maximale tijd om afgerond adres te wijzigen (minuten)',
        EN: 'Maximum time to change a completed address (minutes)'
    },
    messengerEditCompletedAddressMinutesInfo: {
        NL: 'Na deze tijd, gerekend vanaf het afronden van het adres, kan de koerier het adres niet meer wijzigen. Laat leeg om de tijd niet te beperken.',
        EN: 'After this time, counted from completing the address, the courier can no longer change it. Leave empty for no time limit.'
    },
    editAddress: {
        NL: 'Adres aanpassen',
        EN: 'Change address'
    },
    editCompletedAddressWarning: {
        NL: 'Je gaat een afgerond adres aanpassen. Wil je doorgaan?',
        EN: 'You are about to change a completed address. Do you want to continue?'
    },
    expectedTimeOfArrival: {
        NL: 'Verwachte aankomsttijd',
        EN: 'Expected time of arrival'
    },
    calculatedEtaCompletedByPlanner: {
        NL: 'Berekende ETA. Rit afgerond door planner.',
        EN: 'Calculated ETA. Order completed by planner.'
    },
    timeOfArrival: {
        NL: 'Aankomsttijd',
        EN: 'Time of arrival'
    },
    etaDeviation: {
        NL: 'Afwijking ETA',
        EN: 'ETA deviation'
    },
    notStarted: {
        NL: 'Niet gestart',
        EN: 'Not started'
    },
    changeRoute: {
        NL: 'Route wijzigen',
        EN: 'Change route'
    },
    unlockReadyRouteConfirm: {
        NL: 'Je ontgrendelt stopnummers van een route die gereed is. Weet je zeker dat je de route wil wijzigen?',
        EN: 'You are unlocking stop numbers of a route that is ready. Are you sure you want to change the route?'
    },
    deviateFromFixedOrder: {
        NL: 'Afwijken van vaste volgorde.',
        EN: 'Deviate from fixed order.'
    },
    deviateFromFixedOrderConfirm: {
        NL: 'Je gaat afwijken van de vaste volgorde van een rit. Weet je zeker dat je door wil gaan?',
        EN: 'You are about to deviate from the fixed order of an order. Are you sure you want to continue?'
    },
    routeHasNotStartedAddresses: {
        NL: 'Route bevat niet gestarte adressen',
        EN: 'Route contains addresses that have not been started'
    },
    noNotifications: {
        NL: 'Geen meldingen',
        EN: 'No notifications'
    },
    moreInformation: {
        NL: 'Meer informatie',
        EN: 'More information'
    },
    previousWithCount: {
        NL: ({current, total}: {current: number, total: number}) => `Vorige (${current}/${total})`,
        EN: ({current, total}: {current: number, total: number}) => `Previous (${current}/${total})`
    },
    nextWithCount: {
        NL: ({current, total}: {current: number, total: number}) => `Volgende (${current}/${total})`,
        EN: ({current, total}: {current: number, total: number}) => `Next (${current}/${total})`
    },
    ok: {
        NL: 'OK',
        EN: 'OK'
    },
    accountingConnection: {
        NL: 'Boekhoudkoppeling',
        EN: 'Accounting connection'
    },
    accountingConnectionDescription: {
        NL: 'Selecteer het juiste boekhoudsysteem en vul de benodigde gegevens in.',
        EN: 'Select the right accounting system and fill in the required details.'
    },
    accountingSystem: {
        NL: 'Boekhoudsysteem',
        EN: 'Accounting system'
    },
    noAccountingSystem: {
        NL: 'Geen boekhoudsysteem',
        EN: 'No accounting system'
    },
    syncCustomers: {
        NL: 'Synchroniseer klanten',
        EN: 'Synchronise customers'
    },
    syncCustomersFromVeloyd: {
        NL: (api: string) => `Van Veloyd naar ${api}`,
        EN: (api: string) => `From Veloyd to ${api}`
    },
    syncCustomersToVeloyd: {
        NL: (api: string) => `Van ${api} naar Veloyd`,
        EN: (api: string) => `From ${api} to Veloyd`
    },
    noNewCustomersInVeloyd: {
        NL: 'Geen nieuwe klanten aanmaken in Veloyd',
        EN: 'Do not create new customers in Veloyd'
    },
    noNewCustomersInVeloydInfo: {
        NL: 'Nieuwe klanten moeten in het boekhoudsysteem worden aangemaakt.',
        EN: 'New customers have to be created in the accounting system.'
    },
    customersNotEditableInVeloyd: {
        NL: 'Klanten niet aanpasbaar in Veloyd',
        EN: 'Customers not editable in Veloyd'
    },
    customersNotEditableInVeloydInfo: {
        NL: 'Naam en adresgegevens van klanten kunnen niet worden aangepast in Veloyd.',
        EN: 'The name and address of customers cannot be changed in Veloyd.'
    },
    environmentNumber: {
        NL: 'Omgevingsnummer',
        EN: 'Environment number'
    },
    warehouse: {
        NL: 'Magazijn',
        EN: 'Warehouse'
    },
    zoneDetermination: {
        NL: 'Zone bepaling',
        EN: 'Zone determination'
    },
    zoneDeterminationStraightLine: {
        NL: 'Maximale afstand hemelsbreed (km)',
        EN: 'Maximum straight-line distance (km)'
    },
    zoneDeterminationCarDistance: {
        NL: 'Maximale rij-afstand auto (km)',
        EN: 'Maximum driving distance by car (km)'
    },
    zoneDeterminationBikeDistance: {
        NL: 'Maximale rij-afstand fiets (km)',
        EN: 'Maximum riding distance by bike (km)'
    },
    deliveryAreas: {
        NL: 'Bezorggebieden',
        EN: 'Delivery areas'
    },
    zoneName: {
        NL: 'Zone naam',
        EN: 'Zone name'
    },
    administration: {
        NL: 'Administratie',
        EN: 'Administration'
    },
    typeItem: {
        NL: 'Type item',
        EN: 'Item type'
    },
    unit: {
        NL: 'Eenheid',
        EN: 'Unit'
    },
    afasCustomerGetConnector: {
        NL: 'Klanten getConnector',
        EN: 'Customers getConnector'
    },
    afasFieldDebtorId: {
        NL: 'Veld Debiteurnummer',
        EN: 'Field debtor number'
    },
    afasFieldDebtorName: {
        NL: 'Veld Debiteurnaam',
        EN: 'Field debtor name'
    },
    afasFieldEmail: {
        NL: 'Veld Emailadres',
        EN: 'Field email address'
    },
    afasFieldPhone: {
        NL: 'Veld Telefoon',
        EN: 'Field phone'
    },
    afasFieldStreet: {
        NL: 'Veld Straat',
        EN: 'Field street'
    },
    afasFieldNr: {
        NL: 'Veld Huisnummer',
        EN: 'Field house number'
    },
    afasFieldAddition: {
        NL: 'Veld Huisnummer toevoeging',
        EN: 'Field house number addition'
    },
    afasFieldStreet2: {
        NL: 'Veld 2e adres regel',
        EN: 'Field 2nd address line'
    },
    afasFieldPostalCode: {
        NL: 'Veld postcode',
        EN: 'Field postal code'
    },
    afasFieldCity: {
        NL: 'Veld plaats',
        EN: 'Field city'
    },
    afasFieldCountryCode: {
        NL: 'Veld landcode',
        EN: 'Field country code'
    },
    afasGuidVeloydId: {
        NL: 'GUID Veloyd ID',
        EN: 'GUID Veloyd ID'
    },
    afasGuidCustomerReference: {
        NL: 'GUID klant referentie',
        EN: 'GUID customer reference'
    },
    afasGuidTrackTrace: {
        NL: 'GUID Track & Trace',
        EN: 'GUID Track & Trace'
    },
    afasGuidCarrier: {
        NL: 'GUID vervoerder',
        EN: 'GUID carrier'
    },
    afasGuidOptions: {
        NL: 'GUID zendingopties',
        EN: 'GUID parcel options'
    },
    afasGuidCountry: {
        NL: 'GUID landcode',
        EN: 'GUID country code'
    },
    afasGuidWeight: {
        NL: 'GUID gewicht',
        EN: 'GUID weight'
    },
    afasGuidInfo: {
        NL: 'GUID overige info',
        EN: 'GUID other info'
    },
    clientId: {
        NL: 'Client ID',
        EN: 'Client ID'
    },
    clientSecret: {
        NL: 'Client Secret',
        EN: 'Client Secret'
    },
    syncCustomersFromDebtorGroup: {
        NL: 'Synchroniseer klanten uit debiteurgroep',
        EN: 'Synchronise customers from debtor group'
    },
    syncCustomersFromDebtorGroupInfo: {
        NL: 'Alléén klanten in deze debiteurgroep worden gesynchroniseerd.',
        EN: 'Only customers in this debtor group are synchronised.'
    },
    checkConceptInvoices: {
        NL: 'Controleer op bestaande facturen',
        EN: 'Check for existing invoices'
    },
    checkConceptInvoicesInfo: {
        NL: 'Als er al een concept factuur bestaat voor de betreffende debiteur dan worden nieuwe factuurregels hieraan toegevoegd.',
        EN: 'When a concept invoice already exists for the debtor, new invoice lines are added to it.'
    },
    sendAttachmentTo: {
        NL: (api: string) => `Stuur bijlage naar ${api}`,
        EN: (api: string) => `Send attachment to ${api}`
    },
    mergeOrdersOnOneInvoiceLine: {
        NL: 'Ritten samenvoegen op één factuurregel',
        EN: 'Merge orders on one invoice line'
    },
    mergeParcels: {
        NL: 'Zendingen samenvoegen',
        EN: 'Merge parcels'
    },
    mergeParcelsInfo: {
        NL: 'Kies hoe zendingen worden samengevoegd op de factuur.',
        EN: 'Choose how parcels are merged on the invoice.'
    },
    mergeParcelsOnOneInvoiceLine: {
        NL: 'Op één factuurregel',
        EN: 'On one invoice line'
    },
    mergeParcelsPerCarrier: {
        NL: 'Per vervoerder',
        EN: 'Per carrier'
    },
    mergeParcelsPerCarrierInfo: {
        NL: 'Bij Instellingen > Zendingen > Vervoerders kan per vervoerder een productnummer worden ingesteld dat wordt meegegeven op de factuurregel.',
        EN: 'At Settings > Parcels > Carriers a product number can be set per carrier, which is added to the invoice line.'
    },
    mergeParcelsPerProductCode: {
        NL: 'Per productcode',
        EN: 'Per product code'
    },
    mergeParcelsPerProductCodeInfo: {
        NL: 'Bij Instellingen > Zendingen > Productcodes kunnen productnummers worden ingesteld.',
        EN: 'Product numbers can be set at Settings > Parcels > Product codes.'
    },
    periodOnInvoiceLine: {
        NL: 'Periode op factuurregel',
        EN: 'Period on invoice line'
    },
    periodOnInvoiceLineInfo: {
        NL: 'De factuurperiode wordt toegevoegd aan de factuurregel.',
        EN: 'The invoice period is added to the invoice line.'
    },
    periodAsReference: {
        NL: 'Periode als referentie',
        EN: 'Period as reference'
    },
    periodAsReferenceInfo: {
        NL: 'De factuurperiode wordt toegevoegd als referentie van de factuur.',
        EN: 'The invoice period is added as the reference of the invoice.'
    },
    ordersProductCode: {
        NL: 'Productcode ritten',
        EN: 'Product code orders'
    },
    parcelsProductCode: {
        NL: 'Productcode zendingen',
        EN: 'Product code parcels'
    },
    subscriptionsProductCode: {
        NL: 'Productcode abonnementen',
        EN: 'Product code subscriptions'
    },
    password: {
        NL: 'Wachtwoord',
        EN: 'Password'
    },
    organisation: {
        NL: 'Organisatie',
        EN: 'Organisation'
    },
    invoiceType: {
        NL: 'Factuur type',
        EN: 'Invoice type'
    },
    invoiceDimension: {
        NL: 'Factuur dimensie',
        EN: 'Invoice dimension'
    },
    vatCode: {
        NL: 'VAT code',
        EN: 'VAT code'
    },
    snelstartDescription: {
        NL: 'Facturen worden in SnelStart aangemaakt als verkooporder (concept factuur). Controleer en factureer ze daarna in SnelStart, SnelStart nummert en verstuurt de factuur. Het debiteurnummer van een klant in Veloyd is het relatienummer in SnelStart.',
        EN: 'Invoices are created in SnelStart as sales orders (concept invoices). Check and invoice them in SnelStart afterwards, SnelStart numbers and sends the invoice. The debtor number of a customer in Veloyd is the relation number in SnelStart.'
    },
    snelstartSubscriptionKey: {
        NL: 'Subscription key',
        EN: 'Subscription key'
    },
    snelstartSubscriptionKeyInfo: {
        NL: 'De primaire sleutel van het abonnement in het SnelStart ontwikkelaarsportaal.',
        EN: 'The primary key of the subscription in the SnelStart developer portal.'
    },
    snelstartClientKey: {
        NL: 'Koppelsleutel',
        EN: 'Client key'
    },
    snelstartClientKeyInfo: {
        NL: 'De koppelsleutel van de administratie, aan te maken in SnelStart Web bij Koppelingen.',
        EN: 'The client key of the administration, created in SnelStart Web under Koppelingen.'
    },
    snelstartOrdersArticle: {
        NL: 'Artikelcode ritten',
        EN: 'Article code orders'
    },
    snelstartParcelsArticle: {
        NL: 'Artikelcode zendingen',
        EN: 'Article code parcels'
    },
    snelstartShiftsArticle: {
        NL: 'Artikelcode diensten',
        EN: 'Article code shifts'
    },
    snelstartSubscriptionsArticle: {
        NL: 'Artikelcode abonnementen',
        EN: 'Article code subscriptions'
    },
    snelstartArticleInfo: {
        NL: 'Het artikel in SnelStart bepaalt het grootboek en de btw van de factuurregel, bijvoorbeeld -2 (Diversen diensten hoog). Zonder artikelcode gebruikt SnelStart het standaard artikel.',
        EN: 'The article in SnelStart decides the ledger and VAT of the invoice line, for example -2 (Diversen diensten hoog). Without an article code SnelStart uses its default article.'
    },
    snelstartVerification: {
        NL: 'SnelStart verificatie',
        EN: 'SnelStart verification'
    },
    snelstartVerificationDescription: {
        NL: 'SnelStart keurt een koppeling pas goed na minimaal 100 verzoeken met de koppelsleutel. Vul de sleutels van de vervoerder of klant in om deze verzoeken te doen. Hierbij worden in SnelStart een testrelatie "Veloyd API test" en een verkooporder (pakbon) aangemaakt. Dit kan een paar minuten duren.',
        EN: 'SnelStart only approves a connection after at least 100 requests with the client key. Enter the keys of the carrier or customer to make these requests. This creates a test relation "Veloyd API test" and a sales order (packing slip) in SnelStart. This can take a few minutes.'
    },
    snelstartVerificationRequests: {
        NL: '100 verzoeken doen',
        EN: 'Make 100 requests'
    },
    snelstartVerificationRequestsMade: {
        NL: (requests: number) => `${requests} verzoeken gedaan bij SnelStart.`,
        EN: (requests: number) => `${requests} requests made to SnelStart.`
    },
    invoiceSettings: {
        NL: 'Factuur instellingen',
        EN: 'Invoice settings'
    },
    approveOrders: {
        NL: 'Accordeer ritten',
        EN: 'Approve orders'
    },
    showNameOnInvoice: {
        NL: 'Toon bedrijfsnaam op facturen',
        EN: 'Show company name on invoices'
    },
    showNameOnInvoiceInfo: {
        NL: 'Als deze optie is uitgeschakeld wordt alleen het logo getoond.',
        EN: 'When this option is off only the logo is shown.'
    },
    showOrderOverviewOnInvoice: {
        NL: 'Toon rit overzicht op facturen',
        EN: 'Show order overview on invoices'
    },
    groupOrderOverviewByDay: {
        NL: 'Groepeer rit overzicht per dag',
        EN: 'Group order overview per day'
    },
    groupOrderOverviewByDayInfo: {
        NL: 'Groepering op de overzichtspagina gebeurt standaard over de hele geselecteerde periode. Zet deze optie aan als je het gegroepeerd per dag wil zien.',
        EN: 'The overview page is grouped over the whole selected period by default. Turn this option on to group it per day.'
    },
    showOrderSpecificationOnInvoice: {
        NL: 'Toon rit specificatie op facturen',
        EN: 'Show order specification on invoices'
    },
    showParcelOverviewOnInvoice: {
        NL: 'Toon zending overzicht op facturen',
        EN: 'Show parcel overview on invoices'
    },
    showParcelSpecificationOnInvoice: {
        NL: 'Toon zending specificatie op facturen',
        EN: 'Show parcel specification on invoices'
    },
    showPriceExplanationOrders: {
        NL: 'Toon rit prijsopbouw op facturen',
        EN: 'Show order price breakdown on invoices'
    },
    showColliBarcodeSpecification: {
        NL: 'Toon colli barcodes in prijsopbouw',
        EN: 'Show colli barcodes in price breakdown'
    },
    showColliBarcodeSpecificationInfo: {
        NL: 'Toont per collo de barcode, collo type en bijbehorende prijs (indien aanwezig volgens de tarieftabel).',
        EN: 'Shows the barcode, collo type and price per collo (when present in the price table).'
    },
    showPriceExplanationParcels: {
        NL: 'Toon zending prijsopbouw op facturen',
        EN: 'Show parcel price breakdown on invoices'
    },
    invoiceOrdersPriceZero: {
        NL: 'Factureer ritten met prijs €0,00',
        EN: 'Invoice orders with price €0.00'
    },
    invoiceParcelsPriceZero: {
        NL: 'Factureer zendingen met prijs €0,00',
        EN: 'Invoice parcels with price €0.00'
    },
    invoiceSentOrdersOnly: {
        NL: 'Factureer alleen uitgevoerde ritten',
        EN: 'Only invoice executed orders'
    },
    invoiceSentOrdersOnlyInfo: {
        NL: 'Ritten vanaf status "Onderweg" worden gefactureerd.',
        EN: 'Orders from status "Onderweg" are invoiced.'
    },
    invoiceSentParcelsOnly: {
        NL: 'Factureer alleen verstuurde zendingen',
        EN: 'Only invoice sent parcels'
    },
    invoiceSentParcelsOnlyInfo: {
        NL: 'Zendingen vanaf status "Opgehaald" worden gefactureerd.',
        EN: 'Parcels from status "Opgehaald" are invoiced.'
    },
    xmlExport: {
        NL: 'XML export',
        EN: 'XML export'
    },
    xmlExportTemplate: {
        NL: 'XML export template',
        EN: 'XML export template'
    },
    snelstartWebshopDescription: {
        NL: 'Verkooporders met de status Order worden geïmporteerd als zending. Na het versturen kan de verkooporder worden omgezet naar een pakbon.',
        EN: 'Sales orders with the status Order are imported as parcels. After sending, the sales order can be changed into a packing slip.'
    },
    snelstartUpdateStatus: {
        NL: 'Verkooporder omzetten naar pakbon in SnelStart',
        EN: 'Change sales order into packing slip in SnelStart'
    },
    never: {
        NL: 'Nooit',
        EN: 'Never'
    },
    afterConfirm: {
        NL: 'Na bevestigen',
        EN: 'After confirming'
    },
    afterSent: {
        NL: 'Na verzenden',
        EN: 'After sending'
    },
    verify: {
        NL: 'Verifieer',
        EN: 'Verify'
    },
    verificationFailed: {
        NL: (error: string) => `Verificatie niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${error}`,
        EN: (error: string) => `Verification not successful, check the details you entered. Error: ${error}`
    },
    verificationSucceeded: {
        NL: 'Verificatie succesvol.',
        EN: 'Verification successful.'
    },
    msgPostNLAvailable: {
        NL: 'PostNL-Monta koppeling beschikbaar',
        EN: 'PostNL-Monta connection available'
    },
    msgDHLAvailable: {
        NL: 'DHL-Monta koppeling beschikbaar',
        EN: 'DHL-Monta connection available'
    },
    qlsAvailable: {
        NL: 'QLS koppeling beschikbaar',
        EN: 'QLS connection available'
    },
    connectionAvailableDeactivateInfo: {
        NL: 'Als deze optie wordt uitgezet moet de koppeling handmatig worden gedeactiveerd in het account van de reseller.',
        EN: 'When this option is turned off, the connection has to be deactivated manually in the account of the reseller.'
    },
    intrapostAvailable: {
        NL: 'Intrapost koppeling beschikbaar',
        EN: 'Intrapost connection available'
    },
    intrapostAvailableInfo: {
        NL: 'Als deze optie wordt uitgezet kan de reseller geen zendingen meer via Intrapost aanmelden.',
        EN: 'When this option is turned off, the reseller can no longer create parcels through Intrapost.'
    },
    snelstartWebshopAvailable: {
        NL: 'SnelStart webshop koppeling beschikbaar',
        EN: 'SnelStart webshop connection available'
    },
    snelstartWebshopAvailableInfo: {
        NL: 'Klanten van deze reseller kunnen verkooporders uit SnelStart importeren als zending.',
        EN: 'Customers of this reseller can import sales orders from SnelStart as parcels.'
    },
    webshopContactReseller: {
        NL: (reseller: string) => `Neem contact op met ${reseller} om deze koppeling in te stellen.`,
        EN: (reseller: string) => `Contact ${reseller} to set up this connection.`
    },
    invalidStartTime: {
        NL: 'Vul een geldige starttijd in (UU:MM).',
        EN: 'Enter a valid start time (HH:mm).'
    },
    invalidEndTime: {
        NL: 'Vul een geldige eindtijd in (UU:MM).',
        EN: 'Enter a valid end time (HH:mm).'
    },
    endTimeBeforeStartTime: {
        NL: 'De eindtijd moet na de starttijd liggen.',
        EN: 'The end time must be after the start time.'
    },
    importLineError: {
        NL: ({line, error}: {line: number, error: string}) => `Regel ${line}: ${error}`,
        EN: ({line, error}: {line: number, error: string}) => `Line ${line}: ${error}`
    },
    startTimeFormat: {
        NL: 'Starttijd (UU:MM)',
        EN: 'Start time (HH:mm)'
    },
    endTimeFormat: {
        NL: 'Eindtijd (UU:MM)',
        EN: 'End time (HH:mm)'
    },
    attentionShort: {
        NL: 'T.a.v.',
        EN: 'Attn.'
    },
    email: {
        NL: 'Email',
        EN: 'Email'
    },
    phone: {
        NL: 'Telefoon',
        EN: 'Phone'
    },
    attachment: {
        NL: 'Bijlage',
        EN: 'Attachment'
    },
    nrShort: {
        NL: 'Nr',
        EN: 'No.'
    },
    addition: {
        NL: 'Toevoeging',
        EN: 'Addition'
    },
    streetNrAddition: {
        NL: 'Straat + nr + toevoeging',
        EN: 'Street + no. + addition'
    },
    nrAddition: {
        NL: 'Nr + toevoeging',
        EN: 'No. + addition'
    },
    street2: {
        NL: '2e adres regel',
        EN: 'Address line 2'
    },
    newAddress: {
        NL: 'Nieuw adres',
        EN: 'New address'
    },
    sendWithPxByDefault: {
        NL: 'Verstuur standaard met Px',
        EN: 'Send with Px by default'
    },
    addressBookTimeslotInfo: {
        NL: 'Nieuwe ritten via API, import of het klantportaal krijgen dit tijdvak bij dit adres. Een aangeleverd tijdvak wordt verkleind tot de overlap.',
        EN: 'New orders via API, import or the customer portal get this timeslot at this address. A supplied timeslot is narrowed to the overlap.'
    },
    editOrder: {
        NL: 'Bewerk rit',
        EN: 'Edit order'
    },
    orderNothingPickedUpOrDelivered: {
        NL: 'Er is voor deze rit nog niets opgehaald of bezorgd',
        EN: 'Nothing has been picked up or delivered for this order yet'
    },
    sendProofOfCompletion: {
        NL: 'Verstuur bewijs van uitvoering',
        EN: 'Send proof of completion'
    },
    close: {
        NL: 'Sluiten',
        EN: 'Close'
    },
    emailSentTo: {
        NL: (email: string) => `Email verstuurd naar ${email}`,
        EN: (email: string) => `Email sent to ${email}`
    },
    copyOrder: {
        NL: 'Kopieer rit',
        EN: 'Copy order'
    },
    printLabels: {
        NL: 'Print labels',
        EN: 'Print labels'
    },
    removeOrder: {
        NL: 'Verwijder rit',
        EN: 'Remove order'
    },
    sendProofOfDelivery: {
        NL: 'Verstuur bezorgbewijs',
        EN: 'Send proof of delivery'
    },
    saveChanges: {
        NL: 'Wijzigingen opslaan',
        EN: 'Save changes'
    },
    saveChangesBeforeClosing: {
        NL: 'Wil je de wijzigingen opslaan voor het sluiten?',
        EN: 'Do you want to save the changes before closing?'
    },
    dontSave: {
        NL: 'Niet opslaan',
        EN: 'Don\'t save'
    },
    errorMessage: {
        NL: 'Foutmelding',
        EN: 'Error'
    },
    mfaTitle: {
        NL: 'Tweestapsverificatie',
        EN: 'Two-factor authentication'
    },
    mfaEnterCode: {
        NL: 'Vul de tweestapsverificatiecode in.',
        EN: 'Enter the two-factor authentication code.'
    },
    mfaEnterCodeApp: {
        NL: 'Vul de tweestapsverificatiecode in uit de authenticator app.',
        EN: 'Enter the two-factor authentication code from the authenticator app.'
    },
    mfaEnterCodeEmail: {
        NL: 'Vul de tweestapsverificatiecode in die per e-mail is verstuurd.',
        EN: 'Enter the two-factor authentication code that was sent by email.'
    },
    mfaLogIn: {
        NL: 'Log in',
        EN: 'Log in'
    },
    mfaConfirm: {
        NL: 'Bevestig',
        EN: 'Confirm'
    },
    loginAsCustomerMfaTitle: {
        NL: 'Deze klant heeft tweestapsverificatie geactiveerd.',
        EN: 'This customer has two-factor authentication enabled.'
    },
    loginAsCustomerMfaText: {
        NL: 'Deze klant heeft tweestapsverificatie geactiveerd. Om in te loggen heb je de verificatiecode nodig van de klant, weet je zeker dat je wilt doorgaan?',
        EN: 'This customer has two-factor authentication enabled. You need the customer\'s verification code to log in, are you sure you want to continue?'
    },
    loginAsCustomerMfaVerified: {
        NL: 'De code is juist. Open het klantportaal in een nieuw tabblad.',
        EN: 'The code is correct. Open the customer portal in a new tab.'
    },
    openCustomerPortal: {
        NL: 'Klantportaal openen',
        EN: 'Open customer portal'
    },
    addressCoordinatesUnknown: {
        NL: 'Coördinaten van adres zijn niet bekend',
        EN: 'Coordinates of the address are unknown'
    },
    editActivityDurationTitle: {
        NL: 'Activiteit aanpassen',
        EN: 'Edit activity'
    },
    editPauseDurationTitle: {
        NL: 'Pauze tijd aanpassen',
        EN: 'Edit break time'
    },
    editPriceTable: {
        NL: 'Tarieftabel aanpassen',
        EN: 'Edit price table'
    },
    editReference: {
        NL: 'Referentie aanpassen',
        EN: 'Edit reference'
    },
    zoneDeterminationInfo: {
        NL: 'Berekend vanaf adres van de klant naar adres in de rit',
        EN: 'Calculated from the customer\'s address to the address in the order'
    },
    distanceVehicleType: {
        NL: 'Afstand berekenen voor',
        EN: 'Calculate distance for'
    },
    car: {
        NL: 'Auto',
        EN: 'Car'
    },
    bike: {
        NL: 'Fiets',
        EN: 'Bike'
    },
    start: {
        NL: 'Start',
        EN: 'Start'
    },
    end: {
        NL: 'Eind',
        EN: 'End'
    },
    distanceFee: {
        NL: 'Kilometertarief',
        EN: 'Rate per kilometer'
    },
    startDistance: {
        NL: 'Kilometers inbegrepen bij starttarief',
        EN: 'Kilometers included in start rate'
    },
    detourFactorPercentage: {
        NL: 'Omrij-percentage',
        EN: 'Detour percentage'
    },
    detourFactorPercentageInfo: {
        NL: 'De berekende afstand wordt met een percentage verhoogd voor de tariefbepaling.',
        EN: 'The calculated distance is increased by a percentage to determine the rate.'
    },
    fuelFeeType: {
        NL: 'Brandstof afhankelijke toeslag',
        EN: 'Fuel surcharge'
    },
    fuelFeeTypeOrderPrice: {
        NL: 'Percentage over de ritprijs',
        EN: 'Percentage of the order price'
    },
    fuelFeeTypeDistanceFee: {
        NL: 'Percentage over kilometertarief',
        EN: 'Percentage of the rate per kilometer'
    },
    percentage: {
        NL: 'Percentage',
        EN: 'Percentage'
    },
    shiftTargetsEnabled: {
        NL: 'Doelen in diensten',
        EN: 'Targets in shifts'
    },
    adminOrderPartners: {
        NL: 'Rit partners',
        EN: 'Order partners'
    },
    adminConnectionAvailable: {
        NL: ({name}: {name: string}) => `${name} koppeling beschikbaar`,
        EN: ({name}: {name: string}) => `${name} connection available`
    },
    adminConnectionAvailableInfo: {
        NL: 'Als deze optie wordt uitgezet moet de koppeling handmatig worden gedeactiveerd in het account van de reseller.',
        EN: 'If this option is turned off, the connection must be deactivated manually in the reseller\'s account.'
    },
    adminIntrapostEnabledInfo: {
        NL: 'Als deze optie wordt uitgezet kan de reseller geen zendingen meer via Intrapost aanmelden.',
        EN: 'If this option is turned off, the reseller can no longer register parcels with Intrapost.'
    },
    adminCustomBrandingEnabled: {
        NL: 'Custom branding beschikbaar',
        EN: 'Custom branding available'
    },
    adminCustomBrandingEnabledInfo: {
        NL: 'Hier zit mollie facturatie aan gekoppeld',
        EN: 'Mollie invoicing is linked to this'
    },
    adminDomain: {
        NL: 'Domeinnaam',
        EN: 'Domain name'
    },
    adminDomainInfo: {
        NL: 'Domeinnaam zonder https://',
        EN: 'Domain name without https://'
    },
    adminAllowCustomerContracts: {
        NL: 'Klant vervoerders contracten toegestaan',
        EN: 'Customer carrier contracts allowed'
    },
    adminAllowBranches: {
        NL: 'Vestigingen beschikbaar',
        EN: 'Branches available'
    },
    adminPostNLMailbox48HEnabled: {
        NL: 'PostNL Brievenbuspakket 48 uurs beschikbaar',
        EN: 'PostNL mailbox parcel 48 hours available'
    },
    defaultPriceTable: {
        NL: 'Standaard tarieftabel',
        EN: 'Default price table'
    },
    help: {
        NL: 'Help',
        EN: 'Help'
    },
    photos: {
        NL: 'foto\'s',
        EN: 'photos'
    },
    cameraTakePicture: {
        NL: 'Foto maken',
        EN: 'Take photo'
    },
    cameraTorch: {
        NL: 'Zaklamp',
        EN: 'Flashlight'
    },
    cameraPermissionDenied: {
        NL: 'Geen toegang tot de camera. Zet cameratoegang voor de koeriersapp aan in de instellingen van je browser en probeer het opnieuw. Je kunt wel een foto uit je galerij kiezen.',
        EN: 'No access to the camera. Allow camera access for the courier app in your browser settings and try again. You can still choose a photo from your gallery.'
    },
    cameraNotFound: {
        NL: 'Geen camera gevonden. Je kunt wel een foto uit je galerij kiezen.',
        EN: 'No camera found. You can still choose a photo from your gallery.'
    },
    cameraInUse: {
        NL: 'De camera is in gebruik door een andere app. Sluit die app en probeer het opnieuw. Je kunt wel een foto uit je galerij kiezen.',
        EN: 'The camera is being used by another app. Close that app and try again. You can still choose a photo from your gallery.'
    },
    cameraCouldNotStart: {
        NL: 'De camera kon niet starten. Controleer of cameratoegang voor de koeriersapp aan staat in de instellingen van je browser. Je kunt wel een foto uit je galerij kiezen.',
        EN: 'The camera could not start. Check that camera access for the courier app is allowed in your browser settings. You can still choose a photo from your gallery.'
    },
    tableRowsPerPage: {
        NL: 'Aantal per pagina',
        EN: 'Rows per page'
    },
    tableAddPageToSelection: {
        NL: 'Voeg pagina toe aan selectie',
        EN: 'Add page to selection'
    },
    tableSelectedCount: {
        NL: ({selected, total}: {selected: number, total: number}) => `${selected} van ${total} geselecteerd`,
        EN: ({selected, total}: {selected: number, total: number}) => `${selected} of ${total} selected`
    },
    tableSelectRow: {
        NL: 'Selecteer rij',
        EN: 'Select row'
    },
    tableSelectAll: {
        NL: 'Selecteer alles',
        EN: 'Select all'
    },
    tableSelectionMenu: {
        NL: 'Selectie',
        EN: 'Selection'
    },
    tableSettings: {
        NL: 'Tabelinstellingen',
        EN: 'Table settings'
    },
    tableSortOptions: {
        NL: 'Sorteren op',
        EN: 'Sort by'
    },
    tableFirstPage: {
        NL: 'Eerste pagina',
        EN: 'First page'
    },
    tablePreviousPage: {
        NL: 'Vorige pagina',
        EN: 'Previous page'
    },
    tableNextPage: {
        NL: 'Volgende pagina',
        EN: 'Next page'
    },
    tableLastPage: {
        NL: 'Laatste pagina',
        EN: 'Last page'
    },
    tablePage: {
        NL: ({page}: {page: number}) => `Pagina ${page}`,
        EN: ({page}: {page: number}) => `Page ${page}`
    },
    tableNoResults: {
        NL: 'Geen resultaten',
        EN: 'No results'
    },
    importColumnDebtorCode: {
        NL: 'Debiteurnummer',
        EN: 'Debtor number'
    },
    importColumnBarcode: {
        NL: 'Barcode',
        EN: 'Barcode'
    },
    importColumnColliType: {
        NL: 'Inhoud: Collo type',
        EN: 'Content: Collo type'
    },
    importColumnNotes: {
        NL: 'Opmerkingen',
        EN: 'Notes'
    },
    importColumnNrOfDeliveries: {
        NL: 'Aantal bezorgpogingen',
        EN: 'Number of delivery attempts'
    },
    importColumnQuantity: {
        NL: 'Inhoud: Aantal',
        EN: 'Content: Quantity'
    },
    importColumnDescription: {
        NL: 'Inhoud: omschrijving',
        EN: 'Content: description'
    },
    importColumnWeight: {
        NL: 'Inhoud: Gewicht (g)',
        EN: 'Content: Weight (g)'
    },
    importColumnLength: {
        NL: 'Inhoud: Lengte (mm)',
        EN: 'Content: Length (mm)'
    },
    importColumnWidth: {
        NL: 'Inhoud: Breedte (mm)',
        EN: 'Content: Width (mm)'
    },
    importColumnHeight: {
        NL: 'Inhoud: Hoogte (mm)',
        EN: 'Content: Height (mm)'
    },
    importOrdersCreated: {
        NL: ({count}: {count: number}) => `${count} nieuwe ${count === 1 ? 'rit' : 'ritten'} aangemaakt.`,
        EN: ({count}: {count: number}) => `${count} new ${count === 1 ? 'order' : 'orders'} created.`
    },
    importLine: {
        NL: ({line, message}: {line: number, message: string}) => `Regel ${line}: ${message}`,
        EN: ({line, message}: {line: number, message: string}) => `Line ${line}: ${message}`
    },
    importCustomerNotFound: {
        NL: ({customer}: {customer: string}) => `Klant ${customer} kan niet worden gevonden.`,
        EN: ({customer}: {customer: string}) => `Customer ${customer} can't be found.`
    },
    importCsvColumnsNotSaved: {
        NL: ({error}: {error: string}) => `De kolomindeling kon niet worden opgeslagen: ${error}`,
        EN: ({error}: {error: string}) => `The column layout could not be saved: ${error}`
    },
    importOrderType: {
        NL: 'Type rit',
        EN: 'Order type'
    },
    importOrderTypeDelivery: {
        NL: 'Alleen bezorgen',
        EN: 'Delivery only'
    },
    importOrderTypePickup: {
        NL: 'Alleen ophalen',
        EN: 'Pickup only'
    },
    importOrderTypePickupDelivery: {
        NL: 'Ophalen en bezorgen',
        EN: 'Pickup and delivery'
    },
    importOrderTypeMultiOrder: {
        NL: 'Multirit, adressen binnen één rit',
        EN: 'Multi-stop order, addresses within one order'
    },
    routeActions: {
        NL: 'Route acties',
        EN: 'Route actions'
    },
    hideRoutes: {
        NL: 'Routes verbergen',
        EN: 'Hide routes'
    },
    optimizeRoutes: {
        NL: 'Routes optimaliseren',
        EN: 'Optimize routes'
    },
    makeRoutesReady: {
        NL: 'Routes gereed maken',
        EN: 'Make routes ready'
    },
    editRoutes: {
        NL: 'Routes wijzigen',
        EN: 'Edit routes'
    },
    moveRoutes: {
        NL: 'Routes verplaatsen',
        EN: 'Move routes'
    },
    completeRoutes: {
        NL: 'Routes afronden',
        EN: 'Complete routes'
    },
    deleteRoutes: {
        NL: 'Routes verwijderen',
        EN: 'Delete routes'
    },
    routeBulkCancel: {
        NL: 'Selectie sluiten',
        EN: 'Close selection'
    },
    routeBulkAlreadyHidden: {
        NL: 'Route is al verborgen',
        EN: 'Route is already hidden'
    },
    routeBulkReadyOrStarted: {
        NL: 'Route staat op Gereed of is onderweg',
        EN: 'Route is ready or underway'
    },
    routeBulkConcept: {
        NL: 'Route staat op Concept',
        EN: 'Route is a draft'
    },
    routeBulkStarted: {
        NL: 'Route is onderweg',
        EN: 'Route is underway'
    },
    routeBulkCompleted: {
        NL: 'Route is afgerond',
        EN: 'Route is completed'
    },
    routeBulkNoCompletedStops: {
        NL: 'Route heeft geen afgeronde stops',
        EN: 'Route has no completed stops'
    },
    routeBulkRemoved: {
        NL: 'Route bestaat niet meer',
        EN: 'Route no longer exists'
    },
    routeBulkReadyStartedOrCompletedStops: {
        NL: 'Route staat op Gereed, is gestart of heeft afgeronde stops',
        EN: 'Route is ready, has started or has completed stops'
    },
    routeBulkReadyText: {
        NL: 'Weet je zeker dat je deze routes gereed wilt maken?',
        EN: 'Are you sure you want to make these routes ready?'
    },
    routeBulkUnreadyText: {
        NL: 'Weet je zeker dat je deze routes wilt wijzigen?',
        EN: 'Are you sure you want to edit these routes?'
    },
    routeBulkRescheduleText: {
        NL: 'Naar welke datum wil je deze routes verplaatsen?',
        EN: 'To which date do you want to move these routes?'
    },
    routeBulkStopText: {
        NL: 'Niet afgeronde stops worden uit de routes verwijderd. Weet je zeker dat je deze routes wilt afronden?',
        EN: 'Stops that are not completed will be removed from the routes. Are you sure you want to complete these routes?'
    },
    routeBulkRemoveText: {
        NL: 'Weet je zeker dat je deze routes wilt verwijderen?',
        EN: 'Are you sure you want to remove these routes?'
    },
    routeBulkRemoveTemplateRoutes: {
        NL: 'Er zitten routes vanuit route templates tussen; deze zijn niet meer terug te halen.',
        EN: 'Some routes were created from route templates; these cannot be restored.'
    },
    routeBulkRemoveRoutesWithStops: {
        NL: 'Er zitten routes met stops tussen.',
        EN: 'Some routes contain stops.'
    },
    routeBulkErrorsTitle: {
        NL: 'Niet alle routes verwerkt',
        EN: 'Not all routes processed'
    },
    routeBulkErrorsText: {
        NL: ({success, total}: {success: number, total: number}) => `${success} van ${total} routes verwerkt.`,
        EN: ({success, total}: {success: number, total: number}) => `${success} of ${total} routes processed.`
    },
    routeReadyWarningTooMuchColli: {
        NL: 'Deze route bevat meer colli dan het laadvermogen van het geselecteerde voertuig.',
        EN: 'This route contains more colli than the payload of the selected vehicle.'
    },
    routeReadyWarningTooHeavy: {
        NL: 'Deze route bevat colli die zwaarder zijn dan het laadvermogen van het geselecteerde voertuig.',
        EN: 'This route contains colli that are heavier than the payload of the selected vehicle.'
    },
    routeReadyWarningTooFar: {
        NL: 'Deze route is langer dan het bereik van het geselecteerde voertuig.',
        EN: 'This route is longer than the range of the selected vehicle.'
    },
    routeReadyWarningNotInTimeSlots: {
        NL: 'Deze route haalt niet alle stops binnen het aangegeven tijdvak.',
        EN: 'This route does not reach all stops within their time slot.'
    },
    routeReadyWarningVehicleOverlaps: {
        NL: 'Deze route heeft een dubbel geboekt voertuig.',
        EN: 'This route has a double booked vehicle.'
    },
    routeReadyWarningMessengerOverlaps: {
        NL: 'Deze route heeft een dubbel geboekte koerier.',
        EN: 'This route has a double booked courier.'
    },
    noResponseFromServer: {
        NL: 'Geen reactie van de server ontvangen',
        EN: 'No response received from the server'
    },
    planning: {
        NL: 'Planning',
        EN: 'Planning'
    },
    dayPlanning: {
        NL: 'Dagplanning',
        EN: 'Day planning'
    },
    routes: {
        NL: 'Routes',
        EN: 'Routes'
    },
    stops: {
        NL: 'Stops',
        EN: 'Stops'
    },
    otherOptions: {
        NL: 'Overige opties',
        EN: 'Other options'
    },
    addressOrder: {
        NL: 'Adres volgorde',
        EN: 'Address order'
    },
    addressOrderInfo: {
        NL: 'De volgorde waarin de rit gereden mag worden, de automatische routeoptimalisatie houdt hier rekening mee.',
        EN: 'The order in which the order may be driven, the automatic route optimization takes this into account.'
    },
    addressOrderFixed: {
        NL: 'Vaste volgorde',
        EN: 'Fixed order'
    },
    addressOrderRandom: {
        NL: 'Willekeurig',
        EN: 'Any order'
    },
    nrOfDeliveries: {
        NL: 'Aantal bezorgpogingen',
        EN: 'Number of delivery attempts'
    },
    nrOfDeliveriesInfo: {
        NL: 'Ritten worden automatisch verplaatst naar de volgende werkdag na een mislukte bezorgpoging tot het maximaal aantal bezorgpogingen is bereikt. Vul 0 in om ritten nooit automatisch te verplaatsen.',
        EN: 'Orders are automatically moved to the next working day after a failed delivery attempt until the maximum number of delivery attempts is reached. Enter 0 to never move orders automatically.'
    },
    autoRetour: {
        NL: 'Automatisch retour',
        EN: 'Automatic return'
    },
    nrOfDaysBeforeRetour: {
        NL: 'Bewaartijd',
        EN: 'Storage period'
    },
    nrOfDaysBeforeRetourInfo: {
        NL: 'Hoeveel dagen blijft de rit in bewaring na de laatste bezorgpoging. Vul 0 in om na de laatste bezorgpoging meteen een retourrit aan te maken.',
        EN: 'How many days the order is kept in storage after the last delivery attempt. Enter 0 to create a return order right after the last delivery attempt.'
    },
    allowAddCollo: {
        NL: 'Collo toevoegen toestaan',
        EN: 'Allow adding collo'
    },
    allowAddColloDeliver: {
        NL: 'Alleen bij bezorgen',
        EN: 'Only when delivering'
    },
    allowAddColloPickup: {
        NL: 'Alleen bij ophalen',
        EN: 'Only when picking up'
    },
    monitorTemperature: {
        NL: 'Geconditioneerd transport',
        EN: 'Temperature controlled transport'
    },
    sensorId: {
        NL: 'Sensor ID',
        EN: 'Sensor ID'
    },
    minTemperature: {
        NL: 'Minimum temperatuur',
        EN: 'Minimum temperature'
    },
    maxTemperature: {
        NL: 'Maximum temperatuur',
        EN: 'Maximum temperature'
    },
    selectArea: {
        NL: 'Selecteren',
        EN: 'Select'
    },
    selectLasso: {
        NL: 'Lasso selecteren',
        EN: 'Lasso select'
    },
    moveMap: {
        NL: 'Kaart bewegen',
        EN: 'Move map'
    },
    unplannedAddresses: {
        NL: 'Ongeplande adressen',
        EN: 'Unplanned addresses'
    },
    addressesInRoutes: {
        NL: 'Adressen in routes',
        EN: 'Addresses in routes'
    },
    completedAddresses: {
        NL: 'Afgeronde adressen',
        EN: 'Completed addresses'
    },
    expectedAddresses: {
        NL: 'Verwachte adressen',
        EN: 'Expected addresses'
    },
    stopNumbers: {
        NL: 'Stopnummers',
        EN: 'Stop numbers'
    },
    depots: {
        NL: 'Depots',
        EN: 'Depots'
    },
    displayOptions: {
        NL: 'Weergaveopties',
        EN: 'Display options'
    },
    resetFocus: {
        NL: 'Reset focus',
        EN: 'Reset focus'
    },
    showAllHiddenRoutes: {
        NL: 'Toon alle verborgen routes',
        EN: 'Show all hidden routes'
    },
    exportTemplate: {
        NL: 'Export template',
        EN: 'Export template'
    },
    exportMethod: {
        NL: 'Export methode',
        EN: 'Export method'
    },
    exportTemplateNew: {
        NL: 'Nieuw',
        EN: 'New'
    },
    exportTemplateDefault: {
        NL: 'Standaard',
        EN: 'Default'
    },
    exportTemplateAddColumn: {
        NL: 'Veld toevoegen',
        EN: 'Add field'
    },
    exportTemplateSave: {
        NL: 'Template opslaan',
        EN: 'Save template'
    },
    exportTemplateRemove: {
        NL: 'Template verwijderen',
        EN: 'Delete template'
    },
    exportTemplateOverwriteText: {
        NL: 'Je gaat een bestaande template overschrijven. Weet je zeker dat je door wil gaan?',
        EN: 'You are about to overwrite an existing template. Are you sure you want to continue?'
    },
    exportTemplateAddText: {
        NL: 'Je gaat een nieuw template toevoegen. Weet je zeker dat je door wil gaan?',
        EN: 'You are about to add a new template. Are you sure you want to continue?'
    },
    exportTemplateRemoveFailed: {
        NL: 'Kan template niet verwijderen.',
        EN: 'Could not delete the template.'
    },
    exportOrders: {
        NL: 'Ritten exporteren',
        EN: 'Export orders'
    },
    exportRoutes: {
        NL: 'Routes exporteren',
        EN: 'Export routes'
    },
    exportPerOrder: {
        NL: 'Per rit',
        EN: 'Per order'
    },
    exportPerAddress: {
        NL: 'Per adres',
        EN: 'Per address'
    },
    exportPerCollo: {
        NL: 'Per collo',
        EN: 'Per collo'
    },
    exportPerRoute: {
        NL: 'Per route',
        EN: 'Per route'
    },
    exportTemplateNameExists: {
        NL: ({name}: {name: string}) => `Er bestaat al een template met naam: ${name}`,
        EN: ({name}: {name: string}) => `A template with this name already exists: ${name}`
    },
    exportTemplateSaved: {
        NL: ({name}: {name: string}) => `Template ${name} is opgeslagen.`,
        EN: ({name}: {name: string}) => `Template ${name} has been saved.`
    },
    exportTemplateRemoveText: {
        NL: ({name}: {name: string}) => `Je gaat het export template ${name} verwijderen. Weet je zeker dat je door wil gaan?`,
        EN: ({name}: {name: string}) => `You are about to delete the export template ${name}. Are you sure you want to continue?`
    },
    exportTemplateRemoved: {
        NL: ({name}: {name: string}) => `Template ${name} is verwijderd`,
        EN: ({name}: {name: string}) => `Template ${name} has been deleted`
    },
    exportInvoices: {
        NL: 'Facturen exporteren',
        EN: 'Export invoices'
    },
    exportPerInvoice: {
        NL: 'Per factuur',
        EN: 'Per invoice'
    },
    exportPerInvoiceLine: {
        NL: 'Per factuurregel',
        EN: 'Per invoice line'
    },
    routeTemplates: {
        NL: 'Route templates',
        EN: 'Route templates'
    },
    manualInput: {
        NL: 'Handmatige invoer',
        EN: 'Manual input'
    },
    drag: {
        NL: 'Verslepen',
        EN: 'Drag'
    },
    moreOptions: {
        NL: 'Meer opties',
        EN: 'More options'
    },
    trackTraceSearchIntro: {
        NL: 'Vul hieronder de track & trace code en de postcode van je pakket in.',
        EN: 'Enter the track & trace code and the postal code of your parcel below.'
    },
    trackTraceCode: {
        NL: 'Track & Trace code',
        EN: 'Track & Trace code'
    },
    searchButton: {
        NL: 'Zoeken',
        EN: 'Search'
    },
    trackTraceNotFound: {
        NL: (trackTrace: string) => `Geen zending gevonden met Track & Trace code: ${trackTrace}`,
        EN: (trackTrace: string) => `No shipment found with Track & Trace code: ${trackTrace}`
    },
    recipientChoiceSafePlace: {
        NL: (place: string) => `Veilige plek: ${place}`,
        EN: (place: string) => `Safe place: ${place}`
    },
    recipientChoiceNeighbour: {
        NL: (nr: string) => `Bij de buren: huisnummer ${nr}`,
        EN: (nr: string) => `At the neighbours: house number ${nr}`
    },
    recipientChoicePickupPoint: {
        NL: (name: string) => `Ophalen bij ${name}`,
        EN: (name: string) => `Collect at ${name}`
    },
    recipientInstructionsShort: {
        NL: (instructions: string) => `Instructie: ${instructions}`,
        EN: (instructions: string) => `Instruction: ${instructions}`
    },
    ttsBreadcrumb: {
        NL: 'Instellingen / Planning',
        EN: 'Settings / Planning'
    },
    ttsTitle: {
        NL: 'Track & Trace-pagina',
        EN: 'Track & Trace page'
    },
    ttsIntro: {
        NL: 'Bepaal hoe je ontvangers hun zending volgen. Wijzigingen worden direct opgeslagen.',
        EN: 'Decide how your recipients follow their shipment. Changes are saved right away.'
    },
    ttsUseNewPage: {
        NL: 'Nieuwe Track & Trace-pagina gebruiken',
        EN: 'Use the new Track & Trace page'
    },
    ttsNewPageOn: {
        NL: 'Aan: alle Track & Trace-links van je zendingen openen de nieuwe pagina.',
        EN: 'On: all Track & Trace links of your shipments open the new page.'
    },
    ttsNewPageOff: {
        NL: 'Uit: ontvangers zien nog de huidige pagina. Je kunt hier alvast alles instellen en bekijken.',
        EN: 'Off: recipients still see the current page. You can already set up and preview everything here.'
    },
    ttsSwitchoverDate: {
        NL: (date: string) => `Vanaf ${date} gebruiken alle ontvangers de nieuwe pagina. Nieuwe functies zet je zelf aan.`,
        EN: (date: string) => `From ${date} all recipients use the new page. You switch on new features yourself.`
    },
    ttsTabStyle: {
        NL: 'Huisstijl',
        EN: 'Branding'
    },
    ttsTabFeatures: {
        NL: 'Functies',
        EN: 'Features'
    },
    ttsTabTexts: {
        NL: 'Teksten',
        EN: 'Texts'
    },
    ttsTabLanguages: {
        NL: 'Talen',
        EN: 'Languages'
    },
    ttsLogo: {
        NL: 'Logo',
        EN: 'Logo'
    },
    ttsCurrentLogo: {
        NL: 'Huidig logo',
        EN: 'Current logo'
    },
    ttsLogoInfo: {
        NL: 'Het logo staat bovenaan de pagina. Je wijzigt het bij Bedrijfsgegevens, omdat het ook in de planner en op zendingen wordt gebruikt.',
        EN: 'The logo is shown at the top of the page. You change it in Company details, because it is also used in the planner and on shipments.'
    },
    ttsCompanyDetails: {
        NL: 'Naar bedrijfsgegevens',
        EN: 'Go to company details'
    },
    ttsMainColor: {
        NL: 'Hoofdkleur',
        EN: 'Main colour'
    },
    ttsColorHex: {
        NL: 'Kleur (hex)',
        EN: 'Colour (hex)'
    },
    ttsColorInfo: {
        NL: 'Je bedrijfskleur voor de merkband, de voortgang en de knoppen. Die wordt ook gebruikt in e-mails en in de planner.',
        EN: 'Your company colour for the brand band, the progress and the buttons. It is also used in emails and in the planner.'
    },
    ttsContrastOk: {
        NL: (value: string) => `Contrast met witte tekst: ${value}:1. Goed leesbaar.`,
        EN: (value: string) => `Contrast with white text: ${value}:1. Easy to read.`
    },
    ttsContrastLow: {
        NL: (value: string) => `Contrast met witte tekst: ${value}:1. Te licht voor witte tekst, de pagina gebruikt daarom donkere tekst op deze kleur.`,
        EN: (value: string) => `Contrast with white text: ${value}:1. Too light for white text, so the page uses dark text on this colour.`
    },
    ttsContact: {
        NL: 'Contact en voettekst',
        EN: 'Contact and footer'
    },
    ttsField_phone: {
        NL: 'Telefoon',
        EN: 'Phone'
    },
    ttsField_whatsapp: {
        NL: 'WhatsApp',
        EN: 'WhatsApp'
    },
    ttsField_email: {
        NL: 'E-mail',
        EN: 'Email'
    },
    ttsField_footerTitle: {
        NL: 'Titel voettekst',
        EN: 'Footer title'
    },
    ttsFooterMessage: {
        NL: 'Voettekst',
        EN: 'Footer text'
    },
    ttsHideAddress: {
        NL: 'Bedrijfsadres verbergen',
        EN: 'Hide company address'
    },
    ttsHideAddressInfo: {
        NL: (name: string) => `Het adres van ${name} staat dan niet onderaan de pagina.`,
        EN: (name: string) => `The address of ${name} is then not shown at the bottom of the page.`
    },
    ttsActionsTitle: {
        NL: 'Wat mogen ontvangers aanpassen?',
        EN: 'What may recipients change?'
    },
    ttsActionsInfo: {
        NL: 'Ontvangers kunnen hun keuze wijzigen zolang de zending nog niet is bezorgd. Veilige plek is niet zichtbaar bij handtekening, handtekening buren, leeftijds- of ID-controle of een bezorgcode. Bij de buren is niet zichtbaar bij handtekening, "niet bij buren", leeftijds- of ID-controle of een bezorgcode. De koerier ziet de keuze in de app en de wijziging staat in de historie van de rit.',
        EN: 'Recipients can change their choice as long as the shipment has not been delivered. Safe place is not shown with a signature, neighbour signature, age or ID check or a delivery code. Neighbours is not shown with a signature, "not at neighbours", age or ID check or a delivery code. The courier sees the choice in the app and the change is in the history of the order.'
    },
    ttsSafePlace: {
        NL: 'Veilige plek',
        EN: 'Safe place'
    },
    ttsSafePlaceInfo: {
        NL: 'Ontvanger kiest een plek bij huis waar het pakket zonder handtekening mag blijven. De koerier maakt dan een foto.',
        EN: 'The recipient chooses a place at home where the parcel may be left without a signature. The courier then takes a photo.'
    },
    ttsNeighbour: {
        NL: 'Bezorgen bij de buren',
        EN: 'Deliver to the neighbours'
    },
    ttsNeighbourInfo: {
        NL: 'Ontvanger geeft het huisnummer van een buur door.',
        EN: 'The recipient gives the house number of a neighbour.'
    },
    ttsPickupPoint: {
        NL: 'Ophalen bij een afhaalpunt',
        EN: 'Collect at a pickup point'
    },
    ttsPickupPointInfo: {
        NL: 'Ontvanger haalt het pakket op bij een van jouw eigen locaties.',
        EN: 'The recipient collects the parcel at one of your own locations.'
    },
    ttsInstructions: {
        NL: 'Instructie voor de bezorger',
        EN: 'Instruction for the courier'
    },
    ttsInstructionsInfo: {
        NL: 'Vrije tekst van maximaal 200 tekens, naast de instructies van de afzender.',
        EN: 'Free text of at most 200 characters, next to the instructions of the sender.'
    },
    ttsDeliveryDay: {
        NL: 'Andere bezorgdag kiezen',
        EN: 'Choose another delivery day'
    },
    ttsDeliveryDayInfo: {
        NL: 'De ontvanger kiest een andere bezorgdag, zolang de route nog niet gereed is.',
        EN: 'The recipient chooses another delivery day, as long as the route is not ready yet.'
    },
    ttsDeliveryDayCount: {
        NL: 'Aantal bezorgdagen om uit te kiezen',
        EN: 'Number of delivery days to choose from'
    },
    ttsSafePlaces: {
        NL: 'Veilige plekken waaruit de ontvanger kiest',
        EN: 'Safe places the recipient chooses from'
    },
    ttsRemoveItem: {
        NL: (name: string) => `${name} verwijderen`,
        EN: (name: string) => `Remove ${name}`
    },
    ttsAddPlace: {
        NL: 'Plek toevoegen',
        EN: 'Add a place'
    },
    ttsAddPlacePlaceholder: {
        NL: 'Bijv. meterkast',
        EN: 'E.g. meter cupboard'
    },
    ttsAdd: {
        NL: 'Toevoegen',
        EN: 'Add'
    },
    ttsOtherPlaceInfo: {
        NL: '"Anders", met een eigen omschrijving, staat altijd als laatste optie.',
        EN: '"Other", with a description of its own, is always the last option.'
    },
    ttsPickupPoints: {
        NL: 'Afhaalpunten waaruit de ontvanger kiest',
        EN: 'Pickup points the recipient chooses from'
    },
    ttsNoPickupPoints: {
        NL: 'Voeg een afhaalpunt toe. Zonder afhaalpunten zien ontvangers deze keuze niet.',
        EN: 'Add a pickup point. Without pickup points recipients do not see this choice.'
    },
    ttsPickupPointNr: {
        NL: (nr: number) => `Afhaalpunt ${nr}`,
        EN: (nr: number) => `Pickup point ${nr}`
    },
    ttsPickupPointName: {
        NL: 'Naam',
        EN: 'Name'
    },
    ttsPickupPointAddress: {
        NL: 'Adres',
        EN: 'Address'
    },
    ttsOpeningHours: {
        NL: 'Openingstijden',
        EN: 'Opening hours'
    },
    ttsAddPickupPoint: {
        NL: 'Afhaalpunt toevoegen',
        EN: 'Add pickup point'
    },
    ttsPickupPeriod: {
        NL: 'Ophaaltermijn (werkdagen)',
        EN: 'Pickup period (working days)'
    },
    ttsPickupPeriodInfo: {
        NL: 'Zo lang ligt het pakket klaar na de keuze van de ontvanger. Daarna gaat de rit retour, net als bij In bewaring.',
        EN: 'This is how long the parcel is ready after the recipient\'s choice. After that the order is returned, as with On hold.'
    },
    ttsDisplay: {
        NL: 'Weergave',
        EN: 'Display'
    },
    ttsTimeFrame: {
        NL: 'Tijdvak voor bezorging',
        EN: 'Delivery time window'
    },
    ttsTimeFrameInfo: {
        NL: 'Zodra er een ETA is, valt 1/3 van het tijdvak vóór de ETA en 2/3 erna.',
        EN: 'Once there is an ETA, 1/3 of the window is before the ETA and 2/3 after it.'
    },
    ttsMinutes: {
        NL: (count: number) => `${count} minuten`,
        EN: (count: number) => `${count} minutes`
    },
    ttsHours: {
        NL: (count: number) => `${count} uur`,
        EN: (count: number) => `${count} hours`
    },
    ttsHidePhoto: {
        NL: 'Foto van aflevering verbergen',
        EN: 'Hide delivery photo'
    },
    ttsHidePhotoInfo: {
        NL: 'Ontvangers zien dan alleen wie de zending heeft aangenomen en de handtekening.',
        EN: 'Recipients then only see who received the shipment and the signature.'
    },
    ttsStatusIcon: {
        NL: 'Status icoon onderweg',
        EN: 'Status icon on the way'
    },
    ttsStatusIconInfo: {
        NL: 'Het icoon van de bezorger op de kaart, en op de huidige pagina bij de status onderweg.',
        EN: 'The icon of the courier on the map, and on the current page for the status on the way.'
    },
    ttsBike: {
        NL: 'Fiets',
        EN: 'Bike'
    },
    ttsCargoBike: {
        NL: 'Bakfiets',
        EN: 'Cargo bike'
    },
    ttsCar: {
        NL: 'Auto',
        EN: 'Car'
    },
    ttsOwnContent: {
        NL: 'Eigen inhoud',
        EN: 'Own content'
    },
    ttsOwnContentInfo: {
        NL: 'Blokken die je zelf vult. Laat je een veld leeg, dan zien ontvangers het blok niet.',
        EN: 'Blocks you fill in yourself. If you leave a field empty, recipients do not see the block.'
    },
    ttsMap: {
        NL: 'Kaart',
        EN: 'Map'
    },
    ttsMapInfo: {
        NL: 'Op de dag van bezorging zien ontvangers waar de bezorger is. Andere adressen zijn nooit zichtbaar, alleen het aantal stops.',
        EN: 'On the day of delivery recipients see where the courier is. Other addresses are never shown, only the number of stops.'
    },
    ttsMapNone: {
        NL: 'Geen kaart',
        EN: 'No map'
    },
    ttsMapRecipient: {
        NL: 'Alleen locatie ontvanger',
        EN: 'Recipient\'s location only'
    },
    ttsMapCourier: {
        NL: 'Locatie ontvanger + koerier',
        EN: 'Recipient\'s location + courier'
    },
    ttsMapCourierStops: {
        NL: 'Locatie ontvanger + koerier en aantal tussenliggende stops',
        EN: 'Recipient\'s location + courier and number of stops in between'
    },
    ttsShowPhoto: {
        NL: 'Foto tonen',
        EN: 'Show photo'
    },
    ttsPhotoDesktop: {
        NL: 'Foto desktop',
        EN: 'Desktop photo'
    },
    ttsPhotoMobile: {
        NL: 'Foto mobiel',
        EN: 'Mobile photo'
    },
    ttsPhotoSize: {
        NL: (size: string) => `Liggend, minimaal ${size} px.`,
        EN: (size: string) => `Landscape, at least ${size} px.`
    },
    ttsShowMessage: {
        NL: 'Bericht tonen',
        EN: 'Show message'
    },
    ttsRecipientMessage: {
        NL: 'Bericht aan ontvangers',
        EN: 'Message to recipients'
    },
    ttsRecipientMessageInfo: {
        NL: (max: number) => `Maximaal ${max} tekens. Laat leeg om geen bericht te tonen.`,
        EN: (max: number) => `At most ${max} characters. Leave empty to show no message.`
    },
    ttsMessagesTitle: {
        NL: 'Berichten per situatie',
        EN: 'Messages per situation'
    },
    ttsMessagesInfo: {
        NL: 'Laat een bericht leeg om de standaardtekst te tonen. Het voorbeeld toont de gekozen taal.',
        EN: 'Leave a message empty to show the default text. The preview shows the chosen language.'
    },
    ttsDefaultText: {
        NL: (text: string) => `Standaard: ${text}`,
        EN: (text: string) => `Default: ${text}`
    },
    ttsGroupPickup: {
        NL: 'Ophalen',
        EN: 'Pickup'
    },
    ttsGroupNotCompleted: {
        NL: 'Bezorgen niet gelukt',
        EN: 'Delivery not successful'
    },
    ttsGroupNotHome: {
        NL: 'Niet thuis',
        EN: 'Not at home'
    },
    ttsGroupOther: {
        NL: 'Overig',
        EN: 'Other'
    },
    ttsMessagePickupNotCompleted: {
        NL: 'Ophalen niet gelukt',
        EN: 'Pickup not successful'
    },
    ttsMessagePickupNotHome: {
        NL: 'Ophalen niet thuis',
        EN: 'Pickup not at home'
    },
    ttsMessagePickupCancelled: {
        NL: 'Ophalen geannuleerd',
        EN: 'Pickup cancelled'
    },
    ttsMessageReschedule: {
        NL: 'Nieuwe bezorgpoging',
        EN: 'New delivery attempt'
    },
    ttsMessageWrongAddress: {
        NL: 'Foutief adres, retour',
        EN: 'Wrong address, returned'
    },
    ttsMessageRefused: {
        NL: 'Geweigerd',
        EN: 'Refused'
    },
    ttsMessageNoFollowUp: {
        NL: 'Geen vervolg',
        EN: 'No follow-up'
    },
    ttsMessageOnHold: {
        NL: 'In bewaring',
        EN: 'On hold'
    },
    ttsMessageRetour: {
        NL: 'Retour',
        EN: 'Returned'
    },
    ttsMessageCancelled: {
        NL: 'Bezorgen geannuleerd',
        EN: 'Delivery cancelled'
    },
    ttsMessageManco: {
        NL: 'Manco',
        EN: 'Missing'
    },
    ttsFaq: {
        NL: 'Veelgestelde vragen',
        EN: 'Frequently asked questions'
    },
    ttsShowFaq: {
        NL: 'Veelgestelde vragen tonen',
        EN: 'Show frequently asked questions'
    },
    ttsShowFaqInfo: {
        NL: 'Onder "Hulp nodig?" op de pagina.',
        EN: 'Under "Need help?" on the page.'
    },
    ttsQuestionNr: {
        NL: (nr: number) => `Vraag ${nr}`,
        EN: (nr: number) => `Question ${nr}`
    },
    ttsQuestion: {
        NL: 'Vraag',
        EN: 'Question'
    },
    ttsAnswer: {
        NL: 'Antwoord',
        EN: 'Answer'
    },
    ttsAddQuestion: {
        NL: 'Vraag toevoegen',
        EN: 'Add question'
    },
    ttsLanguages: {
        NL: 'Talen',
        EN: 'Languages'
    },
    ttsLanguagesInfo: {
        NL: 'De pagina opent in de taal van de browser van de ontvanger. Staat die taal hier uit, dan gebruiken we de standaardtaal. Ontvangers kunnen zelf van taal wisselen.',
        EN: 'The page opens in the language of the recipient\'s browser. If that language is switched off here, the default language is used. Recipients can switch language themselves.'
    },
    ttsLanguageDutchInfo: {
        NL: 'Berichten zoals je ze bij Teksten invult.',
        EN: 'Messages as you fill them in under Texts.'
    },
    ttsLanguageOtherInfo: {
        NL: 'Standaardteksten, aan te passen bij Teksten.',
        EN: 'Default texts, to be changed under Texts.'
    },
    ttsDefaultLanguage: {
        NL: 'Standaardtaal',
        EN: 'Default language'
    },
    ttsPreview: {
        NL: 'Voorbeeld',
        EN: 'Preview'
    },
    ttsMobile: {
        NL: 'Mobiel',
        EN: 'Mobile'
    },
    ttsDesktop: {
        NL: 'Desktop',
        EN: 'Desktop'
    },
    ttsStateExpected: {
        NL: 'Aangemeld',
        EN: 'Registered'
    },
    ttsStateScheduled: {
        NL: 'Ingepland',
        EN: 'Scheduled'
    },
    ttsStateOnTheWay: {
        NL: 'Onderweg',
        EN: 'On the way'
    },
    ttsStateCompleted: {
        NL: 'Bezorgd',
        EN: 'Delivered'
    },
    ttsStateNotHome: {
        NL: 'Niet thuis',
        EN: 'Not at home'
    },
    ttsStateReturning: {
        NL: 'Retour',
        EN: 'Returned'
    },
    ttsStateOnHold: {
        NL: 'In bewaring',
        EN: 'On hold'
    },
    ttsStateCancelled: {
        NL: 'Geannuleerd',
        EN: 'Cancelled'
    },
    // E-mails in the style of the Track & Trace page (#3845)
    mailDearUser: {
        NL: 'Beste Veloyd gebruiker,',
        EN: 'Dear Veloyd user,'
    },
    mailKindRegards: {
        NL: 'Met vriendelijke groet,',
        EN: 'Kind regards,'
    },
    mailChangePassword: {
        NL: 'Wachtwoord wijzigen',
        EN: 'Change password'
    },
    mailMfaIntro: {
        NL: 'Vul onderstaande verificatie code in om in te loggen op je account.',
        EN: 'Enter the verification code below to log in to your account.'
    },
    mailMfaNotYou: {
        NL: 'Als je niet zelf hebt geprobeerd in te loggen, raden we je aan om je wachtwoord te wijzigen.',
        EN: 'If you did not try to log in yourself, we recommend changing your password.'
    },
    mailFailedLoginIntro: {
        NL: 'Er zijn meerdere onsuccessvolle pogingen gedaan om in te loggen op je account.',
        EN: 'There have been several unsuccessful attempts to log in to your account.'
    },
    mailTimestamp: {
        NL: 'Tijdstip',
        EN: 'Time'
    },
    mailFailedLoginNotYou: {
        NL: 'Als je dit niet zelf was dan is het aan te raden om je wachtwoord te wijzigen.',
        EN: 'If this was not you, we recommend changing your password.'
    },
    mailResetPasswordIntro: {
        NL: 'Er is een aanvraag gedaan om je wachtwoord te wijzigen, klik hiervoor op onderstaande knop',
        EN: 'A request was made to change your password, click the button below to do so'
    },
    mailResetPasswordIgnore: {
        NL: 'Als je je wachtwoord toch niet wilt wijzigen of je hebt niet om deze wijziging gevraagd dan kun je deze email negeren.',
        EN: 'If you do not want to change your password or did not request this change, you can ignore this email.'
    },
    mailCreatePassword: {
        NL: 'Wachtwoord aanmaken',
        EN: 'Create password'
    },
    mailLoginName: {
        NL: 'Je inlognaam',
        EN: 'Your login name'
    },
    mailAccount: {
        NL: 'Account',
        EN: 'Account'
    },
    mailCustomerName: {
        NL: 'Klantnaam',
        EN: 'Customer name'
    },
    mailOpenShipment: {
        NL: 'Open zending',
        EN: 'Open shipment'
    },
    mailShiftName: {
        NL: 'Dienstnaam',
        EN: 'Shift name'
    },
    mailOpenShift: {
        NL: 'Open dienst',
        EN: 'Open shift'
    },
    mailBarcode: {
        NL: 'Barcode',
        EN: 'Barcode'
    },
    mailTrackTrace: {
        NL: 'Track & Trace',
        EN: 'Track & Trace'
    },
    mailAddresses: {
        NL: (count: number) => `${count} adressen`,
        EN: (count: number) => `${count} addresses`
    },
    mailVerificationCodeRequired: {
        NL: 'Voor ontvangst van deze zending is een verificatiecode vereist:',
        EN: 'A verification code is required to receive this shipment:'
    },
    mailStep: {
        NL: ({step, status}: {step: number, status: string}) => `Stap ${step} van 4 · ${status}`,
        EN: ({step, status}: {step: number, status: string}) => `Step ${step} of 4 · ${status}`
    },
    mailStepRegistered: {
        NL: 'Aangemeld',
        EN: 'Registered'
    },
    mailStepScheduled: {
        NL: 'Ingepland',
        EN: 'Scheduled'
    },
    mailStepOnTheWay: {
        NL: 'Onderweg',
        EN: 'On its way'
    },
    mailStepDelivered: {
        NL: 'Bezorgd',
        EN: 'Delivered'
    },
    mailStepCollected: {
        NL: 'Opgehaald',
        EN: 'Collected'
    },
    mailNotCompleted: {
        NL: 'Niet gelukt',
        EN: 'Unsuccessful'
    },
    mailNotHome: {
        NL: 'Niet thuis',
        EN: 'Not at home'
    },
    mailOnHold: {
        NL: 'In bewaring',
        EN: 'On hold'
    },
    mailFollowUp: {
        NL: ({status, followUp}: {status: string, followUp: string}) => `${status} · ${followUp}`,
        EN: ({status, followUp}: {status: string, followUp: string}) => `${status} · ${followUp}`
    },
    mailFollowUpReschedule: {
        NL: 'nieuwe bezorgpoging',
        EN: 'new delivery attempt'
    },
    mailFollowUpRetour: {
        NL: 'retour naar afzender',
        EN: 'returning to sender'
    },
    mailFollowUpNone: {
        NL: 'geen nieuwe poging gepland',
        EN: 'no new attempt scheduled'
    },
    mailPickupContact: {
        NL: (customer: string) => `Neem contact op met ${customer} voor het maken van een nieuwe afspraak.`,
        EN: (customer: string) => `Please contact ${customer} to make a new appointment.`
    },
    mailExpectedDelivery: {
        NL: 'Verwachte bezorging',
        EN: 'Expected delivery'
    },
    mailExpectedPickup: {
        NL: 'Verwacht ophaalmoment',
        EN: 'Expected collection'
    },
    mailNewDelivery: {
        NL: 'Nieuwe bezorging',
        EN: 'New delivery'
    },
    mailPickupUntil: {
        NL: 'Ophalen kan tot',
        EN: 'Collect until'
    },
    mailDeliveredOn: {
        NL: 'Bezorgd op',
        EN: 'Delivered on'
    },
    mailCollectedOn: {
        NL: 'Opgehaald op',
        EN: 'Collected on'
    },
    mailToday: {
        NL: 'Vandaag',
        EN: 'Today'
    },
    mailTomorrow: {
        NL: 'Morgen',
        EN: 'Tomorrow'
    },
    mailDateUnknown: {
        NL: 'Bezorgdatum onbekend',
        EN: 'Delivery date unknown'
    },
    mailWindow: {
        NL: ({from, to}: {from: string, to: string}) => `Tussen ${from} en ${to}`,
        EN: ({from, to}: {from: string, to: string}) => `Between ${from} and ${to}`
    },
    mailArrivedAt: {
        NL: (time: string) => `Om ${time}`,
        EN: (time: string) => `At ${time}`
    },
    mailWindowFollows: {
        NL: 'Het tijdvak volgt zodra je bezorging is ingepland.',
        EN: 'The time slot follows as soon as your delivery is scheduled.'
    },
    mailWindowFollowsPickup: {
        NL: 'Het tijdvak volgt zodra het ophalen is ingepland.',
        EN: 'The time slot follows as soon as the collection is scheduled.'
    },
    mailShipment: {
        NL: 'Zending',
        EN: 'Shipment'
    },
    mailShipmentOf: {
        NL: ({count, sender}: {count: number, sender: string}) => `${count} ${count === 1 ? 'pakket' : 'pakketten'}${sender ? ` van ${sender}` : ''}`,
        EN: ({count, sender}: {count: number, sender: string}) => `${count} ${count === 1 ? 'parcel' : 'parcels'}${sender ? ` from ${sender}` : ''}`
    },
    mailOpeningHours: {
        NL: 'Openingstijden',
        EN: 'Opening hours'
    },
    mailDelivered: {
        NL: 'Afgeleverd',
        EN: 'Delivered'
    },
    mailDeliveredNeighbour: {
        NL: (nr: string) => nr ? `Bij de buren, huisnummer ${nr}` : 'Bij de buren',
        EN: (nr: string) => nr ? `With the neighbours, number ${nr}` : 'With the neighbours'
    },
    mailDeliveredMailbox: {
        NL: 'In de brievenbus',
        EN: 'Through the letterbox'
    },
    mailDeliveredSafePlace: {
        NL: (place: string) => `Op de veilige plek: ${place}`,
        EN: (place: string) => `At the safe place: ${place}`
    },
    mailGoodToKnow: {
        NL: 'Goed om te weten',
        EN: 'Good to know'
    },
    mailReqSignature: {
        NL: 'Er is een handtekening nodig voor ontvangst.',
        EN: 'A signature is required on delivery.'
    },
    mailReqStatedAddressOnly: {
        NL: 'De zending wordt alleen aangeboden bij geadresseerde.',
        EN: 'The shipment is only delivered to the addressee.'
    },
    mailReqMailbox: {
        NL: 'De zending past door de brievenbus.',
        EN: 'The shipment fits through the letterbox.'
    },
    mailReqMinimumAge: {
        NL: (age: number) => `De ontvanger dient ouder te zijn dan ${age} jaar.`,
        EN: (age: number) => `The recipient must be older than ${age}.`
    },
    mailReqIdCheck: {
        NL: 'Een legitimatiebewijs is nodig voor ontvangst.',
        EN: 'An ID is required on delivery.'
    },
    mailReqVerificationCode: {
        NL: 'Voor ontvangst is een bezorgcode vereist:',
        EN: 'A delivery code is required on delivery:'
    },
    mailFollowCourier: {
        NL: 'Volg je bezorger',
        EN: 'Follow your courier'
    },
    mailViewProof: {
        NL: 'Bekijk bewijs van aflevering',
        EN: 'View proof of delivery'
    },
    mailActionsTitle: {
        NL: 'Pas je bezorging aan',
        EN: 'Change your delivery'
    },
    mailActionsIntro: {
        NL: 'Niet thuis? Kies wat het beste uitkomt. Je kiest op de Track & Trace-pagina; de bezorger ziet je keuze direct.',
        EN: 'Not at home? Choose what suits you best. You choose on the Track & Trace page; the courier sees your choice right away.'
    },
    mailTileSafePlace: {
        NL: 'Veilige plek',
        EN: 'Safe place'
    },
    mailTileNeighbour: {
        NL: 'Bij de buren',
        EN: 'Neighbours'
    },
    mailTilePickupPoint: {
        NL: 'Ophalen',
        EN: 'Collect'
    },
    mailTileInstructions: {
        NL: 'Instructie',
        EN: 'Instruction'
    },
    mailTileDeliveryDay: {
        NL: 'Andere dag',
        EN: 'Another day'
    },
    mailTeamOf: {
        NL: (name: string) => `Team ${name}`,
        EN: (name: string) => `Team ${name}`
    },
    mailFooterContact: {
        NL: ({phone, email}: {phone: string, email: string}) => `Vragen over je zending? ${[phone && `Bel ${phone}`, email && `${phone ? 'mail' : 'Mail'} ${email}`].filter(Boolean).join(' of ')}`,
        EN: ({phone, email}: {phone: string, email: string}) => `Questions about your shipment? ${[phone && `Call ${phone}`, email && `${phone ? 'email' : 'Email'} ${email}`].filter(Boolean).join(' or ')}`
    },
    mailFooterReason: {
        NL: (customer: string) => `Je ontvangt deze e-mail omdat ${customer} een zending voor je heeft aangemeld.`,
        EN: (customer: string) => `You receive this email because ${customer} registered a shipment for you.`
    },
    mailSubject: {
        NL: 'Onderwerp',
        EN: 'Subject'
    },
    mailSenderName: {
        NL: 'Afzender naam',
        EN: 'Sender name'
    },
    mailSenderEmail: {
        NL: 'Afzender emailadres',
        EN: 'Sender email address'
    },
    welcomeMail: {
        NL: 'Welkomstmail',
        EN: 'Welcome email'
    },
    welcomeMailUsers: {
        NL: 'Welkomstmail gebruikers',
        EN: 'Welcome email for users'
    },
    welcomeMailUsersInfo: {
        NL: 'Nieuwe gebruikers, zoals planners en koeriers, krijgen deze e-mail met een knop om hun wachtwoord aan te maken.',
        EN: 'New users, such as planners and couriers, receive this email with a button to create their password.'
    },
    welcomeMailPhoto: {
        NL: 'Foto welkomstmail',
        EN: 'Welcome email photo'
    },
    settingsCustomers: {
        NL: 'Klanten',
        EN: 'Customers'
    },
    settingsGeneral: {
        NL: 'Algemeen',
        EN: 'General'
    },
    settingsCompanyDetails: {
        NL: 'Bedrijfsgegevens',
        EN: 'Company details'
    },
    settingsOpeningHours: {
        NL: 'Openingstijden',
        EN: 'Opening hours'
    },
    settingsDeliveryZones: {
        NL: 'Bezorggebieden',
        EN: 'Delivery zones'
    },
    settingsEmail: {
        NL: 'Email Instellingen',
        EN: 'Email settings'
    },
    parcelMailTitle: {
        NL: 'Email notificaties',
        EN: 'Email notifications'
    },
    parcelMailTabConfirmed: {
        NL: 'Aangemeld',
        EN: 'Registered'
    },
    parcelMailTabShipped: {
        NL: 'Verzonden',
        EN: 'Shipped'
    },
    parcelMailTabCancelled: {
        NL: 'Geannuleerd',
        EN: 'Cancelled'
    },
    parcelMailTabRetour: {
        NL: 'Retourbevestiging',
        EN: 'Return confirmation'
    },
    parcelMailCommentConfirmed: {
        NL: 'Dit bericht wordt verstuurd zodra de zending is bevestigd.',
        EN: 'This message is sent as soon as the shipment is confirmed.'
    },
    parcelMailCommentShipped: {
        NL: 'Dit bericht wordt verstuurd zodra de zending door de vervoerder is ontvangen.',
        EN: 'This message is sent as soon as the carrier has received the shipment.'
    },
    parcelMailCommentDelivered: {
        NL: 'Dit bericht wordt verstuurd zodra de zending is bezorgd.',
        EN: 'This message is sent as soon as the shipment is delivered.'
    },
    parcelMailCommentCancelled: {
        NL: 'Dit bericht wordt verstuurd zodra de zending is geannuleerd.',
        EN: 'This message is sent as soon as the shipment is cancelled.'
    },
    parcelMailCommentRetour: {
        NL: 'Dit bericht wordt verstuurd wanneer de retourzending wordt aangemeld.',
        EN: 'This message is sent when the return shipment is registered.'
    },
    deliveredEmailChoice: {
        NL: 'Als de klant een eigen Bezorgd-mail heeft voor de zending',
        EN: 'If the customer has its own Delivered mail for the shipment'
    },
    deliveredEmailChoiceCustomer: {
        NL: 'Bezorgd-mail bij zendingen met een eigen Bezorgd-mail van de klant',
        EN: 'Delivered mail for shipments with the customer\'s own Delivered mail'
    },
    deliveredEmailCustomerOnly: {
        NL: 'Alleen de mail van de klant versturen',
        EN: 'Only send the customer\'s mail'
    },
    deliveredEmailBoth: {
        NL: 'Beide versturen',
        EN: 'Send both'
    },
    useDefaultSetting: {
        NL: 'Gebruik standaard instelling',
        EN: 'Use default setting'
    },
    sendDeliveredEmail: {
        NL: 'Verstuur "Bezorgd" email',
        EN: 'Send "Delivered" email'
    },
    parcelMailIntro: {
        NL: 'Deze emailnotificaties worden verstuurd naar het emailadres van de klant, wanneer je als vervoerder een zending aanmaakt in opdracht van de klant. Emailnotificaties naar de ontvanger worden ingesteld in het klantportaal van de klant.',
        EN: 'These email notifications are sent to the customer\'s email address when you, as the carrier, create a shipment on behalf of the customer. Email notifications to the recipient are set up in the customer portal of the customer.'
    },
    sendConfirmedEmail: {
        NL: 'Verstuur "Aangemeld" email',
        EN: 'Send "Registered" email'
    },
    sendCancelledEmail: {
        NL: 'Verstuur "Geannuleerd" email',
        EN: 'Send "Cancelled" email'
    },
    accountDetails: {
        NL: 'Gegevens',
        EN: 'Details'
    },
    changePassword: {
        NL: 'Wachtwoord wijzigen',
        EN: 'Change password'
    },
    accountDetailsNameNote: {
        NL: 'Je naam kan alleen een beheerder wijzigen.',
        EN: 'Only an administrator can change your name.'
    },
    accountDetailsEmailNote: {
        NL: 'Wijzig je je e-mailadres, dan krijg je een bevestigingsmail op het nieuwe adres. Je e-mailadres wijzigt pas na bevestiging.',
        EN: 'If you change your email address, you get a confirmation mail at the new address. Your email address only changes after confirmation.'
    },
    currentPassword: {
        NL: 'Huidig wachtwoord',
        EN: 'Current password'
    },
    newPassword: {
        NL: 'Nieuw wachtwoord',
        EN: 'New password'
    },
    repeatNewPassword: {
        NL: 'Herhaal nieuw wachtwoord',
        EN: 'Repeat new password'
    },
    showPassword: {
        NL: 'Wachtwoord tonen',
        EN: 'Show password'
    },
    hidePassword: {
        NL: 'Wachtwoord verbergen',
        EN: 'Hide password'
    },
    passwordRequirementsIntro: {
        NL: 'Je nieuwe wachtwoord moet:',
        EN: 'Your new password must:'
    },
    passwordRequirementLength: {
        NL: 'Minstens 12 tekens hebben',
        EN: 'Have at least 12 characters'
    },
    passwordRequirementLetterAndDigit: {
        NL: 'Minstens één letter en één cijfer bevatten',
        EN: 'Contain at least one letter and one digit'
    },
    passwordRequirementDifferent: {
        NL: 'Anders zijn dan je huidige wachtwoord',
        EN: 'Be different from your current password'
    },
    passwordRequirementRepeated: {
        NL: 'Twee keer hetzelfde zijn ingevuld',
        EN: 'Be entered the same twice'
    },
    passwordChanged: {
        NL: 'Je wachtwoord is gewijzigd.',
        EN: 'Your password has been changed.'
    },
    emailChangeTitle: {
        NL: 'E-mailadres wijzigen',
        EN: 'Change email address'
    },
    login: {
        NL: 'Inloggen',
        EN: 'Log in'
    },
    mailConfirmEmailSubject: {
        NL: 'Bevestig je nieuwe e-mailadres',
        EN: 'Confirm your new email address'
    },
    mailConfirmEmailButton: {
        NL: 'E-mailadres bevestigen',
        EN: 'Confirm email address'
    },
    mailConfirmEmailIgnore: {
        NL: 'Heb je dit niet aangevraagd, negeer dan deze mail.',
        EN: 'If you did not request this, ignore this mail.'
    },
    mailEmailChangedSubject: {
        NL: 'Je e-mailadres is gewijzigd',
        EN: 'Your email address has been changed'
    },
    accountDetailsConfirmationSent: {
        NL: (email: string) => `We hebben een bevestigingsmail gestuurd naar ${email}. Je e-mailadres wijzigt pas als je op de link in die mail klikt.`,
        EN: (email: string) => `We have sent a confirmation mail to ${email}. Your email address only changes when you click the link in that mail.`
    },
    accountDetailsPendingEmail: {
        NL: (email: string) => `Wacht op bevestiging: ${email}`,
        EN: (email: string) => `Awaiting confirmation: ${email}`
    },
    emailChanged: {
        NL: (email: string) => `Je e-mailadres is gewijzigd. Log voortaan in met ${email}.`,
        EN: (email: string) => `Your email address has been changed. From now on, log in with ${email}.`
    },
    mailConfirmEmailIntro: {
        NL: (email: string) => `Klik op de knop om je e-mailadres te wijzigen naar ${email}. De link is 24 uur geldig.`,
        EN: (email: string) => `Click the button to change your email address to ${email}. The link is valid for 24 hours.`
    },
    mailEmailChangedIntro: {
        NL: (email: string) => `Je e-mailadres is gewijzigd naar ${email}. Heb je dit niet gedaan, neem dan contact op met je vervoerder.`,
        EN: (email: string) => `Your email address has been changed to ${email}. If you did not do this, contact your carrier.`
    },
    wrongCurrentPassword: {
        NL: 'Je huidige wachtwoord klopt niet.',
        EN: 'Your current password is not correct.'
    },
    menuNotifications: {
        NL: 'Meldingen',
        EN: 'Notifications'
    },
    menuSwitchAccount: {
        NL: 'Wissel account',
        EN: 'Switch account'
    },
    menuLogout: {
        NL: 'Uitloggen',
        EN: 'Log out'
    },
    resetPasswordIntro: {
        NL: 'Vul hieronder je nieuwe wachtwoord in.',
        EN: 'Enter your new password below.'
    },
    resetPasswordDone: {
        NL: 'Je wachtwoord is gewijzigd. Je kunt nu inloggen met je nieuwe wachtwoord.',
        EN: 'Your password has been changed. You can now log in with your new password.'
    },
    confirmButton: {
        NL: 'Bevestigen',
        EN: 'Confirm'
    },
    proofOfPickup: {
        NL: 'Ophaalbewijs',
        EN: 'Proof of pickup'
    },
    proofOfDelivery: {
        NL: 'Bezorgbewijs',
        EN: 'Proof of delivery'
    },
    proofOrder: {
        NL: 'Rit {order}',
        EN: 'Order {order}'
    },
    proofOverview: {
        NL: 'overzicht',
        EN: 'overview'
    },
    proofPickedUpAt: {
        NL: 'Opgehaald op',
        EN: 'Picked up on'
    },
    proofDeliveredAt: {
        NL: 'Bezorgd op',
        EN: 'Delivered on'
    },
    proofCompletedAt: {
        NL: 'Afgerond op',
        EN: 'Completed on'
    },
    proofLastUpdateAt: {
        NL: 'Laatste update op',
        EN: 'Last update on'
    },
    proofDateTime: {
        NL: '{date} om {time} uur',
        EN: '{date} at {time}'
    },
    proofColliPickedUp: {
        NL: '{count} van {total} colli opgehaald',
        EN: '{count} of {total} parcels picked up'
    },
    proofColliDelivered: {
        NL: '{count} van {total} colli bezorgd',
        EN: '{count} of {total} parcels delivered'
    },
    proofAddressesColli: {
        NL: '{addresses} adressen · {colli} colli',
        EN: '{addresses} addresses · {colli} parcels'
    },
    trackTrace: {
        NL: 'Track & Trace',
        EN: 'Track & Trace'
    },
    barcode: {
        NL: 'Barcode',
        EN: 'Barcode'
    },
    description: {
        NL: 'Omschrijving',
        EN: 'Description'
    },
    proofWeightAndDimensions: {
        NL: 'Gewicht en maten',
        EN: 'Weight and dimensions'
    },
    proofPhotos: {
        NL: 'Foto\'s',
        EN: 'Photos'
    },
    proofReceipt: {
        NL: 'Ontvangst',
        EN: 'Receipt'
    },
    addresses: {
        NL: 'Adressen',
        EN: 'Addresses'
    },
    time: {
        NL: 'Tijd',
        EN: 'Time'
    },
    page: {
        NL: 'Pagina',
        EN: 'Page'
    },
    proofPageXOfY: {
        NL: 'Pagina {page} van {pages}',
        EN: 'Page {page} of {pages}'
    },
    colloAtNeighbors: {
        NL: 'Bij buren',
        EN: 'At neighbours'
    },
    colloInMailbox: {
        NL: 'In brievenbus',
        EN: 'In mailbox'
    },
    proofNeighborNr: {
        NL: 'Huisnummer {nr}',
        EN: 'House number {nr}'
    },
    proofOverviewNote: {
        NL: 'Per adres volgt een ophaal- of bezorgbewijs op de genoemde pagina, met colli, foto\'s en handtekening.',
        EN: 'A proof of pickup or delivery for each address follows on the listed page, with parcels, photos and signature.'
    },
    webhookSecret: {
        NL: 'Webhook geheim',
        EN: 'Webhook secret'
    },
    webhookSecretInfo: {
        NL: 'Optioneel. Vul hier het geheim in dat bij de webhook in WooCommerce staat: Veloyd weigert dan webhooks die niet door jouw webshop ondertekend zijn. Laat leeg om elke webhook te accepteren.',
        EN: 'Optional. Enter the secret of the webhook in WooCommerce: Veloyd then refuses webhooks that are not signed by your webshop. Leave empty to accept every webhook.'
    },
    routeTemplateAddressOrderInfo: {
        NL: 'Bepaal hier de standaard volgorde van de adressen uit gekoppelde rit templates. Laat de adressen ontgrendeld wanneer je binnen de route alles nog wil kunnen optimaliseren. Of vergrendel de stopnummers wanneer deze niet van plek mogen wisselen.',
        EN: 'Set the default order of the addresses from connected order templates here. Leave the addresses unlocked when you still want to optimize everything within the route, or lock the stop numbers when they may not change places.'
    },
    connectedOrderTemplatesInfo: {
        NL: 'Rit templates kunnen worden gekoppeld aan deze route template. Bij elke instantie van de route in de dagplanning staan de gekoppelde ritten er dan al in. De stops uit de gekoppelde rit templates kun je op volgorde zetten door ze rechts op de goede positie te slepen.',
        EN: 'Order templates can be connected to this route template. Every instance of the route in the day planning then already contains the connected orders. You can order the stops from the connected order templates by dragging them to the right position on the right.'
    },
    lockAddressesOrder: {
        NL: 'Adressen op vaste volgorde zetten',
        EN: 'Put addresses in a fixed order'
    },
    lockAddressesOrderInfo: {
        NL: 'Staat deze instelling uit, dan worden adressen uit gekoppelde rit templates automatisch geoptimaliseerd. Staat deze instelling aan, dan kan je adressen op een vaste volgorde zetten. Bij routes in de dagplanning zullen de stopnummers van deze adressen dan vergrendeld zijn.',
        EN: 'When this setting is off, addresses from connected order templates are optimized automatically. When it is on, you can put the addresses in a fixed order. The stop numbers of these addresses are then locked in routes in the day planning.'
    },
    templateCreated: {
        NL: 'Template aangemaakt',
        EN: 'Template created'
    },
    templateUpdated: {
        NL: 'Template bijgewerkt',
        EN: 'Template updated'
    },
    editRouteTemplateFromDateInfo: {
        NL: 'Toekomstige routes in de dagplanning zullen worden overschreven. Dit process gebeurt op de achtergrond. Wijzigingen worden pas zichtbaar in de dagplanning wanneer het process is afgerond, dit kan even duren.\n\nToegevoegde adressen in deze routes blijven behouden, maar komen ongepland achteraan te staan.\nRoutes in de dagplanning die op Gereed staan zullen nooit worden gewijzigd.\n\nKies de datum vanaf wanneer deze wijziging van toepassing is.',
        EN: 'Future routes in the day planning will be overwritten. This happens in the background. Changes only become visible in the day planning once the process has finished, which can take a while.\n\nAddresses added to these routes are kept, but are placed unplanned at the end.\nRoutes in the day planning that are Ready will never be changed.\n\nChoose the date from which this change applies.'
    },
    fillInStartAndEndPoint: {
        NL: 'Vul een start- en eindlocatie in',
        EN: 'Fill in a start and end location'
    },
    ignoreDepotsInfo: {
        NL: 'Stops op het bedrijfsadres, een vestigingsadres of de start- of eindlocatie van een route worden genegeerd in de voorwaarden.',
        EN: 'Stops at the company address, a branch address or the start or end location of a route are ignored in the conditions.'
    },
    calculatedDuration: {
        NL: 'Berekende duur',
        EN: 'Calculated duration'
    },
    suggestedStartTimeTitle: {
        NL: ({time}: {time: string}) => `Geadviseerde starttijd ${time}`,
        EN: ({time}: {time: string}) => `Suggested start time ${time}`
    },
    suggestedStartTimeText: {
        NL: 'Met deze starttijd worden de tijdvakken zo goed mogelijk gehaald.',
        EN: 'With this start time the time slots are met as well as possible.'
    },
    ignore: {
        NL: 'Negeren',
        EN: 'Ignore'
    },
    adopt: {
        NL: 'Overnemen',
        EN: 'Adopt'
    },
    createPlanningNotPossible: {
        NL: 'Route berekening niet mogelijk',
        EN: 'Route calculation not possible'
    },
    createPlanningMultiStopOrders: {
        NL: 'Er zijn ritten geselecteerd die meerdere stops bevatten. De automatische verdeling werkt alleen voor ritten met maar één stop. Verwijder de ritten met meerdere stops uit de selectie en probeer het opnieuw.',
        EN: 'Orders with multiple stops are selected. Automatic distribution only works for orders with a single stop. Remove the orders with multiple stops from the selection and try again.'
    },
    createPlanningNoRouteFound: {
        NL: 'Geen mogelijke route gevonden.',
        EN: 'No possible route found.'
    },
    startShiftTitle: {
        NL: 'Dienst starten',
        EN: 'Start shift'
    },
    shiftStartConfirm: {
        NL: 'Je dienst wordt gestart. Weet je zeker dat je door wil gaan?',
        EN: 'Your shift will be started. Are you sure you want to continue?'
    },
    shiftEndConfirm: {
        NL: 'Je dienst wordt afgerond en kan niet meer worden vervolgd. Weet je zeker dat je door wil gaan?',
        EN: 'Your shift will be completed and cannot be continued. Are you sure you want to continue?'
    },
    shiftStartTooEarly: {
        NL: (time: string) => `Je kunt deze dienst nog niet starten. De dienst kan pas om ${time} worden gestart.`,
        EN: (time: string) => `You cannot start this shift yet. The shift can be started from ${time}.`
    },
    shiftStartOutsideRadiusNotAllowed: {
        NL: (radius: number) => `Je bevind je niet binnen ${radius} meter van de startlocatie, dienst kan niet worden gestart`,
        EN: (radius: number) => `You are not within ${radius} meters of the start location, the shift cannot be started`
    },
    shiftStartOutsideRadiusWarning: {
        NL: (radius: number) => `Je bevind je niet binnen ${radius} meter van de startlocatie`,
        EN: (radius: number) => `You are not within ${radius} meters of the start location`
    },
    shiftEndOutsideRadiusNotAllowed: {
        NL: (radius: number) => `Je bevind je niet binnen ${radius} meter van de eindlocatie, dienst kan niet worden afgerond.`,
        EN: (radius: number) => `You are not within ${radius} meters of the end location, the shift cannot be completed.`
    },
    shiftEndOutsideRadiusWarning: {
        NL: (radius: number) => `Je bevind je niet binnen ${radius} meter van de eindlocatie.`,
        EN: (radius: number) => `You are not within ${radius} meters of the end location.`
    },
    shiftStartNoActivities: {
        NL: 'Dienst kan niet worden gestart omdat er geen activiteiten zijn ingesteld.',
        EN: 'The shift cannot be started because no activities have been set up.'
    },
    stopsPerHourTarget: {
        NL: 'Stops per uur doel',
        EN: 'Stops per hour target'
    },
    shiftPauseFailed: {
        NL: 'Er is iets mis gegaan bij het pauzeren van de dienst. Probeer het opnieuw.',
        EN: 'Something went wrong while pausing the shift. Please try again.'
    },
    shiftResumeFailed: {
        NL: 'Er is iets mis gegaan bij het hervatten van de dienst. Probeer het opnieuw.',
        EN: 'Something went wrong while resuming the shift. Please try again.'
    },
    cancelRetour: {
        NL: 'Annuleer retour',
        EN: 'Cancel return'
    },
    cancelRetourConfirm: {
        NL: 'De retour wordt geannuleerd, wil je doorgaan?',
        EN: 'The return will be cancelled, do you want to continue?'
    },
    changeTimeslot: {
        NL: 'Tijdvak wijzigen',
        EN: 'Change timeslot'
    },
    timeslotChange: {
        NL: 'Tijdvak wijziging',
        EN: 'Timeslot change'
    },
    changeTimeslotOrdersText: {
        NL: 'Wijzig de starttijd en/of de eindtijd van alle adressen in de geselecteerde ritten.',
        EN: 'Change the start time and/or the end time of all addresses in the selected orders.'
    },
    changeTimeslotAddressesText: {
        NL: 'Wijzig de starttijd en/of de eindtijd van de geselecteerde adressen.',
        EN: 'Change the start time and/or the end time of the selected addresses.'
    },
    ordersSelectedCount: {
        NL: ({count}: {count: number}) => `${count} ritten geselecteerd`,
        EN: ({count}: {count: number}) => `${count} orders selected`
    },
    addressesSelectedCount: {
        NL: ({count}: {count: number}) => `${count} adressen geselecteerd`,
        EN: ({count}: {count: number}) => `${count} addresses selected`
    },
    addressesEdited: {
        NL: ({count}: {count: number}) => `${count} ${count === 1 ? 'adres' : 'adressen'} bewerkt.`,
        EN: ({count}: {count: number}) => `${count} ${count === 1 ? 'address' : 'addresses'} edited.`
    },
    addressEndTimeNotAfterStartTime: {
        NL: ({name}: {name: string}) => `${name}: eindtijd ligt niet na de starttijd`,
        EN: ({name}: {name: string}) => `${name}: end time is not after the start time`
    },
    nextStopETA: {
        NL: 'ETA bij volgende stop',
        EN: 'ETA at next stop'
    },
    etaDeviationDuration: {
        NL: (minutes: number) => minutes > 60 ? `${Math.floor(minutes / 60)} uur en ${minutes % 60} ${minutes % 60 === 1 ? 'minuut' : 'minuten'}` : `${minutes} ${minutes === 1 ? 'minuut' : 'minuten'}`,
        EN: (minutes: number) => minutes > 60 ? `${Math.floor(minutes / 60)} ${Math.floor(minutes / 60) === 1 ? 'hour' : 'hours'} and ${minutes % 60} ${minutes % 60 === 1 ? 'minute' : 'minutes'}` : `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`
    },
    sortBy: {
        NL: 'Sorteren op',
        EN: 'Sort by'
    },
    sortRouteName: {
        NL: 'Route naam',
        EN: 'Route name'
    },
    sortProgress: {
        NL: 'Voortgang',
        EN: 'Progress'
    },
    vehicleKind: {
        NL: 'Voertuigsoort',
        EN: 'Vehicle type'
    },
    calculatedEndTime: {
        NL: 'Berekende eindtijd',
        EN: 'Calculated end time'
    },
    timeCreated: {
        NL: 'Tijd aangemaakt',
        EN: 'Time created'
    },
    differenceStartTime: {
        NL: 'Afwijking starttijd',
        EN: 'Start time deviation'
    },
    nrOfCompleted: {
        NL: 'Aantal afgerond',
        EN: 'Number completed'
    },
    nrOfNotCompleted: {
        NL: 'Aantal niet afgerond',
        EN: 'Number not completed'
    },
    nrOfTooLate: {
        NL: 'Aantal te laat',
        EN: 'Number too late'
    },
    differenceDuration: {
        NL: 'Afwijking duur',
        EN: 'Duration deviation'
    },
    unlockAllStopNumbers: {
        NL: 'Ontgrendel alle stopnummers',
        EN: 'Unlock all stop numbers'
    },
    invalidPostalCodeRange: {
        NL: (part: string) => `Ongeldige postcode of reeks: ${part}`,
        EN: (part: string) => `Invalid postal code or range: ${part}`
    },
    deliveryZonesDrawInfoBefore: {
        NL: 'Klik op de knop',
        EN: 'Click the button'
    },
    deliveryZonesDrawInfoAfter: {
        NL: 'op de kaart om een nieuw bezorggebied te tekenen, Esc stopt het tekenen.',
        EN: 'on the map to draw a new delivery zone, Esc stops drawing.'
    },
    addPostalCodeZone: {
        NL: 'Postcodegebied toevoegen',
        EN: 'Add postal code zone'
    },
    postalCodes: {
        NL: 'Postcodes',
        EN: 'Postal codes'
    },
    postalCodeZoneFieldInfo: {
        NL: 'De postcodes van dit bezorggebied. Gebruik een komma om postcodes te scheiden en een streepje om een reeks te noteren. Postcodes kunnen mét of zónder letters gekozen worden. Bijvoorbeeld: 1000-2000, 3000, 4000AA-4000ZZ',
        EN: 'The postal codes of this delivery zone. Use a comma to separate postal codes and a dash for a range. Postal codes can be chosen with or without letters. For example: 1000-2000, 3000, 4000AA-4000ZZ'
    },
    deliveryZoneDefaultName: {
        NL: (number: number) => `Bezorggebied ${number}`,
        EN: (number: number) => `Delivery zone ${number}`
    },
    deliveryZoneImportedName: {
        NL: (number: number) => `Zone ${number}`,
        EN: (number: number) => `Zone ${number}`
    },
    deliveryZonesImportSkipped: {
        NL: (skipped: number) => `${skipped} ${skipped === 1 ? 'onderdeel is' : 'onderdelen zijn'} niet geïmporteerd, alleen vlakken kunnen een bezorggebied zijn`,
        EN: (skipped: number) => `${skipped} ${skipped === 1 ? 'item was' : 'items were'} not imported, only areas can be a delivery zone`
    },
    deliveryZonesImportFailed: {
        NL: 'Importeren mislukt. Geen geldige data',
        EN: 'Import failed. No valid data'
    },
    changeName: {
        NL: 'Wijzig naam',
        EN: 'Change name'
    },
    addressAlreadyExists: {
        NL: 'Adres bestaat al',
        EN: 'Address already exists'
    },
    addressAlreadyExistsInRouteText: {
        NL: 'Het adres dat je probeert toe te voegen bestaat al in deze route. De colli worden toegevoegd aan het bestaande adres.',
        EN: 'The address you are trying to add already exists in this route. The colli will be added to the existing address.'
    },
    scanBarcode: {
        NL: 'Barcode scannen',
        EN: 'Scan barcode'
    },
    finishScanning: {
        NL: 'Scannen afronden',
        EN: 'Finish scanning'
    },
    addAnotherAddress: {
        NL: 'Nog een adres toevoegen',
        EN: 'Add another address'
    },
    changeCustomerActiveShiftText: {
        NL: (shiftName: string) => `Je gaat de klant wijzigen terwijl je dienst ${shiftName} nog actief is. Wil je doorgaan?`,
        EN: (shiftName: string) => `You are about to change the customer while your shift ${shiftName} is still active. Do you want to continue?`
    }
}
